import { Autocomplete as e, Box as t, ButtonBase as n, Checkbox as r, Chip as i, Collapse as a, Container as o, Dialog as s, DialogActions as c, DialogContent as l, DialogContentText as u, DialogTitle as d, FormControlLabel as f, FormHelperText as p, Grid as m, InputAdornment as h, InputBase as g, LinearProgress as _, Link as v, MenuItem as y, Paper as ee, Radio as b, RadioGroup as x, Select as te, Stack as S, Step as ne, StepLabel as re, Stepper as ie, TableCell as ae, TablePagination as oe, TextField as se, Toolbar as ce, Tooltip as le, Typography as C, autocompleteClasses as ue, createTheme as de, inputBaseClasses as fe, inputLabelClasses as pe, outlinedInputClasses as me, stepIconClasses as he, styled as ge, useMediaQuery as _e, useTheme as ve } from "@mui/material";
import * as w from "react";
import T, { forwardRef as ye, memo as E, useCallback as be, useId as xe, useMemo as Se, useRef as Ce, useState as we } from "react";
import { Fragment as Te, jsx as D, jsxs as O } from "@emotion/react/jsx-runtime";
import { useToggle as Ee } from "react-use";
import { useBlocker as De } from "react-router";
import { Email as Oe, PASSKEY_AUTHENTICATION_TYPE as ke, ReadUser as Ae, customErrorMap as je, denwaNumberShubetsu as Me, formatDate as Ne, formatInvoiceDelivery as Pe, formatPaymentMethod as Fe, isIpRestricted as Ie, isLocalIp as Le, isMfaExempted as Re, orHyphen as ze } from "esa-core";
import Be from "@mui/material/AppBar";
import { grey as Ve } from "@mui/material/colors";
//#region lib/components/Atoms/EsaTextField.tsx
var He = ye((e, t) => /* @__PURE__ */ D(se, {
	variant: "standard",
	fullWidth: !0,
	ref: t,
	...e
})), k = function() {
	return k = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, k.apply(this, arguments);
};
function Ue(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
//#endregion
//#region ../../../node_modules/.pnpm/@e-seikatsu+design-system@10.0.0_@mui+material@9.5.0_@emotion+react@11.14.0_@types+reac_a3f44f16f860030a3d2f287fe1d407fb/node_modules/@e-seikatsu/design-system/dist/_chunks/style-inject.es-746bb8ed.js
function We(e, t) {
	t === void 0 && (t = {});
	var n = t.insertAt;
	if (e && typeof document < "u") {
		var r = document.head || document.getElementsByTagName("head")[0], i = document.createElement("style");
		i.type = "text/css", n === "top" && r.firstChild ? r.insertBefore(i, r.firstChild) : r.appendChild(i), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e));
	}
}
var Ge = w.memo(function(e) {
	return w.createElement("svg", k({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24"
	}, e), w.createElement("path", {
		fill: "none",
		d: "M0 0h24v24H0z"
	}), w.createElement("path", { d: "M1 11v10h6v-5h2v5h6V11L8 6zm12 8h-2v-5H5v5H3v-6.97l5-3.57 5 3.57zM17 7h2v2h-2zM17 11h2v2h-2zM17 15h2v2h-2z" }), w.createElement("path", { d: "M10 3v1.97l2 1.43V5h9v14h-4v2h6V3z" }));
}), Ke = ".Icon-module_eds-icon--small__OT8XM{height:18px;width:18px}.Icon-module_eds-icon--medium__8tsLA{height:20px;width:20px}.Icon-module_eds-icon--large__U0lkm{height:24px;width:24px}.Icon-module_eds-icon--custom-40__iRHrm{height:40px;width:40px}.Icon-module_eds-icon--custom-48__J7-45{height:48px;width:48px}.Icon-module_eds-icon--custom-56__ECZ4P{height:56px;width:56px}.Icon-module_eds-icon--custom-64__I7tp3{height:64px;width:64px}.Icon-module_eds-icon--primary__6d84l{fill:var(--color-semantic-icon-primary)}.Icon-module_eds-icon--secondary__BG8NY{fill:var(--color-semantic-icon-secondary)}.Icon-module_eds-icon--error__fxR9y{fill:var(--color-semantic-icon-error)}.Icon-module_eds-icon--warning__5ZcUP{fill:var(--color-semantic-icon-warning)}.Icon-module_eds-icon--info__yt1dI{fill:var(--color-semantic-icon-info)}.Icon-module_eds-icon--success__BrBws{fill:var(--color-semantic-icon-success)}.Icon-module_eds-icon--black__IyXDb{fill:var(--color-semantic-icon-black)}.Icon-module_eds-icon--grey__pFnH5{fill:var(--color-semantic-icon-grey)}.Icon-module_eds-icon--white__NKsM4{fill:var(--color-semantic-icon-white)}.Icon-module_eds-icon--disabled__gvLqw{fill:var(--color-semantic-icon-disabled)}", qe = {
	"eds-icon--small": "Icon-module_eds-icon--small__OT8XM",
	"eds-icon--medium": "Icon-module_eds-icon--medium__8tsLA",
	"eds-icon--large": "Icon-module_eds-icon--large__U0lkm",
	"eds-icon--custom-40": "Icon-module_eds-icon--custom-40__iRHrm",
	"eds-icon--custom-48": "Icon-module_eds-icon--custom-48__J7-45",
	"eds-icon--custom-56": "Icon-module_eds-icon--custom-56__ECZ4P",
	"eds-icon--custom-64": "Icon-module_eds-icon--custom-64__I7tp3",
	"eds-icon--primary": "Icon-module_eds-icon--primary__6d84l",
	"eds-icon--secondary": "Icon-module_eds-icon--secondary__BG8NY",
	"eds-icon--error": "Icon-module_eds-icon--error__fxR9y",
	"eds-icon--warning": "Icon-module_eds-icon--warning__5ZcUP",
	"eds-icon--info": "Icon-module_eds-icon--info__yt1dI",
	"eds-icon--success": "Icon-module_eds-icon--success__BrBws",
	"eds-icon--black": "Icon-module_eds-icon--black__IyXDb",
	"eds-icon--grey": "Icon-module_eds-icon--grey__pFnH5",
	"eds-icon--white": "Icon-module_eds-icon--white__NKsM4",
	"eds-icon--disabled": "Icon-module_eds-icon--disabled__gvLqw"
};
We(Ke);
var Je = {
	account: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 -960 960 960"
		}, e), w.createElement("path", { d: "M234-276q51-39 114-61.5T480-360t132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800t-226.5 93.5T160-480q0 59 19.5 111t54.5 93m246-164q-59 0-99.5-40.5T340-580t40.5-99.5T480-720t99.5 40.5T620-580t-40.5 99.5T480-440m0 360q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q53 0 100-15.5t86-44.5q-39-29-86-44.5T480-280t-100 15.5-86 44.5q39 29 86 44.5T480-160m0-360q26 0 43-17t17-43-17-43-43-17-43 17-17 43 17 43 43 17m0 300" }));
	}),
	accountClock: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "M16 14h1.5v2.82l2.44 1.41-.75 1.3L16 17.69zm1-2a5 5 0 0 0-5 5 5 5 0 0 0 5 5 5 5 0 0 0 5-5 5 5 0 0 0-5-5m0-2a7 7 0 0 1 7 7 7 7 0 0 1-7 7c-2.79 0-5.2-1.64-6.33-4H1v-3c0-2.66 5.33-4 8-4 .6 0 1.34.07 2.12.2A6.99 6.99 0 0 1 17 10m-7 7c0-.7.1-1.38.29-2-.42-.07-.86-.1-1.29-.1-2.97 0-6.1 1.46-6.1 2.1v1.1h7.19A7 7 0 0 1 10 17M9 4a4 4 0 0 1 4 4 4 4 0 0 1-4 4 4 4 0 0 1-4-4 4 4 0 0 1 4-4m0 1.9A2.1 2.1 0 0 0 6.9 8 2.1 2.1 0 0 0 9 10.1 2.1 2.1 0 0 0 11.1 8 2.1 2.1 0 0 0 9 5.9" }));
	}),
	accountClockFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "M10.63 14.1a7 7 0 0 1 9.27-3.47 7 7 0 0 1 3.47 9.27A6.98 6.98 0 0 1 17 24c-2.7 0-5.17-1.56-6.33-4H1v-2c.06-1.14.84-2.07 2.34-2.82S6.72 14.04 9 14c.57 0 1.11.05 1.63.1M9 4c1.12.03 2.06.42 2.81 1.17S12.93 6.86 12.93 8s-.37 2.08-1.12 2.83-1.69 1.12-2.81 1.12-2.06-.37-2.81-1.12S5.07 9.14 5.07 8s.37-2.08 1.12-2.83S7.88 4.03 9 4m8 18a5 5 0 0 0 5-5 5 5 0 0 0-5-5 5 5 0 0 0-5 5 5 5 0 0 0 5 5m-1-8h1.5v2.82l2.44 1.41-.75 1.3L16 17.69z" }));
	}),
	add: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z" }));
	}),
	addCircle: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8" }));
	}),
	apps: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M4 8h4V4H4zm6 12h4v-4h-4zm-6 0h4v-4H4zm0-6h4v-4H4zm6 0h4v-4h-4zm6-10v4h4V4zm-6 4h4V4h-4zm6 6h4v-4h-4zm0 6h4v-4h-4z" }));
	}),
	arrowBack: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z" }));
	}),
	arrowDownward: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z" }));
	}),
	arrowDownLeft: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M15 19v-2H8.41L20 5.41 18.59 4 7 15.59V9H5v10z" }));
	}),
	arrowDownRight: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19 9h-2v6.59L5.41 4 4 5.41 15.59 17H9v2h10z" }));
	}),
	arrowForward: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" }));
	}),
	arrowUpward: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z" }));
	}),
	arrowUpLeft: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M5 15h2V8.41L18.59 20 20 18.59 8.41 7H15V5H5z" }));
	}),
	arrowUpRight: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z" }));
	}),
	attachFile: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6z" }));
	}),
	autoAwesome: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25zM11.5 9.5 9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12zm-1.51 3.49L9 15.17l-.99-2.18L5.83 12l2.18-.99L9 8.83l.99 2.18 2.18.99z" }));
	}),
	autoAwesomeFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25z" }));
	}),
	autoFixHigh: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m20 7 .94-2.06L23 4l-2.06-.94L20 1l-.94 2.06L17 4l2.06.94zM8.5 7l.94-2.06L11.5 4l-2.06-.94L8.5 1l-.94 2.06L5.5 4l2.06.94zM20 12.5l-.94 2.06-2.06.94 2.06.94.94 2.06.94-2.06L23 15.5l-2.06-.94zM17.71 9.12l-2.83-2.83c-.2-.19-.45-.29-.71-.29s-.51.1-.71.29L2.29 17.46a.996.996 0 0 0 0 1.41l2.83 2.83c.2.2.45.3.71.3s.51-.1.71-.29l11.17-11.17c.39-.39.39-1.03 0-1.42m-3.54-.7 1.41 1.41L14.41 11 13 9.59zM5.83 19.59l-1.41-1.41L11.59 11 13 12.41z" }));
	}),
	barChart: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M4 9h4v11H4zM16 13h4v7h-4zM10 4h4v16h-4z" }));
	}),
	blurOn: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5M6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1m0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5m-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5m7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5m0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5M10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1m0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5m8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5M14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5m-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5m0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5m0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5" }));
	}),
	bookmark: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2m0 15-5-2.18L7 18V5h10z" }));
	}),
	bookmarkFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2" }));
	}),
	business: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 7V3H2v18h20V7zM6 19H4v-2h2zm0-4H4v-2h2zm0-4H4V9h2zm0-4H4V5h2zm4 12H8v-2h2zm0-4H8v-2h2zm0-4H8V9h2zm0-4H8V5h2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8zm-2-8h-2v2h2zm0 4h-2v2h2z" }));
	}),
	calculator: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v4h10V4zm0 6v2h2v-2zm4 0v2h2v-2zm4 0v2h2v-2zm-8 4v2h2v-2zm4 0v2h2v-2zm4 0v2h2v-2zm-8 4v2h2v-2zm4 0v2h2v-2zm4 0v2h2v-2z" }));
	}),
	calendar: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 -960 960 960"
		}, e), w.createElement("path", { d: "M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80zm0-80h560v-400H200zm0-480h560v-80H200zm0 0v-80z" }));
	}),
	calendarClockFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "M15 13h1.5v2.82l2.44 1.41-.75 1.3L15 16.69zm4-5H5v11h4.67c-.43-.91-.67-1.93-.67-3a7 7 0 0 1 7-7c1.07 0 2.09.24 3 .67zM5 21a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 0 1 2 2v6.1c1.24 1.26 2 2.99 2 4.9a7 7 0 0 1-7 7c-1.91 0-3.64-.76-4.9-2zm11-9.85A4.85 4.85 0 0 0 11.15 16c0 2.68 2.17 4.85 4.85 4.85A4.85 4.85 0 0 0 20.85 16c0-2.68-2.17-4.85-4.85-4.85" }));
	}),
	cancel: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z",
			opacity: .87
		}), w.createElement("path", { d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z" }));
	}),
	cancelFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z" }));
	}),
	chat: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "M20 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2zM4 4v13.17L5.17 16H20V4zm2 3h12v2H6zm0 4h9v2H6z" }));
	}),
	chatBubble: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H6l-2 2V4h16z" }));
	}),
	chatSms: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.17L4 17.17V4h16zM7 9h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2z" }));
	}),
	checkCircle: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z" }));
	}),
	checkList: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M22 7h-9v2h9zm0 8h-9v2h9zM5.54 11 2 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41zm0 8L2 15.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41z" }));
	}),
	chevronLeft: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" }));
	}),
	chevronRight: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" }));
	}),
	clock: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8" }), w.createElement("path", { d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" }));
	}),
	close: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }));
	}),
	cloud: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0 1 22 15c0 1.65-1.35 3-3 3H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.47 5.47 0 0 1 12 6m0-2C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96A7.49 7.49 0 0 0 12 4" }));
	}),
	cloudDownloadFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M17 13l-5 5-5-5h3V9h4v4z" }));
	}),
	cloudUploadFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M14 13v4h-4v-4H7l5-5 5 5z" }));
	}),
	contentCopy: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z" }));
	}),
	contractEdit: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M9 9V7h9v2zm0 3v-2h9v2zm3 10H6a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 3 19v-3h3V2h15v9.025a3.783 3.783 0 0 0-2 .35V4H8v12h6l-2 2H5v1q0 .424.287.712Q5.576 20 6 20h6zm2 0v-3.075l5.525-5.5q.225-.225.5-.325a1.6 1.6 0 0 1 .55-.1 1.5 1.5 0 0 1 1.075.45l.925.925q.2.225.313.5.111.275.112.55 0 .274-.1.563a1.34 1.34 0 0 1-.325.512l-5.5 5.5zm1.5-1.5h.95l3.025-3.05-.45-.475-.475-.45-3.05 3.025zm3.525-3.525-.475-.45.925.925z" }));
	}),
	crop: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M17 15h2V7c0-1.1-.9-2-2-2H9v2h8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2z" }));
	}),
	crown: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "m12 8 3 5.2 3-2.7-.7 3.5H6.7L6 10.5l3 2.7zm0-4-3.5 6L3 5l2 11h14l2-11-5.5 5zm7 14H5v1c0 .6.4 1 1 1h12c.6 0 1-.4 1-1z" }));
	}),
	databaseExport: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "m17.86 18 1.04 1c-1.4 1.2-3.96 2-6.9 2-4.41 0-8-1.79-8-4V7c0-2.21 3.58-4 8-4 2.95 0 5.5.8 6.9 2l-1.04 1-.36.4C16.65 5.77 14.78 5 12 5 8.13 5 6 6.5 6 7s2.13 2 6 2c1.37 0 2.5-.19 3.42-.46l.96.96H13.5v1.42c-.5.05-1 .08-1.5.08-2.39 0-4.53-.53-6-1.36v2.81C7.3 13.4 9.58 14 12 14c.5 0 1-.03 1.5-.08v.58h2.88l-1 1 .12.11c-1.09.25-2.26.39-3.5.39-2.28 0-4.39-.45-6-1.23V17c0 .5 2.13 2 6 2 2.78 0 4.65-.77 5.5-1.39zm1.06-10.92L17.5 8.5 20 11h-5v2h5l-2.5 2.5 1.42 1.42L23.84 12z" }));
	}),
	databaseImport: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "m8.84 12-4.92 4.92L2.5 15.5 5 13H0v-2h5L2.5 8.5l1.42-1.42zM12 3C8.59 3 5.68 4.07 4.53 5.57L5 6l1.03 1.07C6 7.05 6 7 6 7c0-.5 2.13-2 6-2s6 1.5 6 2-2.13 2-6 2c-2.62 0-4.42-.69-5.32-1.28l3.12 3.12c.7.1 1.44.16 2.2.16 2.39 0 4.53-.53 6-1.36v2.81c-1.3.95-3.58 1.55-6 1.55-.96 0-1.9-.1-2.76-.27l-1.65 1.64c1.32.4 2.82.63 4.41.63 2.28 0 4.39-.45 6-1.23V17c0 .5-2.13 2-6 2s-6-1.5-6-2v-.04L5 18l-.46.43C5.69 19.93 8.6 21 12 21c4.41 0 8-1.79 8-4V7c0-2.21-3.58-4-8-4" }));
	}),
	delete: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 -960 960 960"
		}, e), w.createElement("path", { d: "M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120zm400-600H280v520h400zM360-280h80v-360h-80zm160 0h80v-360h-80zM280-720v520z" }));
	}),
	description: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5z" }));
	}),
	descriptionFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			fill: "#1f1f1f",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm2 16H8v-2h8zm0-4H8v-2h8zm-3-5V3.5L18.5 9z" }));
	}),
	desktop: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H3V4h18z" }));
	}),
	devices: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1m-1 9h-4v-7h4z" }));
	}),
	done: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" }));
	}),
	doNotDisturb: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.9 7.9 0 0 1 12 20m6.31-3.1L7.1 5.69A7.9 7.9 0 0 1 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9" }));
	}),
	door: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M18 4v16H6V4zm0-2H6c-1.1 0-2 .9-2 2v18h16V4c0-1.1-.9-2-2-2m-2.5 8.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S17 12.83 17 12s-.67-1.5-1.5-1.5" }));
	}),
	dragPan: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 -960 960 960"
		}, e), w.createElement("path", { d: "M480-80 310-250l57-57 73 73v-206l-205-1 73 73-58 58L80-480l169-169 57 57-72 72h206v-206l-73 73-57-57 170-170 170 170-57 57-73-73v206l205 1-73-73 58-58 170 170-170 170-57-57 73-73H520l-1 205 73-73 58 58z" }));
	}),
	edit: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m14.06 9.02.92.92L5.92 19H5v-.92zM17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 0 0 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94z" }));
	}),
	email: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0-8 5-8-5zm0 12H4V8l8 5 8-5z" }));
	}),
	emailMultiple: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "M2 6v14h18v2H2c-1.105 0-2-.89-2-2V6zm22-2c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0-8 5-8-5zm0 12H6V6l8 5 8-5z" }));
	}),
	error: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8" }));
	}),
	errorFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z" }));
	}),
	expandLess: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" }));
	}),
	expandMore: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M24 24H0V0h24z",
			opacity: .87
		}), w.createElement("path", { d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" }));
	}),
	favorite: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3m-4.4 15.55-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05" }));
	}),
	favoriteFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z" }));
	}),
	fax: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19 9h-1V4H8v5h-.78C6.67 8.39 5.89 8 5 8c-1.66 0-3 1.34-3 3v7c0 1.66 1.34 3 3 3 .89 0 1.67-.39 2.22-1H22v-8c0-1.66-1.34-3-3-3M6 18c0 .55-.45 1-1 1s-1-.45-1-1v-7c0-.55.45-1 1-1s1 .45 1 1zm4-12h6v3h-6zm10 12H8v-7h11c.55 0 1 .45 1 1z" }), w.createElement("circle", {
			cx: 15,
			cy: 13,
			r: 1
		}), w.createElement("circle", {
			cx: 18,
			cy: 13,
			r: 1
		}), w.createElement("circle", {
			cx: 15,
			cy: 16,
			r: 1
		}), w.createElement("circle", {
			cx: 18,
			cy: 16,
			r: 1
		}), w.createElement("path", { d: "M9 12h4v5H9z" }));
	}),
	feather: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "M22 2s-7.64-.37-13.66 7.88C3.72 16.21 2 22 2 22l1.94-1c1.44-2.5 2.19-3.53 3.6-5 2.53.74 5.17.65 7.46-2-2-.56-3.6-.43-5.96-.19C11.69 12 13.5 11.6 16 12l1-2c-1.8-.34-3-.37-4.78.04C14.19 8.65 15.56 7.87 18 8l1.21-1.93c-1.56-.11-2.5.06-4.29.5 1.61-1.46 3.08-2.12 5.22-2.25 0 0 1.05-1.89 1.86-2.32" }));
	}),
	flag: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m12.36 6 .4 2H18v6h-3.36l-.4-2H7V6zM14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6z" }));
	}),
	folder: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m9.17 6 2 2H20v10H4V6zM10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8z" }));
	}),
	formatBold: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42M10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5" }));
	}),
	formatColor: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M16.56 8.94 7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 0 0 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12M5.21 10 10 5.21 14.79 10zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5M2 20h20v4H2z" }));
	}),
	formatSize: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M9 4v3h5v12h3V7h5V4zm-6 8h3v7h3v-7h3V9H3z" }));
	}),
	formatUnderlined: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6m-7 2v2h14v-2z" }));
	}),
	file: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zM6 20V4h7v5h5v11z" }));
	}),
	fileDownload: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3zm-1-4-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5z" }));
	}),
	filterFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24m0 24H0"
		}), w.createElement("path", { d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A.998.998 0 0 0 18.95 4H5.04c-.83 0-1.3.95-.79 1.61" }), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}));
	}),
	fileUpload: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3zM7 9l1.41 1.41L11 7.83V16h2V7.83l2.59 2.58L17 9l-5-5z" }));
	}),
	findInPage: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zM6 4h7l5 5v8.58l-1.84-1.84a4.99 4.99 0 0 0-.64-6.28A4.96 4.96 0 0 0 12 8a5 5 0 0 0-3.53 1.46 4.98 4.98 0 0 0 0 7.05 4.98 4.98 0 0 0 6.28.63L17.6 20H6zm8.11 11.1c-.56.56-1.31.88-2.11.88s-1.55-.31-2.11-.88c-.56-.56-.88-1.31-.88-2.11s.31-1.55.88-2.11c.56-.57 1.31-.88 2.11-.88s1.55.31 2.11.88c.56.56.88 1.31.88 2.11s-.31 1.55-.88 2.11" }));
	}),
	groups: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58A2.01 2.01 0 0 0 0 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29M20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m4 3.43c0-.81-.48-1.53-1.22-1.85A6.95 6.95 0 0 0 20 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24zm-7.76-2.78c-1.17-.52-2.61-.9-4.24-.9s-3.07.39-4.24.9A2.99 2.99 0 0 0 6 16.39V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74M8.07 16c.09-.23.13-.39.91-.69.97-.38 1.99-.56 3.02-.56s2.05.18 3.02.56c.77.3.81.46.91.69zM12 8c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m0-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3" }));
	}),
	height: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 -960 960 960"
		}, e), w.createElement("path", { d: "M480-120 320-280l56-56 64 63v-414l-64 63-56-56 160-160 160 160-56 57-64-64v414l64-63 56 56z" }));
	}),
	help: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M11 18h2v-2h-2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4" }));
	}),
	helpFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 17h-2v-2h2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25" }));
	}),
	history: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.95 8.95 0 0 0 13 21a9 9 0 0 0 0-18m-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z" }));
	}),
	home: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m12 5.69 5 4.5V18h-2v-6H9v6H7v-7.81zM12 3 2 12h3v8h6v-6h2v6h6v-8h3z" }));
	}),
	homeCheck: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "m23.958 13.484-8.71 8.712-.27-.268-4.765-4.765 1.662-1.661 3.371 3.371 6.969-6.967.1-.1zm-7.45-7.435v8.418l-1.234 1.208-1.086-1.085V7.244l-5.8-4.14-5.798 4.14v8.083h2.32V9.528h6.958v2.775l-2.32 2.323v-2.778H7.23v5.8H.27v-11.6L8.39.25z" }));
	}),
	homeSearch: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "M16.435 11.46a5.04 5.04 0 0 1 5.038 5.04c0 1.073-.339 2.073-.917 2.894h.35l.104.103 2.794 2.8-1.576 1.567-2.796-2.789-.103-.103v-.352c-.82.578-1.82.918-2.894.918a5.04 5.04 0 0 1 0-10.077m0 2.146a2.89 2.89 0 0 0-2.893 2.894 2.89 2.89 0 0 0 2.893 2.894A2.89 2.89 0 0 0 19.33 16.5a2.89 2.89 0 0 0-2.894-2.894m.072-7.557v3.144l-.126-.003a7.3 7.3 0 0 0-2.194.341V7.243l-5.799-4.14-5.799 4.14v8.084h2.32V9.528h6.959v1.245a7.3 7.3 0 0 0-2.32 3.23v-2.155H7.23v5.798H.27V6.05L8.388.25z" }));
	}),
	homeWork: Ge,
	hourglassBottom: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m18 22-.01-6L14 12l3.99-4.01L18 2H6v6l4 4-4 3.99V22zM8 7.5V4h8v3.5l-4 4z" }));
	}),
	image: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19 5v14H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-4.86 8.86-3 3.87L9 13.14 6 17h12z" }));
	}),
	imageFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			fill: "#1f1f1f",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z" }));
	}),
	imageLibrary: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 28 28"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h28v28H0z"
		}), w.createElement("path", { d: "M10.499 16.336h11.666l-4.025-5.25-2.683 3.5-1.808-2.333zm-1.167 4.667a2.25 2.25 0 0 1-1.648-.686A2.25 2.25 0 0 1 7 18.67v-14q0-.961.685-1.648a2.25 2.25 0 0 1 1.648-.685h14q.963 0 1.648.685.685.686.685 1.648v14q0 .963-.685 1.648a2.25 2.25 0 0 1-1.648.686zm0-2.334h14v-14h-14zm-4.667 7a2.25 2.25 0 0 1-1.648-.685 2.25 2.25 0 0 1-.685-1.648V7.003h2.333v16.333H21v2.333z" }));
	}),
	imageSizeSelectLarge: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 28 28"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h28v28H0z"
		}), w.createElement("path", { d: "M5.833 24.5a2.25 2.25 0 0 1-1.648-.685 2.25 2.25 0 0 1-.685-1.648v-14h16.333V24.5zm0-3.5H17.5l-3.967-5.25-3.033 4.083-1.867-2.508zm0-15.167H3.5q0-.961.685-1.648A2.25 2.25 0 0 1 5.833 3.5zm2.334 0V3.5H10.5v2.333zm4.666 0V3.5h2.334v2.333zm4.667 0V3.5h2.333v2.333zm4.667 0V3.5q.961 0 1.648.685.684.686.685 1.648zm0 16.334H24.5q0 .961-.685 1.648a2.25 2.25 0 0 1-1.648.685zm0-2.334V17.5H24.5v2.333zm0-4.666v-2.334H24.5v2.334zm0-4.667V8.167H24.5V10.5z" }));
	}),
	info: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8" }));
	}),
	infoFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z" }));
	}),
	key: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M22 19h-6v-4h-2.68c-1.14 2.42-3.6 4-6.32 4-3.86 0-7-3.14-7-7s3.14-7 7-7c2.72 0 5.17 1.58 6.32 4H24v6h-2zm-4-2h2v-4h2v-2H11.94l-.23-.67C11.01 8.34 9.11 7 7 7c-2.76 0-5 2.24-5 5s2.24 5 5 5c2.11 0 4.01-1.34 4.71-3.33l.23-.67H18zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1" }));
	}),
	keyboardArrowDown: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M18 6.41 16.59 5 12 9.58 7.41 5 6 6.41l6 6z" }), w.createElement("path", { d: "m18 13-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z" }));
	}),
	keyboardArrowUp: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M6 17.59 7.41 19 12 14.42 16.59 19 18 17.59l-6-6z" }), w.createElement("path", { d: "m6 11 1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z" }));
	}),
	laptop: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2zM4 6h16v10H4z" }));
	}),
	link: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5m-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4zm-3-4h8v2H8z" }));
	}),
	locationOn: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7M7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9" }), w.createElement("circle", {
			cx: 12,
			cy: 9,
			r: 2.5
		}));
	}),
	locationOnFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5" }));
	}),
	lock: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("g", { fill: "none" }, w.createElement("path", { d: "M0 0h24v24H0z" }), w.createElement("path", {
			d: "M0 0h24v24H0z",
			opacity: .87
		})), w.createElement("path", { d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9zm9 14H6V10h12zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2" }));
	}),
	lockOpen: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m0 12H6V10h12zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2" }));
	}),
	login: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M11 7 9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8z" }));
	}),
	logout: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m17 8-1.41 1.41L17.17 11H9v2h8.17l-1.58 1.58L17 16l4-4zM5 5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5z" }));
	}),
	loop: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8m0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4z" }));
	}),
	map: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m20.5 3-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5M10 5.47l4 1.4v11.66l-4-1.4zm-5 .99 3-1.01v11.7l-3 1.16zm14 11.08-3 1.01V6.86l3-1.16z" }));
	}),
	maximize: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m15 3 2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z" }));
	}),
	menu: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z" }));
	}),
	minimize: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M9 9V3H7v2.59L3.91 2.5 2.5 3.91 5.59 7H3v2zm12 0V7h-2.59l3.09-3.09-1.41-1.41L17 5.59V3h-2v6zM3 15v2h2.59L2.5 20.09l1.41 1.41L7 18.41V21h2v-6zm12 0v6h2v-2.59l3.09 3.09 1.41-1.41L18.41 17H21v-2z" }));
	}),
	moreHoriz: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2" }));
	}),
	moreVert: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2" }));
	}),
	myLocation: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7" }));
	}),
	notifications: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2m6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5z" }));
	}),
	openInNew: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z" }));
	}),
	pdfFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-9.5 8.5c0 .8-.7 1.5-1.5 1.5H7v2H5.5V9H8c.8 0 1.5.7 1.5 1.5zm5 2c0 .8-.7 1.5-1.5 1.5h-2.5V9H13c.8 0 1.5.7 1.5 1.5zm4-3H17v1h1.5V13H17v2h-1.5V9h3zm-6.5 0h1v3h-1zm-5 0h1v1H7z" }));
	}),
	people: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5M4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12m0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7m7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44M15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35" }));
	}),
	person: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4" }));
	}),
	personAdd: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4m-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2zm-3-3v-3h3v-2H6V7H4v3H1v2h3v3z" }));
	}),
	personFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4" }));
	}),
	phone: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79zm9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75zM7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57a.8.8 0 0 0-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.15 15.15 0 0 1-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.4 11.4 0 0 1 8.5 4c0-.55-.45-1-1-1" }));
	}),
	phoneFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02z" }));
	}),
	portrait: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3m0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m6 8.58c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12zM8.48 16c.74-.51 2.23-1 3.52-1s2.78.49 3.52 1zM19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14z" }));
	}),
	print: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3M8 5h8v3H8zm8 12v2H8v-4h8zm2-2v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4z" }), w.createElement("circle", {
			cx: 18,
			cy: 11.5,
			r: 1
		}));
	}),
	public: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M4 12c0-.61.08-1.21.21-1.78L8.99 15v1c0 1.1.9 2 2 2v1.93C7.06 19.43 4 16.07 4 12m13.89 5.4c-.26-.81-1-1.4-1.9-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41C17.92 5.77 20 8.65 20 12c0 2.08-.81 3.98-2.11 5.4" }));
	}),
	publish: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 -960 960 960"
		}, e), w.createElement("path", { d: "M440-160v-326L336-382l-56-58 200-200 200 200-56 58-104-104v326zM160-600v-120q0-33 23.5-56.5T240-800h480q33 0 56.5 23.5T800-720v120h-80v-120H240v120z" }));
	}),
	pushPin: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M14 4v5c0 1.12.37 2.16 1 3H9c.65-.86 1-1.9 1-3V4zm3-2H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3V4h1c.55 0 1-.45 1-1s-.45-1-1-1" }));
	}),
	queryStats: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19.88 18.47c.44-.7.7-1.51.7-2.39 0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21.58 23 23 21.58zm-3.8.11a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5m-.36-8.5c-.74.02-1.45.18-2.1.45l-.55-.83-3.8 6.18-3.01-3.52-3.63 5.81L1 17l5-8 3 3.5L13 6zm2.59.5c-.64-.28-1.33-.45-2.05-.49L21.38 2 23 3.18z" }));
	}),
	redo: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16a8 8 0 0 1 7.6-5.5c1.95 0 3.73.72 5.12 1.88L13 16h9V7z" }));
	}),
	refresh: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M17.65 6.35A7.96 7.96 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z" }));
	}),
	remove: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19 13H5v-2h14z" }));
	}),
	reply: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11" }));
	}),
	replyAll: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M7 8V5l-7 7 7 7v-3l-4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11" }));
	}),
	robot: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3m-2 10H6V7h12zm-9-6c-.83 0-1.5-.67-1.5-1.5S8.17 10 9 10s1.5.67 1.5 1.5S9.83 13 9 13m7.5-1.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5M8 15h8v2H8z" }));
	}),
	rotateLeft: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M7.11 8.53 5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47M6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47m1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93" }));
	}),
	rotateRight: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M15.55 5.55 11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10zM19.93 11a7.9 7.9 0 0 0-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03m3.89-2.42 1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48" }));
	}),
	save: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V7zm2 16H5V5h11.17L19 7.83zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3M6 6h9v4H6z" }));
	}),
	search: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14" }));
	}),
	sendFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2z" }));
	}),
	sentimentDissatisfied: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("circle", {
			cx: 15.5,
			cy: 9.5,
			r: 1.5
		}), w.createElement("circle", {
			cx: 8.5,
			cy: 9.5,
			r: 1.5
		}), w.createElement("path", { d: "M12 14c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5m-.01-12C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8" }));
	}),
	sentimentSatisfied: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("circle", {
			cx: 15.5,
			cy: 9.5,
			r: 1.5
		}), w.createElement("circle", {
			cx: 8.5,
			cy: 9.5,
			r: 1.5
		}), w.createElement("path", { d: "M12 16c-1.48 0-2.75-.81-3.45-2H6.88a5.495 5.495 0 0 0 10.24 0h-1.67c-.7 1.19-1.97 2-3.45 2m-.01-14C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8" }));
	}),
	settings: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46a.5.5 0 0 0-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.49.49 0 0 0 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1a.6.6 0 0 0-.18-.03c-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46a.5.5 0 0 0 .61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1q.09.03.18.03c.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64zm-1.98-1.71c.04.31.05.52.05.73s-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2" }));
	}),
	share: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92M18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1M6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1" }));
	}),
	smartphone: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M17 1.01 7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99M17 19H7V5h10z" }));
	}),
	star: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28z" }));
	}),
	starFill: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("g", { fill: "none" }, w.createElement("path", { d: "M0 0h24v24H0z" }), w.createElement("path", { d: "M0 0h24v24H0z" })), w.createElement("path", { d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" }));
	}),
	stickyNote: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19 5v9h-5v5H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10l6-6V5c0-1.1-.9-2-2-2m-7 11H7v-2h5zm5-4H7V8h10z" }));
	}),
	store: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "m18.36 9 .6 3H5.04l.6-3zM20 4H4v2h16zm0 3H4l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2zM6 18v-4h6v4z" }));
	}),
	table: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m0 4v4h6V8zm8 0v4h6V8zm-8 6v4h6v-4zm8 0v4h6v-4z" }));
	}),
	tablet: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			fill: "#1f1f1f",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2m-2 14H5V6h14z" }));
	}),
	tableEdit: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", { d: "m21.7 13.35-1 1-2.05-2.05 1-1c.21-.22.56-.22.77 0l1.28 1.28c.22.21.22.56 0 .77M12 18.94l6.07-6.06 2.05 2.05L14.06 21H12zM4 2h14a2 2 0 0 1 2 2v4.17L16.17 12H12v4.17L10.17 18H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 4v4h6V6zm8 0v4h6V6zm-8 6v4h6v-4z" }));
	}),
	tag: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 -960 960 960"
		}, e), w.createElement("path", { d: "M570-104q-23 23-57 23t-57-23L104-456q-11-11-17.5-26T80-514v-286q0-33 23.5-56.5T160-880h286q17 0 32 6.5t26 17.5l352 353q23 23 23 56.5T856-390zm-57-56 286-286-353-354H160v286zM260-640q25 0 42.5-17.5T320-700t-17.5-42.5T260-760t-42.5 17.5T200-700t17.5 42.5T260-640M160-800" }));
	}),
	textFormat: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M2 20h20v4H2zm3.49-3h2.42l1.27-3.58h5.65L16.09 17h2.42L13.25 3h-2.5zm4.42-5.61 2.03-5.79h.12l2.03 5.79z" }));
	}),
	thumbDown: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0zm0 0h24v24H0z"
		}), w.createElement("path", { d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2m0 12-4.34 4.34L12 14H3v-2l3-7h9zm4-12h4v12h-4z" }));
	}),
	thumbUp: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0zm0 0h24v24H0z"
		}), w.createElement("path", { d: "M9 21h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.58 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2M9 9l4.34-4.34L12 10h9v2l-3 7H9zM1 9h4v12H1z" }));
	}),
	train: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("circle", {
			cx: 8.5,
			cy: 14.5,
			r: 1.5
		}), w.createElement("circle", {
			cx: 15.5,
			cy: 14.5,
			r: 1.5
		}), w.createElement("path", { d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2l2-2h4l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-4-4-8-4m0 2c3.51 0 4.96.48 5.57 1H6.43c.61-.52 2.06-1 5.57-1M6 7h5v3H6zm12 8.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12zm0-5.5h-5V7h5z" }));
	}),
	trackpadInput: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 28 28"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h28v28H0z"
		}), w.createElement("path", { d: "M17.295 25.667a3.5 3.5 0 0 1-1.342-.263 3.4 3.4 0 0 1-1.138-.758l-5.95-5.98.963-.991q.408-.408.992-.554a2.4 2.4 0 0 1 1.166 0l2.013.583v-8.37q0-.496.335-.832t.831-.335.832.335.335.831v11.463l-2.858-.817 3.004 3.004q.174.175.379.263.204.087.438.087h4.87q.963 0 1.648-.685A2.25 2.25 0 0 0 24.5 21v-4.667q0-.495.335-.83.335-.337.831-.336.495 0 .832.335.335.335.335.831V21q0 1.925-1.37 3.296-1.372 1.37-3.297 1.37zm.204-8.167v-4.667q0-.495.335-.83.335-.337.831-.336.495 0 .832.335.335.335.335.831V17.5zm3.5 0V14q0-.496.335-.831.335-.336.831-.336t.832.336.335.831v3.5zM4.665 22.167a2.25 2.25 0 0 1-1.648-.686 2.25 2.25 0 0 1-.685-1.648v-14q0-.961.685-1.648A2.25 2.25 0 0 1 4.665 3.5h17.5q.963 0 1.648.685.686.686.686 1.648V10.5h-2.334V5.833h-17.5v14h2.1l2.305 2.334z" }));
	}),
	undo: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8" }));
	}),
	verifiedUser: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5zm7 10c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11 7 3.11zm-11.59.59L6 13l4 4 8-8-1.41-1.42L10 14.17z" }));
	}),
	viewAgenda: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			fill: "#1f1f1f",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M19 13H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2m0 6H5v-4h14zM19 3H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 6H5V5h14z" }));
	}),
	viewList: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M3 5v14h18V5zm4 2v2H5V7zm-2 6v-2h2v2zm0 2h2v2H5zm14 2H9v-2h10zm0-4H9v-2h10zm0-4H9V7h10z" }));
	}),
	visibility: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 6a9.77 9.77 0 0 1 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5A9.77 9.77 0 0 1 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7" }));
	}),
	visibilityOff: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 24 24"
		}, e), w.createElement("path", {
			fill: "none",
			d: "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
		}), w.createElement("path", { d: "M12 6a9.77 9.77 0 0 1 8.82 5.5 9.65 9.65 0 0 1-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6m-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14M2.01 3.87l2.68 2.68A11.74 11.74 0 0 0 1 11.5C2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45zm7.5 7.5 2.61 2.61c-.04.01-.08.02-.12.02a2.5 2.5 0 0 1-2.5-2.5c0-.05.01-.08.01-.13m-3.4-3.4 1.75 1.75a4.6 4.6 0 0 0-.36 1.78 4.507 4.507 0 0 0 6.27 4.14l.98.98c-.88.24-1.8.38-2.75.38a9.77 9.77 0 0 1-8.82-5.5c.7-1.43 1.72-2.61 2.93-3.53" }));
	}),
	warning: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 -960 960 960"
		}, e), w.createElement("path", { d: "m40-120 440-760 440 760zm138-80h604L480-720zm302-40q17 0 28.5-11.5T520-280t-11.5-28.5T480-320t-28.5 11.5T440-280t11.5 28.5T480-240m-40-120h80v-200h-80zm40-100" }));
	}),
	width: w.memo(function(e) {
		return w.createElement("svg", k({
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 -960 960 960"
		}, e), w.createElement("path", { d: "M280-320 120-480l160-160 57 56-64 64h414l-63-64 56-56 160 160-160 160-56-56 63-64H273l63 64z" }));
	})
}, Ye = function(e) {
	var t = e.iconName, n = e.size, r = n === void 0 ? "medium" : n, i = e.color, a = i === void 0 ? "primary" : i, o = {
		IconComponent: Je[t],
		size: r,
		color: a
	};
	return T.createElement(Xe, k({}, o));
}, Xe = function(e) {
	var t = e.IconComponent, n = e.size, r = e.color;
	return T.createElement(t, { className: `eds-icon ${qe[`eds-icon--${n}`]} ${qe[`eds-icon--${r}`]}` });
}, A = E(Ye), Ze = ".eds-alert{align-items:center;border:1px solid;border-radius:var(--radius-small);display:flex;gap:12px;justify-content:space-between;padding:12px 16px;width:100%;word-break:break-all}.Alert-module_eds-alert--error__e9dlI{background-color:var(--color-semantic-bg-alert-error);border-color:var(--color-palette-error-light)}.Alert-module_eds-alert--error__e9dlI .Alert-module_eds-alert__icon__EE2YL .eds-icon{fill:var(--color-semantic-icon-error)}.Alert-module_eds-alert--error__e9dlI .Alert-module_eds-alert__content__OEJPZ,.Alert-module_eds-alert--error__e9dlI .Alert-module_eds-alert__title__p6DWP{color:var(--color-semantic-text-alert-error)}.Alert-module_eds-alert--error__e9dlI .Alert-module_eds-alert__close__p4BaL .eds-icon{fill:var(--color-palette-error-darker)}.Alert-module_eds-alert--error__e9dlI .Alert-module_eds-alert__close__p4BaL:hover{background-color:hsla(4,89%,79%,.2)}.Alert-module_eds-alert--error__e9dlI .Alert-module_eds-alert__content__OEJPZ a,.Alert-module_eds-alert--error__e9dlI .Alert-module_eds-alert__title__p6DWP a{color:var(--color-semantic-text-link)}.Alert-module_eds-alert--error__e9dlI.Alert-module_eds-alert--top-fixed__bblRx{background-color:var(--color-palette-error-main)}.Alert-module_eds-alert--warning__RWT9-{background-color:var(--color-semantic-bg-alert-warning);border-color:var(--color-palette-warning-light)}.Alert-module_eds-alert--warning__RWT9- .Alert-module_eds-alert__icon__EE2YL .eds-icon{fill:var(--color-semantic-icon-warning)}.Alert-module_eds-alert--warning__RWT9- .Alert-module_eds-alert__content__OEJPZ,.Alert-module_eds-alert--warning__RWT9- .Alert-module_eds-alert__title__p6DWP{color:var(--color-semantic-text-alert-warning)}.Alert-module_eds-alert--warning__RWT9- .Alert-module_eds-alert__close__p4BaL .eds-icon{fill:var(--color-palette-warning-darker)}.Alert-module_eds-alert--warning__RWT9- .Alert-module_eds-alert__close__p4BaL:hover{background-color:hsla(27,87%,73%,.2)}.Alert-module_eds-alert--warning__RWT9- .Alert-module_eds-alert__content__OEJPZ a,.Alert-module_eds-alert--warning__RWT9- .Alert-module_eds-alert__title__p6DWP a{color:var(--color-semantic-text-link)}.Alert-module_eds-alert--warning__RWT9-.Alert-module_eds-alert--top-fixed__bblRx{background-color:var(--color-palette-warning-main)}.Alert-module_eds-alert--info__FCU1K{background-color:var(--color-semantic-bg-alert-info);border-color:var(--color-palette-info-light)}.Alert-module_eds-alert--info__FCU1K .Alert-module_eds-alert__icon__EE2YL .eds-icon{fill:var(--color-semantic-icon-info)}.Alert-module_eds-alert--info__FCU1K .Alert-module_eds-alert__content__OEJPZ,.Alert-module_eds-alert--info__FCU1K .Alert-module_eds-alert__title__p6DWP{color:var(--color-semantic-text-alert-info)}.Alert-module_eds-alert--info__FCU1K .Alert-module_eds-alert__close__p4BaL .eds-icon{fill:var(--color-palette-info-darker)}.Alert-module_eds-alert--info__FCU1K .Alert-module_eds-alert__close__p4BaL:hover{background-color:rgba(144,203,249,.2)}.Alert-module_eds-alert--info__FCU1K .Alert-module_eds-alert__content__OEJPZ a,.Alert-module_eds-alert--info__FCU1K .Alert-module_eds-alert__title__p6DWP a{color:var(--color-semantic-text-link)}.Alert-module_eds-alert--info__FCU1K.Alert-module_eds-alert--top-fixed__bblRx{background-color:var(--color-palette-info-main)}.Alert-module_eds-alert--success__YFmV7{background-color:var(--color-semantic-bg-alert-success);border-color:var(--color-palette-success-light)}.Alert-module_eds-alert--success__YFmV7 .Alert-module_eds-alert__icon__EE2YL .eds-icon{fill:var(--color-semantic-icon-success)}.Alert-module_eds-alert--success__YFmV7 .Alert-module_eds-alert__content__OEJPZ,.Alert-module_eds-alert--success__YFmV7 .Alert-module_eds-alert__title__p6DWP{color:var(--color-semantic-text-alert-success)}.Alert-module_eds-alert--success__YFmV7 .Alert-module_eds-alert__close__p4BaL .eds-icon{fill:var(--color-palette-success-darker)}.Alert-module_eds-alert--success__YFmV7 .Alert-module_eds-alert__close__p4BaL:hover{background-color:rgba(165,215,167,.2)}.Alert-module_eds-alert--success__YFmV7 .Alert-module_eds-alert__content__OEJPZ a,.Alert-module_eds-alert--success__YFmV7 .Alert-module_eds-alert__title__p6DWP a{color:var(--color-semantic-text-link)}.Alert-module_eds-alert--success__YFmV7.Alert-module_eds-alert--top-fixed__bblRx{background-color:var(--color-palette-success-main)}.Alert-module_eds-alert__content__OEJPZ a:hover,.Alert-module_eds-alert__title__p6DWP a:hover{opacity:.6}.Alert-module_eds-alert__title__p6DWP{font-size:14px;font-weight:700}.Alert-module_eds-alert__content__OEJPZ{font-size:14px;font-weight:400}.Alert-module_eds-alert__content__OEJPZ,.Alert-module_eds-alert__title__p6DWP{margin-right:4px;width:inherit}.Alert-module_eds-alert__container__ggSwW{align-items:center;display:flex;gap:12px;width:inherit}.Alert-module_eds-alert__contents-container__xcSGD{display:flex;flex-direction:column;gap:4px;width:inherit}.Alert-module_eds-alert__contents-container__xcSGD>div{display:flex;width:inherit}.eds-alert .Alert-module_eds-alert__contents-container__xcSGD a{text-decoration:underline}.Alert-module_eds-alert__icon__EE2YL{align-items:center;align-self:flex-start;display:flex}.Alert-module_eds-alert__icon__EE2YL .eds-icon{height:22px;width:22px}.Alert-module_eds-alert__close__p4BaL{align-items:center;align-self:flex-start;background-color:transparent;border:none;border-radius:var(--radius-small);cursor:pointer;display:flex;padding:5px}.Alert-module_eds-alert--top-fixed__bblRx{border:none;border-radius:var(--radius-none)}.Alert-module_eds-alert--top-fixed__bblRx .Alert-module_eds-alert__close__p4BaL .eds-icon,.Alert-module_eds-alert--top-fixed__bblRx .Alert-module_eds-alert__icon__EE2YL .eds-icon{fill:var(--color-semantic-icon-white)}.Alert-module_eds-alert--top-fixed__bblRx .Alert-module_eds-alert__content__OEJPZ,.Alert-module_eds-alert--top-fixed__bblRx .Alert-module_eds-alert__content__OEJPZ a,.Alert-module_eds-alert--top-fixed__bblRx .Alert-module_eds-alert__title__p6DWP,.Alert-module_eds-alert--top-fixed__bblRx .Alert-module_eds-alert__title__p6DWP a{color:var(--color-semantic-text-white)}", Qe = {
	"eds-alert--error": "Alert-module_eds-alert--error__e9dlI",
	"eds-alert__icon": "Alert-module_eds-alert__icon__EE2YL",
	"eds-alert__title": "Alert-module_eds-alert__title__p6DWP",
	"eds-alert__content": "Alert-module_eds-alert__content__OEJPZ",
	"eds-alert__close": "Alert-module_eds-alert__close__p4BaL",
	"eds-alert--top-fixed": "Alert-module_eds-alert--top-fixed__bblRx",
	"eds-alert--warning": "Alert-module_eds-alert--warning__RWT9-",
	"eds-alert--info": "Alert-module_eds-alert--info__FCU1K",
	"eds-alert--success": "Alert-module_eds-alert--success__YFmV7",
	"eds-alert__container": "Alert-module_eds-alert__container__ggSwW",
	"eds-alert__contents-container": "Alert-module_eds-alert__contents-container__xcSGD"
};
We(Ze);
var $e = function(e) {
	var t = k({}, e);
	return T.createElement(et, k({}, t));
}, et = function(e) {
	var t = e.children;
	return T.createElement("div", null, T.createElement("span", { className: `${Qe["eds-alert__title"]}` }, t));
}, tt = E($e), nt = function(e) {
	var t = k({}, e);
	return T.createElement(rt, k({}, t));
}, rt = function(e) {
	var t = e.children;
	return T.createElement("div", null, T.createElement("span", { className: `${Qe["eds-alert__content"]}` }, t));
}, it = E(nt), at = function(e) {
	var t = e.color, n = t === void 0 ? "error" : t, r = e.onClose, i = e.isTopFixed, a = Ue(e, [
		"color",
		"onClose",
		"isTopFixed"
	]), o = we(!0), s = o[0], c = o[1], l = k(k({}, a), {
		icon: function() {
			switch (n) {
				case "error": return "error";
				case "warning": return "warning";
				case "info": return "info";
				case "success": return "checkCircle";
				default: return "error";
			}
		}(),
		onClose: function() {
			c(!1), r?.();
		},
		visible: s,
		classNames: function() {
			var e = [];
			return i && e.push(Qe["eds-alert--top-fixed"]), e.join(" ");
		}(),
		color: n,
		isCloseable: !!r
	});
	return T.createElement(ot, k({}, l));
}, ot = function(e) {
	var t = e.color, n = e.icon, r = e.onClose, i = e.visible, a = e.classNames, o = e.isCloseable, s = e.children;
	return T.createElement(T.Fragment, null, i && T.createElement("div", { className: `eds-alert ${Qe[`eds-alert--${t}`]} ${a}` }, T.createElement("div", { className: `${Qe["eds-alert__container"]}` }, T.createElement("div", { className: `${Qe["eds-alert__icon"]}` }, T.createElement(A, { iconName: n })), T.createElement("div", { className: `${Qe["eds-alert__contents-container"]}` }, s)), o && T.createElement("button", {
		type: "button",
		onClick: r,
		className: `${Qe["eds-alert__close"]}`
	}, T.createElement(A, {
		iconName: "close",
		size: "small"
	}))));
}, st = E(at);
st.Title = tt, st.Content = it;
//#endregion
//#region ../../../node_modules/.pnpm/@e-seikatsu+design-system@10.0.0_@mui+material@9.5.0_@emotion+react@11.14.0_@types+reac_a3f44f16f860030a3d2f287fe1d407fb/node_modules/@e-seikatsu/design-system/dist/helper/RippleEffect/index.js
var ct = ".RippleEffect-module_eds-ripple__V9dtw{inset:0;overflow:hidden;pointer-events:none;position:absolute;z-index:0}", lt = { "eds-ripple": "RippleEffect-module_eds-ripple__V9dtw" };
We(ct);
var ut = function(e, t, n, r) {
	r === void 0 && (r = 1e3);
	var i = t.current;
	if (i) {
		var a = document.createElement("span");
		a.classList.add(n), a.style.left = `${e.nativeEvent.layerX}px`, a.style.top = `${e.nativeEvent.layerY}px`, i.appendChild(a), requestAnimationFrame(function() {
			setTimeout(function() {
				a.remove();
			}, r);
		});
	}
}, dt = ye(function(e, t) {
	return T.createElement("span", {
		className: lt["eds-ripple"],
		ref: t
	});
});
dt.displayName = "RippleEffect";
//#endregion
//#region ../../../node_modules/.pnpm/@e-seikatsu+design-system@10.0.0_@mui+material@9.5.0_@emotion+react@11.14.0_@types+reac_a3f44f16f860030a3d2f287fe1d407fb/node_modules/@e-seikatsu/design-system/dist/components/Button/index.js
var ft = ".eds-button{align-items:center;border:none;border-radius:var(--radius-small);box-sizing:border-box;cursor:pointer;display:inline-flex;font-weight:700;gap:4px;justify-content:center;overflow:hidden;position:relative;text-decoration:none;white-space:nowrap}.Button-module_eds-button__ripple__sihYb{animation-duration:.5s;animation-name:Button-module_ripple-effect__B8PDc;background-color:var(--color-palette-white);border-radius:50%;outline:none;pointer-events:none;position:absolute;transform:translateX(-50%) translateY(-50%)}@keyframes Button-module_ripple-effect__B8PDc{0%{height:0;opacity:1;width:0}40%{opacity:.3}to{height:100px;opacity:0;width:100px}}.eds-button.Button-module_eds-button--disabled__nAiY0{pointer-events:none}.eds-button .eds-icon{align-items:center;display:flex}.Button-module_eds-button--contained__QWPtF{box-shadow:var(--shadow-button);color:var(--color-semantic-text-white)}.Button-module_eds-button--full-width__5YMD-{width:100%}.Button-module_eds-button--contained__QWPtF.Button-module_eds-button--primary__kax0-{background-color:var(--color-semantic-bg-cntbtn-primary-default)}.Button-module_eds-button--contained__QWPtF.Button-module_eds-button--primary__kax0-:hover{background-color:var(--color-semantic-bg-cntbtn-primary-hover)}.Button-module_eds-button--contained__QWPtF.Button-module_eds-button--black__LDcAw,.Button-module_eds-button--contained__QWPtF.Button-module_eds-button--primary__kax0-,.Button-module_eds-button--contained__QWPtF.Button-module_eds-button--white__FSb7E{background-color:var(--color-semantic-bg-cntbtn-primary-default)}.Button-module_eds-button--contained__QWPtF.Button-module_eds-button--black__LDcAw:hover,.Button-module_eds-button--contained__QWPtF.Button-module_eds-button--primary__kax0-:hover,.Button-module_eds-button--contained__QWPtF.Button-module_eds-button--white__FSb7E:hover{background-color:var(--color-semantic-bg-cntbtn-primary-hover)}.Button-module_eds-button--contained__QWPtF.Button-module_eds-button--secondary__qNukP{background-color:var(--color-semantic-bg-cntbtn-secondary-default)}.Button-module_eds-button--contained__QWPtF.Button-module_eds-button--secondary__qNukP:hover{background-color:var(--color-semantic-bg-cntbtn-secondary-hover)}.Button-module_eds-button--contained__QWPtF.Button-module_eds-button--error__iRp-9{background-color:var(--color-semantic-bg-cntbtn-error-default)}.Button-module_eds-button--contained__QWPtF.Button-module_eds-button--error__iRp-9:hover{background-color:var(--color-semantic-bg-cntbtn-error-hover)}.Button-module_eds-button--contained__QWPtF.eds-button.Button-module_eds-button--disabled__nAiY0{background-color:var(--color-semantic-bg-cntbtn-disabled);box-shadow:var(--shadow-none);color:var(--color-semantic-text-disabled)}.Button-module_eds-button--contained__QWPtF .eds-icon{fill:var(--color-semantic-icon-white)}.Button-module_eds-button--text__ZnRyz{background-color:transparent}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--primary__kax0-{color:var(--color-palette-primary-main)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--primary__kax0- .eds-icon{fill:var(--color-semantic-icon-primary)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--primary__kax0-:hover{background-color:var(--color-semantic-bg-subbtn-primary-hover)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--primary__kax0- .Button-module_eds-button__ripple__sihYb{background-color:var(--color-palette-primary-main)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--secondary__qNukP{color:var(--color-palette-secondary-main)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--secondary__qNukP .eds-icon{fill:var(--color-semantic-icon-secondary)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--secondary__qNukP:hover{background-color:var(--color-semantic-bg-subbtn-secondary-hover)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--secondary__qNukP .Button-module_eds-button__ripple__sihYb{background-color:var(--color-palette-secondary-main)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--error__iRp-9{color:var(--color-palette-error-main)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--error__iRp-9 .eds-icon{fill:var(--color-semantic-icon-error)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--error__iRp-9:hover{background-color:var(--color-semantic-bg-subbtn-error-hover)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--error__iRp-9 .Button-module_eds-button__ripple__sihYb{background-color:var(--color-palette-error-main)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--black__LDcAw{color:var(--color-palette-grey-700)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--black__LDcAw .eds-icon{fill:var(--color-semantic-icon-black)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--black__LDcAw:hover{background-color:var(--color-semantic-bg-subbtn-default-hover)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--black__LDcAw .Button-module_eds-button__ripple__sihYb{background-color:var(--color-palette-grey-700)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--white__FSb7E{color:var(--color-semantic-text-white)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--white__FSb7E .eds-icon{fill:var(--color-semantic-icon-white)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--white__FSb7E:hover{background-color:var(--color-semantic-bg-subbtn-default-hover)}.Button-module_eds-button--text__ZnRyz.eds-button.Button-module_eds-button--disabled__nAiY0{color:var(--color-semantic-text-disabled)}.Button-module_eds-button--text__ZnRyz.Button-module_eds-button--white__FSb7E.eds-button.Button-module_eds-button--disabled__nAiY0{color:var(--color-semantic-text-white-disabled)}.Button-module_eds-button--outlined__9xgJd{background-color:transparent}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--primary__kax0-{border:1px solid var(--color-semantic-border-olbtn-primary);color:var(--color-palette-primary-main)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--primary__kax0- .eds-icon{fill:var(--color-semantic-icon-primary)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--primary__kax0-:hover{background-color:var(--color-semantic-bg-subbtn-primary-hover)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--primary__kax0- .Button-module_eds-button__ripple__sihYb{background-color:var(--color-palette-primary-main)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--secondary__qNukP{border:1px solid var(--color-semantic-border-olbtn-secondary);color:var(--color-palette-secondary-main)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--secondary__qNukP .eds-icon{fill:var(--color-semantic-icon-secondary)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--secondary__qNukP:hover{background-color:var(--color-semantic-bg-subbtn-secondary-hover)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--secondary__qNukP .Button-module_eds-button__ripple__sihYb{background-color:var(--color-palette-secondary-main)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--error__iRp-9{border:1px solid var(--color-semantic-border-olbtn-error);color:var(--color-palette-error-main)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--error__iRp-9 .eds-icon{fill:var(--color-semantic-icon-error)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--error__iRp-9:hover{background-color:var(--color-semantic-bg-subbtn-error-hover)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--error__iRp-9 .Button-module_eds-button__ripple__sihYb{background-color:var(--color-palette-error-main)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--black__LDcAw{border:1px solid var(--color-semantic-border-olbtn-black);color:var(--color-palette-grey-700)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--black__LDcAw .eds-icon{fill:var(--color-semantic-icon-black)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--black__LDcAw:hover{background-color:var(--color-semantic-bg-subbtn-default-hover)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--black__LDcAw .Button-module_eds-button__ripple__sihYb{background-color:var(--color-palette-grey-700)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--white__FSb7E{border:1px solid var(--color-semantic-border-olbtn-clear);color:var(--color-semantic-text-white)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--white__FSb7E .eds-icon{fill:var(--color-semantic-icon-white)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--white__FSb7E:hover{background-color:var(--color-semantic-bg-subbtn-default-hover)}.Button-module_eds-button--outlined__9xgJd.eds-button.Button-module_eds-button--disabled__nAiY0{border:1px solid var(--color-semantic-border-input-default);color:var(--color-semantic-text-disabled)}.Button-module_eds-button--outlined__9xgJd.Button-module_eds-button--white__FSb7E.eds-button.Button-module_eds-button--disabled__nAiY0{border:1px solid var(--color-semantic-border-olbtn-clear-disabled);color:var(--color-semantic-text-white-disabled)}.Button-module_eds-button--small__Knufy{font-size:12px;height:28px;line-height:20px;padding:4px 10px}.Button-module_eds-button--medium__bj6zk{font-size:14px;height:36px;line-height:24px;padding:6px 16px}.Button-module_eds-button--large__LF5XC{font-size:15px;height:42px;line-height:26px;padding:8px 22px}.eds-button.Button-module_eds-button--disabled__nAiY0 .eds-icon{fill:var(--color-semantic-icon-disabled)}.eds-button.Button-module_eds-button--white__FSb7E.Button-module_eds-button--disabled__nAiY0 .eds-icon{fill:var(--color-semantic-icon-white-disabled)}.Button-module_eds-button--loading__pcKqY.Button-module_eds-button--contained__QWPtF{background-color:var(--color-semantic-bg-cntbtn-disabled)}.Button-module_eds-button--loading__pcKqY.Button-module_eds-button--outlined__9xgJd{border-color:var(--color-semantic-border-olbtn-disabled)}.Button-module_eds-button--loading__pcKqY:before{animation:Button-module_spin__JvkZu .8s linear infinite;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='22' height='22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6.79.837A11 11 0 0 1 22 11h-2a9 9 0 1 0-4.5 7.794l1 1.732A11 11 0 1 1 6.79.837Z' fill='%23757575'/%3E%3C/svg%3E\");background-size:contain;content:\"\";left:50%;position:absolute;top:50%}.Button-module_eds-button--loading__pcKqY.Button-module_eds-button--white__FSb7E:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='22' height='22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.834 11c0 5.06 4.107 9.166 9.167 9.166S20.167 16.06 20.167 11c0-5.06-4.106-9.167-9.166-9.167v1.833A7.331 7.331 0 0 1 18.334 11a7.331 7.331 0 0 1-7.333 7.333A7.331 7.331 0 0 1 3.667 11H1.834Z' fill='%23fff'/%3E%3C/svg%3E\");background-size:contain}.Button-module_eds-button--small__Knufy.Button-module_eds-button--loading__pcKqY:before{height:16px;margin-left:-8px;margin-top:-8px;width:16px}.Button-module_eds-button--medium__bj6zk.Button-module_eds-button--loading__pcKqY:before{height:20px;margin-left:-10px;margin-top:-10px;width:20px}.Button-module_eds-button--large__LF5XC.Button-module_eds-button--loading__pcKqY:before{height:24px;margin-left:-12px;margin-top:-12px;width:24px}@keyframes Button-module_spin__JvkZu{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", pt = {
	"eds-button__ripple": "Button-module_eds-button__ripple__sihYb",
	"ripple-effect": "Button-module_ripple-effect__B8PDc",
	"eds-button--disabled": "Button-module_eds-button--disabled__nAiY0",
	"eds-button--contained": "Button-module_eds-button--contained__QWPtF",
	"eds-button--full-width": "Button-module_eds-button--full-width__5YMD-",
	"eds-button--primary": "Button-module_eds-button--primary__kax0-",
	"eds-button--black": "Button-module_eds-button--black__LDcAw",
	"eds-button--white": "Button-module_eds-button--white__FSb7E",
	"eds-button--secondary": "Button-module_eds-button--secondary__qNukP",
	"eds-button--error": "Button-module_eds-button--error__iRp-9",
	"eds-button--text": "Button-module_eds-button--text__ZnRyz",
	"eds-button--outlined": "Button-module_eds-button--outlined__9xgJd",
	"eds-button--small": "Button-module_eds-button--small__Knufy",
	"eds-button--medium": "Button-module_eds-button--medium__bj6zk",
	"eds-button--large": "Button-module_eds-button--large__LF5XC",
	"eds-button--loading": "Button-module_eds-button--loading__pcKqY",
	spin: "Button-module_spin__JvkZu"
};
We(ft);
var mt = ye(function(e, t) {
	var n = e.fullWidth, r = e.isLoading, i = e.component, a = e.href, o = e.disabled, s = e.disableRipple, c = s !== void 0 && s, l = e.type, u = Ue(e, [
		"fullWidth",
		"isLoading",
		"component",
		"href",
		"disabled",
		"disableRipple",
		"type"
	]), d = Ce(null), f = i ?? (a ? "a" : "button"), p = f === "button" ? l ?? "button" : l, m = k(k({}, u), {
		classNames: function() {
			var e = [];
			return n && e.push(`${pt["eds-button--full-width"]}`), r && e.push(`${pt["eds-button--loading"]}`), (o || r) && e.push(`${pt["eds-button--disabled"]}`), e.join(" ");
		}(),
		disabled: o || r,
		forwardedRef: t,
		href: a,
		type: p,
		handleOnMouseDown: function(t) {
			var n;
			c || ut(t, d, pt["eds-button__ripple"]), (n = e.onMouseDown) == null || n.call(e, t);
		},
		rippleRef: d,
		Root: f
	});
	return T.createElement(ht, k({}, m));
});
mt.displayName = "ButtonContainer";
var ht = function(e) {
	var t = e.children, n = e.color, r = n === void 0 ? "primary" : n, i = e.size, a = i === void 0 ? "medium" : i, o = e.variant, s = o === void 0 ? "contained" : o, c = e.handleOnMouseDown, l = e.classNames, u = e.prependIcon, d = e.appendIcon, f = e.forwardedRef, p = e.Root, m = e.disabled, h = e.rippleRef, g = Ue(e, [
		"children",
		"color",
		"size",
		"variant",
		"handleOnMouseDown",
		"classNames",
		"prependIcon",
		"appendIcon",
		"forwardedRef",
		"Root",
		"disabled",
		"rippleRef"
	]);
	return T.createElement(p, k({
		ref: f,
		disabled: m
	}, g, {
		className: `eds-button ${pt[`eds-button--${r}`]} ${pt[`eds-button--${a}`]} ${pt[`eds-button--${s}`]} ${l}`,
		onMouseDown: c
	}), u && T.createElement(A, {
		iconName: u,
		size: a
	}), t, d && T.createElement(A, {
		iconName: d,
		size: a
	}), T.createElement(dt, { ref: h }));
}, j = E(mt), gt = ".eds-icon-button{align-items:center;background-color:transparent;border:none;border-radius:var(--radius-small);box-sizing:border-box;cursor:pointer;display:inline-flex;justify-content:center;overflow:hidden;position:relative}.IconButton-module_eds-icon-button__ripple__8j1uQ{animation-duration:.5s;animation-fill-mode:none;animation-name:IconButton-module_ripple-effect__iNPBr;background-color:var(--color-palette-white);border-radius:50%;height:0;outline:none;pointer-events:none;position:absolute;transform:translateX(-50%) translateY(-50%);width:0;z-index:5}@keyframes IconButton-module_ripple-effect__iNPBr{0%{height:0;opacity:1;width:0}40%{opacity:.3}to{height:100px;opacity:0;width:100px}}.eds-icon-button.IconButton-module_eds-icon-button--disabled__tm-r-{pointer-events:none}.eds-icon-button .IconButton-module_eds-icon-button__icon__dnwC6 .eds-icon{align-items:center;display:flex}.IconButton-module_eds-icon-button--contained__ugaOT{box-shadow:var(--shadow-button)}.IconButton-module_eds-icon-button--contained__ugaOT.IconButton-module_eds-icon-button--primary__wp7kj{background-color:var(--color-semantic-bg-cntbtn-primary-default)}.IconButton-module_eds-icon-button--contained__ugaOT.IconButton-module_eds-icon-button--primary__wp7kj:hover{background-color:var(--color-semantic-bg-cntbtn-primary-hover)}.IconButton-module_eds-icon-button--contained__ugaOT.IconButton-module_eds-icon-button--black__CkDvO,.IconButton-module_eds-icon-button--contained__ugaOT.IconButton-module_eds-icon-button--primary__wp7kj,.IconButton-module_eds-icon-button--contained__ugaOT.IconButton-module_eds-icon-button--white__-QMCP{background-color:var(--color-semantic-bg-cntbtn-primary-default)}.IconButton-module_eds-icon-button--contained__ugaOT.IconButton-module_eds-icon-button--black__CkDvO:hover,.IconButton-module_eds-icon-button--contained__ugaOT.IconButton-module_eds-icon-button--primary__wp7kj:hover,.IconButton-module_eds-icon-button--contained__ugaOT.IconButton-module_eds-icon-button--white__-QMCP:hover{background-color:var(--color-semantic-bg-cntbtn-primary-hover)}.IconButton-module_eds-icon-button--contained__ugaOT.IconButton-module_eds-icon-button--disabled__tm-r-{background-color:var(--color-semantic-bg-cntbtn-disabled);box-shadow:var(--shadow-none)}.IconButton-module_eds-icon-button--contained__ugaOT .IconButton-module_eds-icon-button__icon__dnwC6 .eds-icon{fill:var(--color-semantic-icon-white)}.IconButton-module_eds-icon-button--outlined__YgiCr{border:1px solid}.IconButton-module_eds-icon-button--outlined__YgiCr.IconButton-module_eds-icon-button--primary__wp7kj{border-color:var(--color-semantic-border-olbtn-primary)}.IconButton-module_eds-icon-button--outlined__YgiCr.IconButton-module_eds-icon-button--black__CkDvO{border-color:var(--color-semantic-border-olbtn-black)}.IconButton-module_eds-icon-button--outlined__YgiCr.IconButton-module_eds-icon-button--white__-QMCP{border-color:var(--color-semantic-border-olbtn-clear)}.IconButton-module_eds-icon-button--outlined__YgiCr.IconButton-module_eds-icon-button--disabled__tm-r-{border-color:var(--color-semantic-border-input-disabled)}.IconButton-module_eds-icon-button--iconOnly__5-1V-.IconButton-module_eds-icon-button--primary__wp7kj .IconButton-module_eds-icon-button__icon__dnwC6 .eds-icon,.IconButton-module_eds-icon-button--outlined__YgiCr.IconButton-module_eds-icon-button--primary__wp7kj .IconButton-module_eds-icon-button__icon__dnwC6 .eds-icon{fill:var(--color-semantic-icon-primary)}.IconButton-module_eds-icon-button--iconOnly__5-1V-.IconButton-module_eds-icon-button--primary__wp7kj:hover,.IconButton-module_eds-icon-button--outlined__YgiCr.IconButton-module_eds-icon-button--primary__wp7kj:hover{background-color:var(--color-semantic-bg-subbtn-primary-hover)}.IconButton-module_eds-icon-button--iconOnly__5-1V-.IconButton-module_eds-icon-button--primary__wp7kj .IconButton-module_eds-icon-button__ripple__8j1uQ,.IconButton-module_eds-icon-button--outlined__YgiCr.IconButton-module_eds-icon-button--primary__wp7kj .IconButton-module_eds-icon-button__ripple__8j1uQ{background-color:var(--color-palette-primary-main)}.IconButton-module_eds-icon-button--iconOnly__5-1V-.IconButton-module_eds-icon-button--black__CkDvO .IconButton-module_eds-icon-button__icon__dnwC6 .eds-icon,.IconButton-module_eds-icon-button--outlined__YgiCr.IconButton-module_eds-icon-button--black__CkDvO .IconButton-module_eds-icon-button__icon__dnwC6 .eds-icon{fill:var(--color-semantic-icon-black)}.IconButton-module_eds-icon-button--iconOnly__5-1V-.IconButton-module_eds-icon-button--black__CkDvO:hover,.IconButton-module_eds-icon-button--outlined__YgiCr.IconButton-module_eds-icon-button--black__CkDvO:hover{background-color:var(--color-semantic-bg-subbtn-default-hover)}.IconButton-module_eds-icon-button--iconOnly__5-1V-.IconButton-module_eds-icon-button--black__CkDvO .IconButton-module_eds-icon-button__ripple__8j1uQ,.IconButton-module_eds-icon-button--outlined__YgiCr.IconButton-module_eds-icon-button--black__CkDvO .IconButton-module_eds-icon-button__ripple__8j1uQ{background-color:var(--color-palette-grey-700)}.IconButton-module_eds-icon-button--iconOnly__5-1V-.IconButton-module_eds-icon-button--white__-QMCP .IconButton-module_eds-icon-button__icon__dnwC6 .eds-icon,.IconButton-module_eds-icon-button--outlined__YgiCr.IconButton-module_eds-icon-button--white__-QMCP .IconButton-module_eds-icon-button__icon__dnwC6 .eds-icon{fill:var(--color-semantic-icon-white)}.IconButton-module_eds-icon-button--iconOnly__5-1V-.IconButton-module_eds-icon-button--white__-QMCP:hover,.IconButton-module_eds-icon-button--outlined__YgiCr.IconButton-module_eds-icon-button--white__-QMCP:hover{background-color:var(--color-semantic-bg-subbtn-default-hover)}.IconButton-module_eds-icon-button--outlined__YgiCr.IconButton-module_eds-icon-button--white__-QMCP.eds-icon-button.IconButton-module_eds-icon-button--disabled__tm-r-{border-color:var(--color-semantic-border-olbtn-clear-disabled)}.IconButton-module_eds-icon-button--small__S99vZ{height:28px;width:28px}.IconButton-module_eds-icon-button--medium__DGTD2{height:36px;width:36px}.IconButton-module_eds-icon-button--large__KVoRy{height:42px;width:42px}.eds-icon-button.IconButton-module_eds-icon-button--disabled__tm-r- .IconButton-module_eds-icon-button__icon__dnwC6 .eds-icon{fill:var(--color-semantic-icon-disabled)}.eds-icon-button.IconButton-module_eds-icon-button--white__-QMCP.IconButton-module_eds-icon-button--disabled__tm-r- .IconButton-module_eds-icon-button__icon__dnwC6 .eds-icon{fill:var(--color-semantic-icon-white-disabled)}", _t = {
	"eds-icon-button__ripple": "IconButton-module_eds-icon-button__ripple__8j1uQ",
	"ripple-effect": "IconButton-module_ripple-effect__iNPBr",
	"eds-icon-button--disabled": "IconButton-module_eds-icon-button--disabled__tm-r-",
	"eds-icon-button__icon": "IconButton-module_eds-icon-button__icon__dnwC6",
	"eds-icon-button--contained": "IconButton-module_eds-icon-button--contained__ugaOT",
	"eds-icon-button--primary": "IconButton-module_eds-icon-button--primary__wp7kj",
	"eds-icon-button--black": "IconButton-module_eds-icon-button--black__CkDvO",
	"eds-icon-button--white": "IconButton-module_eds-icon-button--white__-QMCP",
	"eds-icon-button--outlined": "IconButton-module_eds-icon-button--outlined__YgiCr",
	"eds-icon-button--iconOnly": "IconButton-module_eds-icon-button--iconOnly__5-1V-",
	"eds-icon-button--small": "IconButton-module_eds-icon-button--small__S99vZ",
	"eds-icon-button--medium": "IconButton-module_eds-icon-button--medium__DGTD2",
	"eds-icon-button--large": "IconButton-module_eds-icon-button--large__KVoRy"
};
We(gt);
var vt = ye(function(e, t) {
	var n = e.component, r = e.href, i = e.disabled, a = e.type, o = e.disableRipple, s = o !== void 0 && o, c = Ue(e, [
		"component",
		"href",
		"disabled",
		"type",
		"disableRipple"
	]), l = Ce(null), u = n ?? (r ? "a" : "button"), d = u === "button" ? a ?? "button" : a, f = k(k({}, c), {
		classNames: function() {
			var e = [];
			return i && e.push(`${_t["eds-icon-button--disabled"]}`), e.join(" ");
		}(),
		disabled: i,
		forwardedRef: t,
		href: r,
		type: d,
		handleOnMouseDown: function(t) {
			var n;
			s || ut(t, l, _t["eds-icon-button__ripple"]), (n = e.onMouseDown) == null || n.call(e, t);
		},
		rippleRef: l,
		Root: u
	});
	return T.createElement(yt, k({}, f));
});
vt.displayName = "IconButtonContainer";
var yt = function(e) {
	var t = e.icon, n = t === void 0 ? "starFill" : t, r = e.color, i = r === void 0 ? "primary" : r, a = e.size, o = a === void 0 ? "medium" : a, s = e.variant, c = s === void 0 ? "contained" : s, l = e.handleOnMouseDown, u = e.classNames, d = e.forwardedRef, f = e.Root, p = e.disabled, m = e.rippleRef, h = Ue(e, [
		"icon",
		"color",
		"size",
		"variant",
		"handleOnMouseDown",
		"classNames",
		"forwardedRef",
		"Root",
		"disabled",
		"rippleRef"
	]);
	return T.createElement(f, k({
		ref: d,
		disabled: p
	}, h, {
		className: `eds-icon-button ${_t[`eds-icon-button--${i}`]} ${_t[`eds-icon-button--${o}`]} ${_t[`eds-icon-button--${c}`]} ${u}`,
		onMouseDown: l
	}), A && T.createElement("div", { className: `${_t["eds-icon-button__icon"]}` }, T.createElement(A, {
		iconName: n,
		size: o
	})), T.createElement(dt, { ref: m }));
}, bt = E(vt), xt = ".eds-tag{align-items:center;border:1px solid transparent;border-radius:var(--radius-x-small);box-sizing:border-box;gap:4px;justify-content:center;max-width:100%;padding:5px 6px;white-space:nowrap;width:max-content}.Tag-module_eds-tag__icon__c6a94,.eds-tag{display:inline-flex}.Tag-module_eds-tag__button__gaK01{align-items:center;background-color:transparent;border:none;cursor:pointer;display:flex;justify-content:center;padding:0}.Tag-module_eds-tag__button__gaK01:focus{outline:none}.Tag-module_eds-tag__button__gaK01:hover .eds-icon{opacity:.7}.eds-tag__label{font-weight:700;overflow:hidden;text-overflow:ellipsis}.Tag-module_eds-tag--small__WBadZ{height:18px}.Tag-module_eds-tag--medium__TVZot{height:22px}.Tag-module_eds-tag--large__5DJIb{height:26px}.Tag-module_eds-tag--small__WBadZ .Tag-module_eds-tag__button__gaK01 .eds-icon,.Tag-module_eds-tag--small__WBadZ .Tag-module_eds-tag__icon__c6a94 .eds-icon{height:12px;width:12px}.Tag-module_eds-tag--medium__TVZot .Tag-module_eds-tag__button__gaK01 .eds-icon,.Tag-module_eds-tag--medium__TVZot .Tag-module_eds-tag__icon__c6a94 .eds-icon{height:14px;width:14px}.Tag-module_eds-tag--large__5DJIb .Tag-module_eds-tag__button__gaK01 .eds-icon,.Tag-module_eds-tag--large__5DJIb .Tag-module_eds-tag__icon__c6a94 .eds-icon{height:16px;width:16px}.Tag-module_eds-tag--small__WBadZ .eds-tag__label{font-size:10px}.Tag-module_eds-tag--medium__TVZot .eds-tag__label{font-size:12px}.Tag-module_eds-tag--large__5DJIb .eds-tag__label{font-size:14px}.Tag-module_eds-tag--outlined__Q7OcK{background-color:var(--color-palette-white);border:1px solid}.Tag-module_eds-tag--disabled__qFQlk .Tag-module_eds-tag__button__gaK01{pointer-events:none}.eds-tag.Tag-module_eds-tag--outlined__Q7OcK.Tag-module_eds-tag--disabled__qFQlk{border-color:var(--color-semantic-border-divider)}.eds-tag.Tag-module_eds-tag--disabled__qFQlk .eds-tag__label{color:var(--color-semantic-text-disabled)}.eds-tag.Tag-module_eds-tag--soft__X3fO-.Tag-module_eds-tag--disabled__qFQlk,.eds-tag.Tag-module_eds-tag--strong__160MN.Tag-module_eds-tag--disabled__qFQlk{background-color:var(--color-palette-grey-200)}.Tag-module_eds-tag--standard__ySKAG.Tag-module_eds-tag--outlined__Q7OcK{border-color:var(--color-semantic-border-divider)}.Tag-module_eds-tag--standard__ySKAG.Tag-module_eds-tag--outlined__Q7OcK .Tag-module_eds-tag__button__gaK01 .eds-icon,.Tag-module_eds-tag--standard__ySKAG.Tag-module_eds-tag--outlined__Q7OcK .Tag-module_eds-tag__icon__c6a94:not(.Tag-module_eds-tag__icon--has-color__T-5ba) .eds-icon{fill:var(--color-semantic-icon-black)}.Tag-module_eds-tag--error__P08aF.Tag-module_eds-tag--outlined__Q7OcK .Tag-module_eds-tag__button__gaK01 .eds-icon,.Tag-module_eds-tag--error__P08aF.Tag-module_eds-tag--outlined__Q7OcK .Tag-module_eds-tag__icon__c6a94:not(.Tag-module_eds-tag__icon--has-color__T-5ba) .eds-icon{fill:var(--color-semantic-icon-error)}.Tag-module_eds-tag--warning__5nMc5.Tag-module_eds-tag--outlined__Q7OcK .Tag-module_eds-tag__button__gaK01 .eds-icon,.Tag-module_eds-tag--warning__5nMc5.Tag-module_eds-tag--outlined__Q7OcK .Tag-module_eds-tag__icon__c6a94:not(.Tag-module_eds-tag__icon--has-color__T-5ba) .eds-icon{fill:var(--color-semantic-icon-warning)}.Tag-module_eds-tag--info__Yl0P8.Tag-module_eds-tag--outlined__Q7OcK .Tag-module_eds-tag__button__gaK01 .eds-icon,.Tag-module_eds-tag--info__Yl0P8.Tag-module_eds-tag--outlined__Q7OcK .Tag-module_eds-tag__icon__c6a94:not(.Tag-module_eds-tag__icon--has-color__T-5ba) .eds-icon{fill:var(--color-semantic-icon-info)}.Tag-module_eds-tag--success__FZmcZ.Tag-module_eds-tag--outlined__Q7OcK .Tag-module_eds-tag__button__gaK01 .eds-icon,.Tag-module_eds-tag--success__FZmcZ.Tag-module_eds-tag--outlined__Q7OcK .Tag-module_eds-tag__icon__c6a94:not(.Tag-module_eds-tag__icon--has-color__T-5ba) .eds-icon{fill:var(--color-semantic-icon-success)}.Tag-module_eds-tag--soft__X3fO- .Tag-module_eds-tag__icon__c6a94:not(.Tag-module_eds-tag__icon--has-color__T-5ba) .eds-icon{fill:var(--color-semantic-icon-tag-soft)}.Tag-module_eds-tag--strong__160MN .Tag-module_eds-tag__button__gaK01 .eds-icon,.Tag-module_eds-tag--strong__160MN .Tag-module_eds-tag__icon__c6a94:not(.Tag-module_eds-tag__icon--has-color__T-5ba) .eds-icon{fill:var(--color-semantic-icon-white)}.eds-tag.Tag-module_eds-tag--outlined__Q7OcK.Tag-module_eds-tag--disabled__qFQlk .Tag-module_eds-tag__button__gaK01 .eds-icon,.eds-tag.Tag-module_eds-tag--outlined__Q7OcK.Tag-module_eds-tag--disabled__qFQlk .Tag-module_eds-tag__icon__c6a94 .eds-icon,.eds-tag.Tag-module_eds-tag--soft__X3fO-.Tag-module_eds-tag--disabled__qFQlk .Tag-module_eds-tag__button__gaK01 .eds-icon,.eds-tag.Tag-module_eds-tag--soft__X3fO-.Tag-module_eds-tag--disabled__qFQlk .Tag-module_eds-tag__icon__c6a94 .eds-icon,.eds-tag.Tag-module_eds-tag--strong__160MN.Tag-module_eds-tag--disabled__qFQlk .Tag-module_eds-tag__button__gaK01 .eds-icon,.eds-tag.Tag-module_eds-tag--strong__160MN.Tag-module_eds-tag--disabled__qFQlk .Tag-module_eds-tag__icon__c6a94 .eds-icon{fill:var(--color-semantic-icon-disabled)}.Tag-module_eds-tag--error__P08aF.Tag-module_eds-tag--outlined__Q7OcK{border-color:var(--color-palette-error-light)}.Tag-module_eds-tag--error__P08aF .eds-tag__label{color:var(--color-palette-error-main)}.Tag-module_eds-tag--warning__5nMc5.Tag-module_eds-tag--outlined__Q7OcK{border-color:var(--color-palette-warning-light)}.Tag-module_eds-tag--warning__5nMc5 .eds-tag__label{color:var(--color-palette-warning-main)}.Tag-module_eds-tag--info__Yl0P8.Tag-module_eds-tag--outlined__Q7OcK{border-color:var(--color-palette-info-light)}.Tag-module_eds-tag--info__Yl0P8 .eds-tag__label{color:var(--color-palette-info-main)}.Tag-module_eds-tag--success__FZmcZ.Tag-module_eds-tag--outlined__Q7OcK{border-color:var(--color-palette-success-light)}.Tag-module_eds-tag--success__FZmcZ .eds-tag__label{color:var(--color-palette-success-main)}.Tag-module_eds-tag--soft__X3fO- .Tag-module_eds-tag__button__gaK01 .eds-icon{fill:var(--color-semantic-icon-black)}.Tag-module_eds-tag--soft__X3fO- .eds-tag__label{color:var(--color-semantic-text-primary)}.Tag-module_eds-tag--soft__X3fO-.Tag-module_eds-tag--standard__ySKAG{background-color:var(--color-palette-grey-300)}.Tag-module_eds-tag--soft__X3fO-.Tag-module_eds-tag--error__P08aF{background-color:var(--color-palette-red-100)}.Tag-module_eds-tag--soft__X3fO-.Tag-module_eds-tag--warning__5nMc5{background-color:var(--color-palette-deep-orange-100)}.Tag-module_eds-tag--soft__X3fO-.Tag-module_eds-tag--info__Yl0P8{background-color:var(--color-palette-blue-100)}.Tag-module_eds-tag--soft__X3fO-.Tag-module_eds-tag--success__FZmcZ{background-color:var(--color-palette-green-100)}.Tag-module_eds-tag--strong__160MN .eds-tag__label{color:var(--color-palette-white)}.Tag-module_eds-tag--strong__160MN.Tag-module_eds-tag--standard__ySKAG{background-color:var(--color-palette-grey-700)}.Tag-module_eds-tag--strong__160MN.Tag-module_eds-tag--error__P08aF{background-color:var(--color-palette-error-main)}.Tag-module_eds-tag--strong__160MN.Tag-module_eds-tag--warning__5nMc5{background-color:var(--color-palette-warning-main)}.Tag-module_eds-tag--strong__160MN.Tag-module_eds-tag--info__Yl0P8{background-color:var(--color-palette-info-main)}.Tag-module_eds-tag--strong__160MN.Tag-module_eds-tag--success__FZmcZ{background-color:var(--color-palette-success-main)}", St = {
	"eds-tag__icon": "Tag-module_eds-tag__icon__c6a94",
	"eds-tag__button": "Tag-module_eds-tag__button__gaK01",
	"eds-tag--small": "Tag-module_eds-tag--small__WBadZ",
	"eds-tag--medium": "Tag-module_eds-tag--medium__TVZot",
	"eds-tag--large": "Tag-module_eds-tag--large__5DJIb",
	"eds-tag--outlined": "Tag-module_eds-tag--outlined__Q7OcK",
	"eds-tag--disabled": "Tag-module_eds-tag--disabled__qFQlk",
	"eds-tag--soft": "Tag-module_eds-tag--soft__X3fO-",
	"eds-tag--strong": "Tag-module_eds-tag--strong__160MN",
	"eds-tag--standard": "Tag-module_eds-tag--standard__ySKAG",
	"eds-tag__icon--has-color": "Tag-module_eds-tag__icon--has-color__T-5ba",
	"eds-tag--error": "Tag-module_eds-tag--error__P08aF",
	"eds-tag--warning": "Tag-module_eds-tag--warning__5nMc5",
	"eds-tag--info": "Tag-module_eds-tag--info__Yl0P8",
	"eds-tag--success": "Tag-module_eds-tag--success__FZmcZ"
};
We(xt);
var Ct = function(e) {
	var t = e.disabled, n = e.value, r = e.onRemove, i = Ue(e, [
		"disabled",
		"value",
		"onRemove"
	]), a = we(!1), o = a[0], s = a[1], c = !!r, l = k(k({}, i), {
		isRemoved: o,
		isRemovable: c,
		onClick: function(e) {
			t || (s(!0), r(n, e));
		},
		classNames: function() {
			var t = [];
			return e.disabled && t.push(`${St["eds-tag--disabled"]}`), t.join(" ");
		}(),
		iconClassNames: function() {
			return [St["eds-tag__icon"], e.iconColor ? St["eds-tag__icon--has-color"] : ""].filter(Boolean).join(" ");
		}()
	});
	return T.createElement(wt, k({}, l));
}, wt = function(e) {
	var t = e.variant, n = t === void 0 ? "outlined" : t, r = e.size, i = r === void 0 ? "medium" : r, a = e.color, o = a === void 0 ? "standard" : a, s = e.label, c = e.classNames, l = e.iconClassNames, u = e.onClick, d = e.isRemoved, f = e.isRemovable, p = e.prependIcon, m = e.appendIcon, h = e.iconColor, g = e.style;
	return T.createElement(T.Fragment, null, !d && T.createElement("div", {
		style: g,
		className: `eds-tag ${St[`eds-tag--${n}`]} ${St[`eds-tag--${o}`]} ${St[`eds-tag--${i}`]} ${c}`
	}, p && T.createElement("div", { className: l }, T.createElement(A, {
		iconName: p,
		color: h
	})), T.createElement("span", { className: "eds-tag__label" }, s), m && T.createElement("div", { className: l }, T.createElement(A, {
		iconName: m,
		color: h
	})), f && T.createElement("button", {
		type: "button",
		onClick: function(e) {
			return u(e);
		},
		className: `${St["eds-tag__button"]}`
	}, T.createElement(A, { iconName: "close" }))));
}, Tt = E(Ct), Et = ({ children: e, href: t, sx: n }) => /* @__PURE__ */ O(v, {
	target: "_blank",
	rel: "noopener noreferrer",
	href: t,
	sx: {
		display: "inline-flex",
		...n
	},
	children: [e, /* @__PURE__ */ D(A, {
		iconName: "openInNew",
		size: "small"
	})]
}), Dt = ge(ae)(() => ({ whiteSpace: "nowrap" })), Ot = ({ children: e, onClick: t, disabled: n }) => /* @__PURE__ */ D("button", {
	type: "button",
	style: {
		backgroundColor: "transparent",
		border: "none",
		cursor: "pointer",
		display: "inline",
		fontSize: "inherit",
		color: "rgba(3, 93, 173, 1)",
		margin: 0,
		padding: 0
	},
	disabled: n,
	onClick: t,
	children: e
}), kt = ({ dialogComponent: e, when: t, breakAwayFunc: n, children: r }) => {
	let [i, a] = Ee(!1);
	return /* @__PURE__ */ O(Te, { children: [/* @__PURE__ */ D(e, {
		open: i,
		onCancel: () => {
			a(!1);
		},
		onLeave: () => {
			a(!1), n();
		}
	}), r(() => {
		(typeof t == "boolean" ? t : t()) ? a(!0) : n();
	})] });
}, At = E(({ onClose: e, disableCloseButton: n, children: r, ...i }) => /* @__PURE__ */ D(d, {
	...i,
	children: /* @__PURE__ */ O(t, {
		sx: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "center",
			flexGrow: 1
		},
		children: [/* @__PURE__ */ D(t, { children: r }), /* @__PURE__ */ D(t, { children: /* @__PURE__ */ D(bt, {
			type: "button",
			onClick: e,
			disabled: !e || n,
			icon: "close",
			color: "black",
			variant: "iconOnly"
		}) })]
	})
})), jt = () => {
	let e = ve();
	return _e(e.breakpoints.down("md"));
}, Mt = ({ open: e, onCancel: t, onLeave: n }) => {
	let r = jt();
	return /* @__PURE__ */ O(s, {
		open: e,
		onClose: t,
		fullWidth: !r,
		maxWidth: "sm",
		children: [
			/* @__PURE__ */ D(At, {
				onClose: t,
				disableCloseButton: !1,
				children: "編集内容の破棄"
			}),
			/* @__PURE__ */ D(l, { children: /* @__PURE__ */ D(u, {
				sx: { pt: 2 },
				children: "編集した内容は失われます。よろしいですか？"
			}) }),
			/* @__PURE__ */ O(c, { children: [/* @__PURE__ */ D(j, {
				type: "button",
				onClick: t,
				color: "primary",
				children: "編集を続ける"
			}), /* @__PURE__ */ D(j, {
				type: "button",
				onClick: n,
				color: "error",
				variant: "outlined",
				children: "破棄して移動する"
			})] })
		]
	});
}, Nt = ({ when: e, breakAwayFunc: t, children: n }) => /* @__PURE__ */ D(kt, {
	dialogComponent: Mt,
	when: e,
	breakAwayFunc: t,
	children: n
}), Pt = ({ when: e }) => {
	let [t, n] = we(), r = De(be(({ nextLocation: t }) => t.state === "allow" ? !1 : (typeof e == "boolean" ? e : e()) ? (n(t), !0) : !1, [e]));
	return /* @__PURE__ */ D(Mt, {
		open: t != null,
		onCancel: () => {
			n(void 0);
		},
		onLeave: () => {
			t != null && (n(void 0), r.state === "blocked" && r.proceed());
		}
	});
}, Ft = (e) => e.type === "checkbox", It = (e) => e.type === "file", Lt = (e) => e instanceof Date, M = (e) => e == null, Rt = (e) => typeof e == "object", N = (e) => !M(e) && !Array.isArray(e) && Rt(e) && !Lt(e), zt = (e) => N(e) && e.target ? Ft(e.target) ? e.target.checked : It(e.target) ? e.target.files : e.target.value : e, Bt = /[.[\]'"]/, Vt = (e) => e.split(Bt).filter(Boolean);
function Ht(e, t) {
	let n = Vt(t), r = e._formValues, i = e._defaultValues;
	for (let e = 0; e < n.length - 1; e++) {
		let t = n[e];
		if (r = r == null ? r : r[t], i = i == null ? i : i[t], r === null || i === null) return null;
	}
}
var Ut = (e, t) => t.split(".").some((t, n, r) => !isNaN(Number(t)) && e.has(r.slice(0, n).join("."))), Wt = typeof window < "u" && window.HTMLElement !== void 0 && typeof document < "u";
function P(e) {
	if (typeof e != "object" || !e) return e;
	if (e instanceof Date) return new Date(e);
	let t = typeof Blob < "u" && e instanceof Blob, n = typeof FileList < "u" && e instanceof FileList;
	if (Wt && (t || n)) return e;
	let r = Array.isArray(e);
	if (!r && e.constructor !== Object) return e;
	let i = r ? [] : Object.create(Object.getPrototypeOf(e));
	for (let t in e) Object.prototype.hasOwnProperty.call(e, t) && (i[t] = P(e[t]));
	return i;
}
var Gt = {
	BLUR: "blur",
	FOCUS_OUT: "focusout",
	CHANGE: "change",
	SUBMIT: "submit",
	TRIGGER: "trigger",
	VALID: "valid"
}, Kt = {
	onBlur: "onBlur",
	onChange: "onChange",
	onSubmit: "onSubmit",
	onTouched: "onTouched",
	all: "all"
}, F = {
	max: "max",
	min: "min",
	maxLength: "maxLength",
	minLength: "minLength",
	pattern: "pattern",
	required: "required",
	validate: "validate"
}, qt = [
	F.required,
	F.min,
	F.max,
	F.minLength,
	F.maxLength,
	F.pattern,
	F.validate
], Jt = "form", Yt = "root", Xt = [
	"__proto__",
	"constructor",
	"prototype"
], Zt = /^\w*$/, Qt = (e) => Zt.test(e), I = (e) => e === void 0, L = (e, t, n) => {
	if (!t || !N(e)) return n;
	let r = Qt(t) ? [t] : Vt(t);
	if (r.some((e) => Xt.includes(e))) return n;
	let i = r.reduce((e, t) => M(e) ? void 0 : e[t], e);
	return I(i) || i === e ? I(e[t]) ? n : e[t] : i;
}, $t = (e) => typeof e == "boolean", R = (e) => typeof e == "function", z = (e, t, n) => {
	let r = -1, i = Qt(t) ? [t] : Vt(t), a = i.length, o = a - 1;
	for (; ++r < a;) {
		let t = i[r], a = n;
		if (r !== o) {
			let n = e[t];
			a = N(n) || Array.isArray(n) ? n : isNaN(+i[r + 1]) ? {} : [];
		}
		if (Xt.includes(t)) return;
		e[t] = a, e = e[t];
	}
}, en = T.createContext(null);
en.displayName = "HookFormControlContext";
var tn = () => T.useContext(en), nn = (e, t, n, r = !0) => {
	let i = {};
	for (let a in e) Object.defineProperty(i, a, { get: () => {
		let i = a;
		return t._proxyFormState[i] !== Kt.all && (t._proxyFormState[i] = !r || Kt.all), n && (n[i] = !0), e[i];
	} });
	return i;
}, rn = Wt ? T.useLayoutEffect : T.useEffect, an = (e) => {
	let t = e.constructor && e.constructor.prototype;
	return N(t) && t.hasOwnProperty("isPrototypeOf");
}, on = (e) => M(e) || !Rt(e), sn = (e, t) => t.length === 0 && !Array.isArray(e) && !an(e);
function cn(e, t, n = /* @__PURE__ */ new WeakMap()) {
	if (e === t) return !0;
	if (on(e) || on(t)) return Object.is(e, t);
	if (Lt(e) && Lt(t)) return Object.is(e.getTime(), t.getTime());
	let r = Object.keys(e), i = Object.keys(t);
	if (r.length !== i.length) return !1;
	if (sn(e, r) || sn(t, i)) return Object.is(e, t);
	if (!r.length && Array.isArray(e) !== Array.isArray(t)) return !1;
	let a = n.get(e);
	if (a && a.has(t)) return !0;
	if (a) a.add(t);
	else {
		let r = /* @__PURE__ */ new WeakSet();
		r.add(t), n.set(e, r);
	}
	for (let i of r) {
		let r = e[i];
		if (!(i in t)) return !1;
		if (i !== "ref") {
			let e = t[i];
			if (Lt(r) && Lt(e) || (N(r) || Array.isArray(r)) && (N(e) || Array.isArray(e)) ? !cn(r, e, n) : !Object.is(r, e)) return !1;
		}
	}
	return !0;
}
function ln(e) {
	let t = T.useRef(!1), n = T.useRef(!1), r = T.useRef(void 0), i = T.useRef(0);
	return i.current++, !n.current && e && (n.current = !0, r.current = P(e())), {
		resyncIfNeeded: T.useCallback((e, a, o) => {
			if (e && (t.current || n.current && i.current > 1)) {
				let e = a();
				cn(r.current, e) || o(e);
			}
			t.current = !0;
		}, []),
		snapshot: T.useCallback((e, t) => {
			e && (r.current = P(t()));
		}, [])
	};
}
function un(e) {
	let t = tn(), { control: n = t, disabled: r, name: i, exact: a } = e || {}, o = () => ({
		...n._formState,
		defaultValues: n._defaultValues
	}), [s, c] = T.useState(o), l = T.useRef({
		isDirty: !1,
		isLoading: !1,
		dirtyFields: !1,
		touchedFields: !1,
		validatingFields: !1,
		isValidating: !1,
		isValid: !1,
		errors: !1
	}), { resyncIfNeeded: u, snapshot: d } = ln(o);
	return rn(() => {
		u(!r, o, c);
		let e = n._subscribe({
			name: i,
			formState: l.current,
			exact: a,
			callback: (e) => {
				!r && c({
					...n._formState,
					...e,
					defaultValues: n._defaultValues
				});
			}
		});
		return () => {
			e(), d(!r, o);
		};
	}, [
		n,
		i,
		r,
		a,
		u,
		d
	]), T.useEffect(() => {
		l.current.isValid && n._setValid(!0);
	}, [n]), T.useMemo(() => nn(s, n, l.current, !1), [s, n]);
}
var B = (e) => typeof e == "string", dn = (e, t, n, r, i) => B(e) ? (r && t.watch.add(e), L(n, e, i)) : Array.isArray(e) ? e.map((e) => (r && t.watch.add(e), L(n, e, L(i, e)))) : (r && (t.watchAll = !0), n);
function fn(e) {
	let t = tn(), { control: n = t, name: r, defaultValue: i, disabled: a, exact: o, compute: s } = e || {}, c = T.useRef(i), l = T.useRef(s), u = T.useRef(n), d = T.useRef(r);
	l.current = s;
	let f = () => {
		let e = n._getWatch(r, c.current);
		return l.current ? l.current(e) : e;
	}, [p, m] = T.useState(f), h = T.useRef(p), g = T.useCallback((e) => {
		let t = dn(r, n._names, e || n._formValues, !1, c.current);
		return l.current ? l.current(t) : t;
	}, [
		n._formValues,
		n._names,
		r
	]), _ = T.useCallback((e) => {
		if (!a) {
			let t = dn(r, n._names, e || n._formValues, !1, c.current);
			if (l.current) {
				let e = l.current(t);
				cn(e, h.current) || (m(e), h.current = e);
			} else m(t);
		}
	}, [
		n._formValues,
		n._names,
		a,
		r
	]), { resyncIfNeeded: v, snapshot: y } = ln(f), ee = T.useRef(_);
	ee.current = _;
	let b = T.useRef(g);
	b.current = g, rn(() => {
		u.current !== n || !cn(d.current, r) ? (u.current = n, d.current = r, ee.current()) : v(!a, () => b.current(), (e) => {
			m(e), h.current = e;
		});
		let e = n._subscribe({
			name: r,
			formState: { values: !0 },
			exact: o,
			callback: (e) => {
				ee.current(e.values);
			}
		});
		return () => {
			e(), y(!a, () => b.current());
		};
	}, [
		n,
		o,
		r,
		a,
		v,
		y
	]), T.useEffect(() => n._removeUnmounted());
	let x = u.current !== n, te = d.current;
	return T.useMemo(() => {
		if (a) return !1;
		let e = !x && !cn(te, r);
		return x || e;
	}, [
		a,
		x,
		r,
		te
	]) ? g() : p;
}
function pn(e) {
	let t = tn(), { name: n, disabled: r, control: i = t, shouldUnregister: a, defaultValue: o, exact: s = !0 } = e, c = Ut(i._names.array, n), l = fn({
		control: i,
		name: n,
		defaultValue: T.useMemo(() => {
			let e = L(i._formValues, n, L(i._defaultValues, n, o));
			return I(e) ? Ht(i, n) : e;
		}, [
			i,
			n,
			o
		]),
		exact: s
	}), u = un({
		control: i,
		name: n,
		exact: s
	}), d = T.useRef(e), f = T.useRef(null), p = T.useRef(i.register(n, {
		...e.rules,
		value: l,
		...$t(e.disabled) ? { disabled: e.disabled } : {}
	}));
	d.current = e;
	let m = T.useMemo(() => Object.defineProperties({}, {
		invalid: {
			enumerable: !0,
			get: () => !!L(u.errors, n)
		},
		isDirty: {
			enumerable: !0,
			get: () => !!L(u.dirtyFields, n)
		},
		isTouched: {
			enumerable: !0,
			get: () => !!L(u.touchedFields, n)
		},
		isValidating: {
			enumerable: !0,
			get: () => !!L(u.validatingFields, n)
		},
		error: {
			enumerable: !0,
			get: () => L(u.errors, n)
		}
	}), [u, n]), h = T.useCallback((e) => {
		let t = zt(e);
		return L(i._fields, n) || (p.current = i.register(n, {
			...d.current.rules,
			value: t
		})), p.current.onChange({
			target: {
				value: zt(e),
				name: n
			},
			type: Gt.CHANGE
		});
	}, [n, i]), g = T.useCallback(() => p.current.onBlur({
		target: {
			value: L(i._formValues, n),
			name: n
		},
		type: Gt.BLUR
	}), [n, i._formValues]), _ = T.useCallback((e) => {
		e && (f.current = {
			focus: () => R(e.focus) && e.focus(),
			select: () => R(e.select) && e.select(),
			setCustomValidity: (t) => R(e.setCustomValidity) && e.setCustomValidity(t),
			reportValidity: () => R(e.reportValidity) && e.reportValidity()
		});
		let t = L(i._fields, n);
		t && t._f && e && (t._f.ref = f.current, t._f._c = !0);
	}, [i._fields, n]), v = T.useMemo(() => ({
		name: n,
		value: l,
		...$t(r) || u.disabled ? { disabled: u.disabled || r } : {},
		onChange: h,
		onBlur: g,
		ref: _
	}), [
		n,
		r,
		u.disabled,
		h,
		g,
		_,
		l
	]);
	return T.useEffect(() => {
		let e = i._options.shouldUnregister || a;
		p.current = i.register(n, {
			...d.current.rules,
			...$t(d.current.disabled) ? { disabled: d.current.disabled } : {}
		});
		let t = (e, t) => {
			let n = L(i._fields, e);
			n && n._f && (n._f.mount = t, n._f._c = t);
		};
		if (t(n, !0), e) {
			let e = P(L(a ? i._defaultValues : i._options.values || i._defaultValues, n, L(i._options.defaultValues, n, d.current.defaultValue)));
			z(i._defaultValues, n, e), I(L(i._formValues, n)) && z(i._formValues, n, e);
		}
		if (!c && i.register(n, {
			...d.current.rules,
			...$t(d.current.disabled) ? { disabled: d.current.disabled } : {}
		}), f.current) {
			let e = L(i._fields, n);
			e && e._f && (e._f.ref = f.current);
		}
		return () => {
			(c ? e && !i._state.action : e) ? i.unregister(n) : t(n, !1);
		};
	}, [
		n,
		i,
		c,
		a
	]), T.useEffect(() => {
		i._setDisabledField({
			disabled: r,
			name: n
		});
	}, [
		r,
		n,
		i
	]), T.useMemo(() => ({
		field: v,
		formState: u,
		fieldState: m
	}), [
		v,
		u,
		m
	]);
}
var V = (e) => e.render(pn(e)), mn = ({ as: e, control: t, name: n, render: r }) => {
	let { errors: i } = un({
		control: t,
		name: n
	}), a = L(i, n);
	if (!a) return null;
	let o = a.message || "";
	return r ? r({
		message: o,
		messages: a.types
	}) : T.createElement(e || T.Fragment, null, o);
}, hn = () => typeof crypto < "u" && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
	let t = Math.random() * 16 | 0;
	return (e === "x" ? t : t & 3 | 8).toString(16);
}), gn = (e, t, n = {}) => n.shouldFocus || I(n.shouldFocus) ? n.focusName || `${e}.${I(n.focusIndex) ? t : n.focusIndex}.` : "", _n = (e) => ({
	isOnSubmit: !e || e === Kt.onSubmit,
	isOnBlur: e === Kt.onBlur,
	isOnChange: e === Kt.onChange,
	isOnAll: e === Kt.all,
	isOnTouch: e === Kt.onTouched
}), vn = (e, t, n) => {
	if (n) return !1;
	if (t.watchAll || t.watch.has(e)) return !0;
	for (let n of t.watch) if (e.startsWith(n) && e.charAt(n.length) === ".") return !0;
	return !1;
}, yn = (e, t, n) => {
	for (let r of n || Object.keys(e)) {
		if (r === "_f") continue;
		let i = n ? L(e, r) : e[r];
		if (i) {
			let { _f: e } = i;
			if (e) {
				if (e.refs && e.refs[0] && t(e.refs[0], e.name) || e.ref && t(e.ref, e.name) || yn(i, t)) return !0;
			} else if ((N(i) || Array.isArray(i)) && yn(i, t)) return !0;
		}
	}
}, bn = (e, t, n) => {
	let r = L(e, n), i = Array.isArray(r) ? r : [];
	return z(i, Yt, t[n]), z(e, n, i), e;
}, H = (e) => N(e) && !Object.keys(e).length, xn = (e) => {
	if (!Wt) return !1;
	let t = e ? e.ownerDocument : 0;
	return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, Sn = (e) => e.type === "radio", Cn = (e) => e instanceof RegExp, wn = (e, t, n, r, i) => t ? {
	...n[e],
	types: {
		...n[e] && n[e].types ? n[e].types : {},
		[r]: i || !0
	}
} : {}, Tn = {
	value: !1,
	isValid: !1
}, En = {
	value: !0,
	isValid: !0
}, Dn = (e) => {
	if (!Array.isArray(e)) return Tn;
	if (e.length > 1) {
		let t = e.filter((e) => e && e.checked && !e.disabled).map((e) => e.value);
		return {
			value: t,
			isValid: !!t.length
		};
	}
	let t = e[0];
	return !t || !t.checked || t.disabled ? Tn : !t.attributes || !("value" in t.attributes) || I(t.value) || t.value === "" ? En : {
		value: t.value,
		isValid: !0
	};
}, On = {
	isValid: !1,
	value: null
}, kn = (e) => Array.isArray(e) ? e.reduce((e, t) => t && t.checked && !t.disabled ? {
	isValid: !0,
	value: t.value
} : e, On) : On;
function An(e, t, n = "validate") {
	if (B(e) || Array.isArray(e) && e.every(B) || $t(e) && !e) return {
		type: n,
		message: B(e) ? e : "",
		ref: t
	};
}
var jn = (e) => N(e) && !Cn(e) ? e : {
	value: e,
	message: ""
}, Mn = async (e, t, n, r, i, a) => {
	let { ref: o, refs: s, required: c, maxLength: l, minLength: u, min: d, max: f, pattern: p, validate: m, name: h, valueAsNumber: g, mount: _, _c: v } = e._f, y = L(n, h);
	if (!_ || t.has(h)) return {};
	let ee = s ? s[0] : o, b = (e) => {
		if (i && ee.reportValidity) {
			let t = $t(e) ? "" : e || "";
			s ? s.forEach((e) => R(e.setCustomValidity) && e.setCustomValidity(t)) : ee.setCustomValidity(t), ee.reportValidity();
		}
	}, x = {}, te = Sn(o), S = Ft(o), ne = te || S, re = (g || It(o)) && I(o.value) && I(y) || xn(o) && o.value === "" && !v || y === "" || Array.isArray(y) && !y.length, ie = wn.bind(null, h, r, x), ae = (e, t, n, r = F.maxLength, i = F.minLength) => {
		let a = e ? t : n;
		x[h] = {
			type: e ? r : i,
			message: a,
			ref: o,
			...ie(e ? r : i, a)
		};
	};
	if (a ? !Array.isArray(y) || !y.length : c && (!ne && (re || M(y)) || $t(y) && !y || S && !Dn(s).isValid || te && !kn(s).isValid)) {
		let { value: e, message: t } = B(c) ? {
			value: !!c,
			message: c
		} : jn(c);
		if (e && (x[h] = {
			type: F.required,
			message: t,
			ref: ee,
			...ie(F.required, t)
		}, !r)) return b(t), x;
	}
	if (!re && (!M(d) || !M(f))) {
		let e, t, n = jn(f), i = jn(d);
		if (!M(y) && !Lt(y) && !isNaN(y)) {
			let r = o.valueAsNumber || y && +y;
			M(n.value) || (e = r > n.value), M(i.value) || (t = r < i.value);
		} else {
			let r = o.valueAsDate || new Date(y), a = (e) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + e), s = o.type == "time", c = o.type == "week";
			B(n.value) && y && (e = s ? a(y) > a(n.value) : c ? y > n.value : r > new Date(n.value)), B(i.value) && y && (t = s ? a(y) < a(i.value) : c ? y < i.value : r < new Date(i.value));
		}
		if ((e || t) && (ae(!!e, n.message, i.message, F.max, F.min), !r)) return b(x[h].message), x;
	}
	if ((l || u) && !re && (B(y) || a && Array.isArray(y))) {
		let e = jn(l), t = jn(u), n = !M(e.value) && y.length > +e.value, i = !M(t.value) && y.length < +t.value;
		if ((n || i) && (ae(n, e.message, t.message), !r)) return b(x[h].message), x;
	}
	if (p && !re && B(y)) {
		let { value: e, message: t } = jn(p);
		if (Cn(e) && !y.match(e) && (x[h] = {
			type: F.pattern,
			message: t,
			ref: o,
			...ie(F.pattern, t)
		}, !r)) return b(t), x;
	}
	if (m) {
		if (R(m)) {
			let e = An(await m(y, n), ee);
			if (e && (x[h] = {
				...e,
				...ie(F.validate, e.message)
			}, !r)) return b(e.message), x;
		} else if (N(m)) {
			let e = {};
			for (let t in m) {
				if (!H(e) && !r) break;
				let i = An(await m[t](y, n), ee, t);
				i && (e = {
					...i,
					...ie(t, i.message)
				}, r || b(i.message), r && (x[h] = e));
			}
			if (!H(e) && (x[h] = {
				ref: ee,
				...e
			}, !r)) return x;
		}
	}
	let oe = x[h];
	return b(!oe || oe.message), x;
}, Nn = (e) => Array.isArray(e) ? e : [e], Pn = (e, t) => [...e, ...Nn(t)], Fn = (e) => Array.isArray(e) ? e.map(() => void 0) : void 0;
function In(e, t, n) {
	return [
		...e.slice(0, t),
		...Nn(n),
		...e.slice(t)
	];
}
var Ln = (e, t, n) => Array.isArray(e) ? (I(e[n]) && (e[n] = void 0), e.splice(n, 0, e.splice(t, 1)[0]), e) : [], Rn = (e, t) => [...Nn(t), ...Nn(e)], zn = (e) => Array.isArray(e) ? e.filter(Boolean) : [];
function Bn(e, t) {
	let n = 0, r = [...e];
	for (let e of t) r.splice(e - n, 1), n++;
	return zn(r).length ? r : [];
}
var Vn = (e, t) => I(t) ? [] : Bn(e, Nn(t).sort((e, t) => e - t)), Hn = (e, t, n) => {
	[e[t], e[n]] = [e[n], e[t]];
};
function Un(e, t) {
	let n = t.length - 1, r = 0;
	for (; r < n;) {
		if (M(e)) {
			e = void 0;
			break;
		}
		e = e[t[r]], r++;
	}
	return e;
}
function Wn(e) {
	for (let t in e) if (e.hasOwnProperty(t) && !I(e[t])) return !1;
	return !0;
}
function U(e, t) {
	if (B(t) && Object.prototype.hasOwnProperty.call(e, t)) return delete e[t], e;
	let n = Array.isArray(t) ? t : Qt(t) ? [t] : Vt(t);
	if (n.some((e) => Xt.includes(String(e)))) return e;
	let r = n.length === 1 ? e : Un(e, n), i = n.length - 1, a = n[i];
	return r && delete r[a], i !== 0 && (N(r) && H(r) || Array.isArray(r) && Wn(r)) && U(e, n.slice(0, -1)), e;
}
var Gn = (e, t, n) => (e[t] = n, e);
function Kn(e) {
	let t = tn(), { control: n = t, name: r, keyName: i = "id", disabled: a, shouldUnregister: o, rules: s } = e, c = () => n._getFieldArray(r), [l, u] = T.useState(c), d = T.useRef(n._getFieldArray(r).map(hn)), f = T.useRef(!1), { resyncIfNeeded: p, snapshot: m } = ln(c), h = T.useRef(n), g = T.useRef(r);
	a || n._names.array.add(r), T.useMemo(() => !a && s && l.length >= 0 && n.register(r, s), [
		n,
		r,
		l.length,
		s,
		a
	]), rn(() => {
		if (a) return;
		if (h.current === n && g.current === r) p(!0, c, (e) => {
			u(e), d.current = e.map(hn);
		});
		else {
			h.current = n, g.current = r;
			let e = c();
			cn(l, e) || (u(e), d.current = e.map(hn)), m(!0, c);
		}
		let e = n._subjects.array.subscribe({ next: ({ values: e, name: t }) => {
			if (t === r || !t) {
				let n = L(e, r);
				Array.isArray(n) ? (u(n), d.current = n.map(hn)) : t || (u([]), d.current = []);
			}
		} }).unsubscribe;
		return () => {
			e(), m(!0, c);
		};
	}, [
		n,
		r,
		a,
		p,
		m
	]);
	let _ = T.useCallback((e) => {
		f.current = !0, n._setFieldArray(r, e);
	}, [n, r]);
	return T.useEffect(() => {
		if (a) {
			n._state.actionArrayLengths.delete(r);
			return;
		}
		n._state.action = !1, n._state.actionArrayLengths.delete(r), vn(r, n._names) && n._subjects.state.next({ ...n._formState });
		let e = _n(n._options.mode);
		if (f.current && (!e.isOnSubmit || n._formState.isSubmitted) && !_n(n._options.reValidateMode).isOnSubmit && !e.isOnBlur) {
			if (n._options.resolver) n._runSchema([r]).then((e) => {
				n._updateIsValidating([r]);
				let t = L(e.errors, r), i = L(n._formState.errors, r), a = i && (i.type || i.root?.type), o = i && (i.message || i.root?.message);
				(i ? !t && a || t && (a !== t.type || o !== t.message) : t && t.type) && (t ? N(t) && !Object.keys(t).some((e) => !Number.isNaN(+e)) ? bn(n._formState.errors, { [r]: t }, r) : z(n._formState.errors, r, t) : U(n._formState.errors, r), n._subjects.state.next({ errors: n._formState.errors }));
			});
			else {
				let e = L(n._fields, r);
				e && e._f && Mn(e, n._names.disabled, n._formValues, n._options.criteriaMode === Kt.all, n._options.shouldUseNativeValidation, !0).then((e) => {
					if (!H(e)) n._subjects.state.next({ errors: bn(n._formState.errors, e, r) });
					else {
						let e = L(n._formState.errors, r);
						e && e[Yt] && (U(n._formState.errors, `${r}.${Yt}`), n._subjects.state.next({ errors: n._formState.errors }));
					}
				});
			}
		}
		f.current && n._subjects.state.next({
			name: r,
			values: P(n._formValues)
		}), n._names.focus && yn(n._fields, (e, t) => {
			if (n._names.focus && t.startsWith(n._names.focus) && e.focus) return e.focus(), 1;
		}), n._names.focus = "", n._setValid(), f.current = !1;
	}, [
		l,
		r,
		n,
		a
	]), T.useEffect(() => (a || I(L(n._formValues, r)) && n._setFieldArray(r), () => {
		if (n._state.actionArrayLengths.delete(r), a) return;
		let e = !(n._options.shouldUnregister || o);
		f.current && e && n._subjects.state.next({
			name: r,
			values: P(n._formValues)
		}), e ? ((e, t) => {
			let r = L(n._fields, e);
			r && r._f && (r._f.mount = t);
		})(r, !1) : n.unregister(r);
	}), [
		r,
		n,
		i,
		o,
		a
	]), {
		swap: T.useCallback((e, t) => {
			if (a) return;
			let i = n._getFieldArray(r);
			Hn(i, e, t), Hn(d.current, e, t), _(i), u(i), n._setFieldArray(r, i, Hn, {
				argA: e,
				argB: t
			}, !1);
		}, [
			_,
			r,
			n,
			a
		]),
		move: T.useCallback((e, t) => {
			if (a) return;
			let i = n._getFieldArray(r);
			Ln(i, e, t), Ln(d.current, e, t), _(i), u(i), n._setFieldArray(r, i, Ln, {
				argA: e,
				argB: t
			}, !1);
		}, [
			_,
			r,
			n,
			a
		]),
		prepend: T.useCallback((e, t) => {
			if (a) return;
			let i = Nn(P(e)), o = Rn(n._getFieldArray(r), i);
			n._names.focus = gn(r, 0, t), d.current = Rn(d.current, i.map(hn)), _(o), u(o), n._setFieldArray(r, o, Rn, { argA: Fn(e) });
		}, [
			_,
			r,
			n,
			a
		]),
		append: T.useCallback((e, t) => {
			if (a) return;
			let i = Nn(P(e)), o = Pn(n._getFieldArray(r), i);
			n._names.focus = gn(r, o.length - 1, t), d.current = Pn(d.current, i.map(hn)), _(o), u(o), n._setFieldArray(r, o, Pn, { argA: Fn(e) });
		}, [
			_,
			r,
			n,
			a
		]),
		remove: T.useCallback((e) => {
			if (a) return;
			let t = Vn(n._getFieldArray(r), e);
			d.current = Vn(d.current, e), _(t), u(t), !Array.isArray(L(n._fields, r)) && z(n._fields, r, void 0), n._setFieldArray(r, t, Vn, { argA: e });
		}, [
			_,
			r,
			n,
			a
		]),
		insert: T.useCallback((e, t, i) => {
			if (a) return;
			let o = Nn(P(t)), s = In(n._getFieldArray(r), e, o);
			n._names.focus = gn(r, e, i), d.current = In(d.current, e, o.map(hn)), _(s), u(s), n._setFieldArray(r, s, In, {
				argA: e,
				argB: Fn(t)
			});
		}, [
			_,
			r,
			n,
			a
		]),
		update: T.useCallback((e, t) => {
			if (a) return;
			let i = P(t), o = Gn(n._getFieldArray(r), e, i);
			d.current = [...o].map((t, n) => !t || n === e ? hn() : d.current[n]), _(o), u([...o]), n._setFieldArray(r, o, Gn, {
				argA: e,
				argB: Fn(t)
			});
		}, [
			_,
			r,
			n,
			a
		]),
		replace: T.useCallback((e) => {
			if (a) return;
			let t = Nn(P(e));
			d.current = t.map(hn), _([...t]), u([...t]), n._setFieldArray(r, [...t], (e) => Array.isArray(e) ? e.slice(0, t.length) : e, {});
		}, [
			_,
			r,
			n,
			a
		]),
		fields: T.useMemo(() => l.map((e, t) => ({
			...e,
			...$t(a) ? { disabled: a } : {},
			[i]: d.current[t] || hn()
		})), [
			l,
			i,
			a
		])
	};
}
var qn = (e) => e.render(Kn(e)), Jn = (e) => typeof Blob < "u" && e instanceof Blob || typeof File < "u" && e instanceof File, Yn = (e) => typeof FileList < "u" && e instanceof FileList, Xn = (e) => {
	let t = {};
	for (let n of Object.keys(e)) if (Rt(e[n]) && e[n] !== null && !Lt(e[n]) && !Jn(e[n]) && !Yn(e[n])) {
		let r = Xn(e[n]);
		for (let e of Object.keys(r)) t[`${n}.${e}`] = r[e];
	} else t[n] = e[n];
	return t;
};
function Zn(e) {
	let t = new FormData(), n = Xn(e);
	for (let e in n) {
		let r = n[e];
		if (!I(r)) {
			if (typeof FileList < "u" && r instanceof FileList) {
				for (let n = 0; n < r.length; n++) {
					let i = r[n];
					i && t.append(e, i);
				}
				continue;
			}
			t.append(e, r);
		}
	}
	return t;
}
function Qn(e) {
	try {
		return JSON.stringify(e);
	} catch {
		return "";
	}
}
function $n() {}
var er = T.createContext(null);
er.displayName = "HookFormContext";
var tr = () => T.useContext(er), nr = ({ children: e, watch: t, getValues: n, getErrors: r, getFieldState: i, setError: a, clearErrors: o, setValue: s, setValues: c, trigger: l, formState: u, resetField: d, reset: f, resetDefaultValues: p, handleSubmit: m, unregister: h, control: g, register: _, setFocus: v, subscribe: y }) => {
	let ee = T.useMemo(() => ({
		watch: t,
		getValues: n,
		getErrors: r,
		getFieldState: i,
		setError: a,
		clearErrors: o,
		setValue: s,
		setValues: c,
		trigger: l,
		formState: u,
		resetField: d,
		reset: f,
		resetDefaultValues: p,
		handleSubmit: m,
		unregister: h,
		control: g,
		register: _,
		setFocus: v,
		subscribe: y
	}), [
		o,
		g,
		u,
		r,
		i,
		n,
		m,
		_,
		f,
		p,
		d,
		a,
		v,
		s,
		c,
		y,
		l,
		h,
		t
	]);
	return T.createElement(er.Provider, { value: ee }, T.createElement(en.Provider, { value: ee.control }, e));
}, rr = "post";
function ir(e) {
	return e >= 200 && e < 300;
}
function ar(e) {
	let t = tr(), [n, r] = T.useState(!1), { control: i = t.control, onSubmit: a = $n, children: o, action: s, method: c = rr, headers: l, encType: u, onError: d = $n, render: f, onSuccess: p = $n, validateStatus: m = ir, ...h } = e, g = T.useMemo(() => i.handleSubmit(async (e, t) => {
		let n = Zn(e), r = Qn(e);
		if (a && await a({
			data: e,
			event: t,
			method: c,
			formData: n,
			formDataJson: r
		}), B(s)) try {
			let e = l && l["Content-Type"] && l["Content-Type"].includes("json") || u && u.includes("json"), t = await fetch(s, {
				method: c,
				headers: {
					...l,
					...u && u !== "multipart/form-data" && { "Content-Type": u }
				},
				body: e ? r : n
			});
			if (t && !m(t.status)) return d({ response: t }), { type: String(t.status) };
			p({ response: t });
		} catch (e) {
			return d({ error: e }), { type: "" };
		}
		if (R(s)) try {
			await s(n);
		} catch (e) {
			return d({ error: e }), { type: "" };
		}
	}), [
		i,
		a,
		c,
		s,
		l,
		u,
		m,
		d,
		p
	]), _ = T.useCallback(async (e) => {
		let t = await g(e);
		t && i && (i._subjects.state.next({ isSubmitSuccessful: !1 }), i.setError("root.server", t));
	}, [g, i]);
	return T.useEffect(() => {
		r(!0);
	}, []), f ? f({ submit: _ }) : T.createElement("form", {
		noValidate: n,
		action: s,
		...!R(s) && {
			method: c,
			encType: u
		},
		onSubmit: _,
		...h
	}, o);
}
var or = ({ control: e, disabled: t, exact: n, name: r, render: i }) => i(un({
	control: e,
	name: r,
	disabled: t,
	exact: n
})), sr = or, cr = () => {
	let e = [];
	return {
		get observers() {
			return e;
		},
		next: (t) => {
			for (let n of e) n.next && n.next(t);
		},
		subscribe: (t) => (e.push(t), { unsubscribe: () => {
			e = e.filter((e) => e !== t);
		} }),
		unsubscribe: () => {
			e = [];
		}
	};
};
function lr(e, t) {
	let n = Array.isArray(e) ? [] : {};
	for (let r in e) if (e.hasOwnProperty(r)) {
		let i = e[r], a = t[r];
		i && (N(i) || Array.isArray(i)) && a ? n[r] = lr(i, a) : e[r] && (n[r] = a);
	}
	return n;
}
var ur = (e, t) => e !== null && Rt(e) && Object.prototype.hasOwnProperty.call(e, t), dr = (e, t) => {
	if (!t) return !1;
	let n = e;
	for (let r of Qt(t) ? [t] : Vt(t)) {
		if (!ur(n, r)) return ur(e, t);
		n = n[r];
	}
	return !0;
}, fr = (e) => e.type === "select-multiple", pr = (e) => Sn(e) || Ft(e), mr = (e) => xn(e) && e.isConnected;
function hr(e) {
	return Array.isArray(e) || N(e);
}
function gr(e, t, n = "", r = []) {
	for (let i in e) {
		let a = n ? `${n}.${i}` : i, o = e[i];
		hr(o) && hr(L(t, a)) ? gr(o, t, a, r) : r.push(a);
	}
	return r;
}
var _r = (e) => {
	for (let t in e) if (R(e[t])) return !0;
	return !1;
};
function vr(e) {
	return Array.isArray(e) || N(e) && !_r(e);
}
function yr(e) {
	return !!(e && "_f" in e);
}
function br(e) {
	return Array.isArray(e) ? !e.some((e) => !I(e)) : !Object.keys(e).length;
}
function xr(e, t) {
	Array.isArray(e) ? e[t] = void 0 : delete e[t];
}
function Sr(e, t = {}, n) {
	for (let r in e) {
		let i = e[r], a = n && n[r];
		vr(i) && (!Array.isArray(i) || !yr(a)) ? (t[r] = Array.isArray(i) ? [] : {}, Sr(i, t[r], a), br(t[r]) && xr(t, r)) : I(i) || (t[r] = !0);
	}
	return t;
}
function Cr(e, t, n, r) {
	n ||= Sr(t, {}, r);
	for (let i in e) {
		let a = e[i], o = r && r[i];
		vr(a) && (!Array.isArray(a) || !yr(o)) ? (I(t) || on(n[i]) ? n[i] = Sr(a, Array.isArray(a) ? [] : {}, o) : Cr(a, M(t) ? {} : t[i], n[i], o), br(n[i]) && xr(n, i)) : cn(a, t[i]) ? xr(n, i) : n[i] = !0;
	}
	return n;
}
var wr = (e, t) => {
	let n = t.split("."), r = [], i = n[0];
	for (let t = 1; t < n.length; i += "." + n[t++]) !isNaN(+n[t]) && e.has(i) && r.push(`${i}.${n[t]}`);
	return r;
}, Tr = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => I(e) ? e : t ? e === "" ? NaN : e && +e : n && B(e) ? new Date(e) : r ? r(e) : e;
function Er(e) {
	let t = e.ref;
	return It(t) ? t.files : Sn(t) ? kn(e.refs).value : fr(t) ? [...t.selectedOptions].map(({ value: e }) => e) : Ft(t) ? Dn(e.refs).value : Tr(t.value, e);
}
var Dr = (e, t, n, r) => {
	let i = {};
	for (let n of e) {
		let e = L(t, n);
		e && z(i, n, e._f);
	}
	return {
		criteriaMode: n,
		names: [...e],
		fields: i,
		shouldUseNativeValidation: r
	};
}, Or = (e) => I(e) ? e : Cn(e) ? e.source : N(e) ? Cn(e.value) ? e.value.source : e.value : e, kr = "AsyncFunction", Ar = (e) => {
	if (!e || !e.validate) return !1;
	if (R(e.validate)) return e.validate.constructor.name === kr;
	if (N(e.validate)) {
		for (let t in e.validate) if (e.validate[t].constructor.name === kr) return !0;
	}
	return !1;
}, jr = (e) => e.mount && (e.required || !I(e.required) && e.required !== !1 || !I(e.min) || !I(e.max) || !I(e.maxLength) || !I(e.minLength) || e.pattern || e.validate);
function Mr(e, t, n) {
	let r = L(e, n);
	if (r?.type || r?.message || Array.isArray(r)) return {
		error: r,
		name: n
	};
	let i = n.split(".");
	for (; i.length;) {
		let r = i.join("."), a = L(t, r), o = L(e, r);
		if (a && !Array.isArray(a) && n !== r) return { name: n };
		if (o && o.type) return {
			name: r,
			error: o
		};
		if (o && o.root && o.root.type) return {
			name: `${r}.root`,
			error: o.root
		};
		i.pop();
	}
	return { name: n };
}
var Nr = (e, t, n, r) => {
	n(e);
	let i = Object.keys(e).filter((e) => e !== "name");
	return !i.length || r && i.length >= Object.keys(t).length || i.find((e) => t[e] === (!r || Kt.all));
}, Pr = (e, t, n) => !e || !t || e === t || Nn(e).some((e) => e && (n ? e === t || e.startsWith(t + ".") : e.startsWith(t) || t.startsWith(e))), Fr = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : !(n ? r.isOnChange : i.isOnChange) || e, Ir = (e, t) => {
	let n = L(e, t);
	!zn(n).length && !(n != null && n.root) && U(e, t);
}, Lr = {
	mode: Kt.onSubmit,
	reValidateMode: Kt.onChange,
	shouldFocusError: !0
}, Rr = (e, t) => {
	for (let n in e) n in t || delete e[n];
	Object.assign(e, t);
}, zr = {
	submitCount: 0,
	isDirty: !1,
	isReady: !1,
	isValidating: !1,
	isSubmitted: !1,
	isSubmitting: !1,
	isSubmitSuccessful: !1,
	isValid: !1,
	touchedFields: {},
	dirtyFields: {},
	validatingFields: {}
};
function Br(e = {}) {
	let t = {
		...Lr,
		...e
	}, n = {
		...P(zr),
		isLoading: R(t.defaultValues),
		errors: t.errors || {},
		disabled: t.disabled || !1
	}, r = {}, i = (N(t.defaultValues) || N(t.values)) && P(t.defaultValues || t.values) || {}, a = t.shouldUnregister ? {} : P(i), o = {
		action: !1,
		actionArrayLengths: /* @__PURE__ */ new Map(),
		mount: !1,
		watch: !1,
		keepIsValid: !1
	}, s = {
		mount: /* @__PURE__ */ new Set(),
		disabled: /* @__PURE__ */ new Set(),
		unMount: /* @__PURE__ */ new Set(),
		array: /* @__PURE__ */ new Set(),
		watch: /* @__PURE__ */ new Set(),
		registerName: /* @__PURE__ */ new Set()
	}, c = {}, l = {}, u = 0, d = _n(t.mode), f = _n(t.reValidateMode), p = {
		isDirty: !1,
		dirtyFields: !1,
		validatingFields: !1,
		touchedFields: !1,
		isValidating: !1,
		isValid: !1,
		errors: !1
	}, m = { ...p }, h = { ...m }, g = (...e) => e.some((e) => m[e] || h[e]), _ = {
		array: cr(),
		state: cr()
	}, v = 0, y = 0, ee = t.criteriaMode === Kt.all, b = (e, t) => (n) => {
		clearTimeout(l[e]), l[e] = setTimeout(t, n);
	}, x = (e) => {
		clearTimeout(l[e]), delete l[e], delete c[e];
	}, te = (e) => {
		x(e);
		let t = `${e}.`;
		for (let e of Object.keys(c)) e.startsWith(t) && x(e);
	}, S = async (e) => {
		if (!o.keepIsValid && !t.disabled && (g("isValid") || e)) {
			let e = ++v, i;
			t.resolver ? (i = H((await de()).errors), e === v && ne()) : i = await me({
				fields: r,
				onlyCheckValid: !0,
				eventType: Gt.VALID
			}), e === v && i !== n.isValid && _.state.next({ isValid: i });
		}
	}, ne = (e, r) => {
		!t.disabled && g("isValidating", "validatingFields") && ((e || s.mount).forEach((e) => {
			e && (r ? z(n.validatingFields, e, r) : U(n.validatingFields, e));
		}), _.state.next({
			validatingFields: n.validatingFields,
			isValidating: !H(n.validatingFields)
		}));
	}, re = () => {
		n.dirtyFields = Cr(i, a, void 0, r);
	}, ie = (e, i = [], s, c, l = !0, u = !0) => {
		if (c && s && !t.disabled) {
			o.action = !0;
			let t = L(r, e);
			if (o.actionArrayLengths.has(e) || o.actionArrayLengths.set(e, Array.isArray(t) ? t.length : 0), u && Array.isArray(t)) {
				let n = s(t, c.argA, c.argB);
				l && z(r, e, n);
			}
			let a = L(n.errors, e);
			if (u && Array.isArray(a)) {
				let t = a.root, r = s(a, c.argA, c.argB) || a;
				t && (r.root = t), l && z(n.errors, e, r), Ir(n.errors, e);
			}
			let d = L(n.touchedFields, e), f = u && Array.isArray(d);
			if (f) {
				let t = s(d, c.argA, c.argB);
				l && z(n.touchedFields, e, t);
			}
			let p = L(n.dirtyFields, e);
			if (u && Array.isArray(p)) {
				let t = s(p, c.argA, c.argB) || p;
				l && z(n.dirtyFields, e, t);
			}
			g("dirtyFields") && re(), _.state.next({
				name: e,
				isDirty: ge(e, i),
				dirtyFields: n.dirtyFields,
				...f && { touchedFields: n.touchedFields },
				errors: n.errors,
				isValid: n.isValid
			});
		} else z(a, e, i);
	}, ae = (e, t) => {
		z(n.errors, e, t), n.errors = { ...n.errors }, _.state.next({ errors: n.errors });
	}, oe = (e) => {
		Object.keys(c).forEach(x);
		let t = !H(e);
		n.errors = e, _.state.next({
			errors: n.errors,
			...t ? { isValid: !1 } : {}
		}), !t && o.mount && S();
	}, se = (e) => {
		let t = Qt(e) ? [e] : Vt(e), n = a, r = i;
		for (let e = 0; e < t.length - 1; e++) {
			let i = t[e];
			if (n = M(n) ? n : n[i], r = M(r) ? r : r[i], n === null && r !== null) return !0;
		}
		return !1;
	}, ce = (e) => {
		if (!o.actionArrayLengths.size) return !1;
		let t = Qt(e) ? [e] : Vt(e), n = a, r = "", i = -1, s = 0;
		for (let e = 0; e < t.length; e++) {
			if (M(n)) return !1;
			let a = t[e];
			if (r = r ? `${r}.${a}` : a, Array.isArray(n) && +a >= n.length) return i === -1 ? !1 : e !== i || +a < s;
			if (o.actionArrayLengths.has(r) && (i = e + 1, s = o.actionArrayLengths.get(r)), n = n[a], I(n) && i !== -1 && e > i && +t[i] < s) return !0;
		}
		return !1;
	}, le = (c, l, u, d) => {
		let f = L(r, c);
		if (f) {
			if (se(c) || ce(c)) return;
			let r = I(L(a, c)), p = L(a, c, I(u) ? L(i, c) : u);
			I(p) || d && d.defaultChecked || l ? z(a, c, l ? p : Er(f._f)) : w(c, p), o.mount && !o.action && (t.resolver && g("isValidating", "validatingFields") ? Promise.resolve().then(() => S()) : S(), r && n.isDirty && g("isDirty") && (ge() || (n.isDirty = !1, _.state.next({ ...n }))), e.shouldUnregister && r && !I(L(a, c)) && vn(c, s) && (o.watch = !0));
		}
	}, C = (e, o, s, c, l) => {
		let u = !1, d = !1, f = { name: e };
		if (!t.disabled || c === !0) {
			if (!s || c) {
				let t = cn(L(i, e), o);
				g("isDirty") && (d = n.isDirty, n.isDirty = f.isDirty = !t || ge(), u = d !== f.isDirty), d = !!L(n.dirtyFields, e), t === n.isDirty ? t ? U(n.dirtyFields, e) : z(n.dirtyFields, e, !0) : Rr(n.dirtyFields, Cr(i, a, void 0, r)), f.dirtyFields = n.dirtyFields, u ||= g("dirtyFields") && d !== !t;
			}
			if (s) {
				let t = L(n.touchedFields, e);
				t || (z(n.touchedFields, e, s), f.touchedFields = n.touchedFields, u ||= g("touchedFields") && t !== s);
			}
			u && l && _.state.next(f);
		}
		return u ? f : {};
	}, ue = (e, r, i, a) => {
		let o = L(n.errors, e), s = g("isValid") && $t(r) && n.isValid !== r;
		if (t.delayError && i ? (c[e] = b(e, () => ae(e, i)), c[e](t.delayError)) : (x(e), i ? z(n.errors, e, i) : U(n.errors, e), n.errors = { ...n.errors }), (i ? !cn(o, i) : o) || !H(a) || s) {
			let t = {
				...a,
				...s && $t(r) ? { isValid: r } : {},
				errors: n.errors,
				name: e
			};
			_.state.next(t);
		}
	}, de = async (e) => (ne(e, !0), await t.resolver(a, t.context, Dr(e || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation))), fe = async (e) => {
		let t = y, { errors: i } = await de(e);
		if (t !== y) return i;
		if (ne(e), e) {
			for (let t of e) {
				let e = L(i, t);
				te(t);
				let a = s.array.has(t) && N(e) && !Object.keys(e).some((e) => !Number.isNaN(Number(e))), o = L(r, t), c = N(o) && Object.keys(o).some((e) => e !== "_f");
				a ? bn(n.errors, { [t]: e }, t) : e?.type || e?.message || Array.isArray(e) || N(e) && c ? z(n.errors, t, e) : U(n.errors, t);
			}
			n.errors = { ...n.errors };
		} else Object.keys(c).forEach(x), n.errors = i;
		return i;
	}, pe = async ({ name: e, eventType: r }) => {
		if (t.validate) {
			let i = y, o = await t.validate({
				formValues: a,
				formState: n,
				name: e,
				eventType: r
			});
			if (i !== y) return !0;
			if (N(o)) {
				let e = !0;
				O(Jt);
				for (let t in o) {
					let n = o[t];
					n && (e = !1, Ee(`${Jt}.${t}`, {
						message: B(n.message) ? n.message : "",
						type: n.type || F.validate
					}));
				}
				return e;
			}
			return B(o) || !o ? (Ee(Jt, {
				message: o || "",
				type: F.validate
			}), !1) : (O(Jt), !0);
		}
		return !0;
	}, me = async ({ fields: r, onlyCheckValid: i, name: o, eventType: c, context: l = {
		valid: !0,
		runRootValidation: !1
	} }) => {
		let u = y;
		if (t.validate && !l.runRootValidation && (l.runRootValidation = !0, !await pe({
			name: o,
			eventType: c
		}) && (l.valid = !1, i))) return l.valid;
		for (let o in r) {
			let d = r[o];
			if (d) {
				let { _f: r, ...f } = d;
				if (r) {
					let o = s.array.has(r.name), c = d._f && Ar(d._f), f = g("isValidating", "validatingFields");
					c && f && ne([r.name], !0);
					let p = await Mn(d, s.disabled, a, ee, t.shouldUseNativeValidation && !i, o);
					if (u !== y) return l.valid;
					if (c && f && ne([r.name]), p[r.name] && (l.valid = !1, i) || (i || (x(r.name), L(p, r.name) ? o ? bn(n.errors, p, r.name) : z(n.errors, r.name, p[r.name]) : U(n.errors, r.name)), e.shouldUseNativeValidation && p[r.name])) break;
				}
				!H(f) && await me({
					context: l,
					onlyCheckValid: i,
					fields: f,
					name: o,
					eventType: c
				});
			}
		}
		return l.valid;
	}, he = () => {
		for (let e of s.unMount) {
			let t = L(r, e);
			t && (t._f.refs ? t._f.refs.every((e) => !mr(e)) : !mr(t._f.ref)) && Ae(e);
		}
		s.unMount = /* @__PURE__ */ new Set();
	}, ge = (e, t) => (e && t && z(a, e, t), !cn(o.mount ? a : i, i)), _e = (e, t, n) => dn(e, s, { ...o.mount ? a : I(t) || B(e) ? i : t }, n, t), ve = (e) => zn(L(o.mount ? a : i, e, t.shouldUnregister ? L(i, e, []) : [])), w = (e, t, n = {}, i = !1, o = !1, s = !1) => {
		let c = L(r, e), l = t;
		if (c) {
			let n = c._f;
			n && (!n.disabled && z(a, e, Tr(t, n)), l = xn(n.ref) && M(t) ? "" : t, fr(n.ref) ? [...n.ref.options].forEach((e) => e.selected = l.includes(e.value)) : n.refs ? Ft(n.ref) ? n.refs.forEach((e) => {
				(!e.defaultChecked || !e.disabled) && (e.checked = Array.isArray(l) ? !!l.find((t) => t === e.value) : l === e.value || !!l);
			}) : n.refs.forEach((e) => e.checked = e.value === l) : It(n.ref) ? n.ref.value = "" : (n.ref.value = l, !n.ref.type && !o && !s && _.state.next({
				name: e,
				values: i ? a : P(a)
			})));
		}
		(n.shouldDirty || n.shouldTouch) && C(e, c && c._f && !c._f.disabled && (c._f.valueAsNumber || c._f.valueAsDate || c._f.setValueAs) ? Tr(t, c._f) : l, n.shouldTouch, n.shouldDirty, !o), n.shouldValidate && Ce(e, { delayError: n.delayError }), n.shouldValidate && c && c._f && c._f.deps && (!Array.isArray(c._f.deps) || c._f.deps.length > 0) && Ce(c._f.deps);
	}, T = (e, t, n, i = !1, o = !1, c = !1) => {
		s.array.has(e) && _.array.next({
			name: e,
			values: i ? a : P(a)
		});
		for (let a in t) {
			if (!t.hasOwnProperty(a)) continue;
			let l = t[a], u = e + "." + a, d = L(r, u);
			(s.array.has(e) || N(l) || d && !d._f) && !Lt(l) ? T(u, l, n, i, o, c) : w(u, l, n, i, o, c);
		}
	}, ye = (e, t, i, c, l = !1) => {
		let u = L(r, e), d = s.array.has(e), f = c ? t : P(t), p = cn(L(a, e), f);
		if (p || z(a, e, f), d) _.array.next({
			name: e,
			values: c ? a : P(a)
		}), g("isDirty", "dirtyFields") && i.shouldDirty && (re(), l || _.state.next({
			name: e,
			dirtyFields: n.dirtyFields,
			isDirty: ge(e, f)
		})), i.shouldValidate && Ce(e, { delayError: i.delayError });
		else {
			let t = Array.isArray(f) && !f.length || H(f), n = !p && !l;
			!u || u._f || M(f) || t ? w(e, f, i, c, l, n) : T(e, f, i, c, l, n);
		}
		if (!p && !l) {
			let t = vn(e, s), r = c ? a : P(a);
			if (_.state.next({
				...t && n,
				name: o.mount || t ? e : void 0,
				values: r
			}), !d) for (let t of wr(s.array, e)) _.state.next({
				name: t,
				values: r
			});
		}
	}, E = (e, t, n = {}) => ye(e, t, n, !1), be = (e, t = {}) => {
		let r = R(e) ? e(a) : e;
		if (!cn(a, r)) {
			a = {
				...a,
				...r
			};
			for (let e of s.mount) dr(r, e) && ye(e, L(r, e), t, !0, !0);
			_.state.next({
				...n,
				name: void 0,
				type: void 0,
				...u ? { values: a } : {}
			}), t.shouldValidate && S();
		}
	}, xe = async (e) => {
		o.mount = !0;
		let i = e.target, l = i.name, p = !0, m = L(r, l), h = (e) => {
			p = Number.isNaN(e) || Lt(e) && isNaN(e.getTime()) || cn(e, L(a, l, e));
		};
		if (m) {
			let o, v, b = i.type ? Er(m._f) : zt(e), x = e.type === Gt.BLUR || e.type === Gt.FOCUS_OUT, te = !jr(m._f) && !t.validate && !t.resolver && !L(n.errors, l) && !m._f.deps, re = te || Fr(x, L(n.touchedFields, l), n.isSubmitted, f, d), ie = vn(l, s, x);
			if (z(a, l, P(b)), x) {
				if (!i || !i.readOnly) {
					m._f.onBlur && m._f.onBlur(e);
					let t = c[l];
					t && t(0);
				}
			} else m._f.onChange && m._f.onChange(e);
			let ae = C(l, b, x), oe = !H(ae) || ie;
			if (!x && _.state.next({
				name: l,
				type: e.type,
				...u ? { values: P(a) } : {}
			}), re) return (!te || !n.isValid) && g("isValid") && (t.mode === "onBlur" ? x && S() : x || S()), oe && _.state.next({
				name: l,
				...ie ? {} : ae
			});
			if (!t.resolver && t.validate && await pe({
				name: l,
				eventType: e.type
			}), !x && ie && _.state.next({ ...n }), t.resolver) {
				let e = y, { errors: t } = await de([l]);
				if (e !== y) return;
				if (ne([l]), h(b), !p) {
					!H(ae) && _.state.next(ae);
					return;
				}
				let i = Mr(n.errors, r, l), a = Mr(t, r, i.name || l);
				o = a.error, l = a.name, v = H(t);
			} else {
				let n = y;
				if (ne([l], !0), o = (await Mn(m, s.disabled, a, ee, t.shouldUseNativeValidation))[l], n !== y) return;
				if (ne([l]), h(b), p) {
					if (o) v = !1;
					else if (g("isValid") && (v = await me({
						fields: r,
						onlyCheckValid: !0,
						name: l,
						eventType: e.type
					}), n !== y)) return;
				}
			}
			p && (m._f.deps && (!Array.isArray(m._f.deps) || m._f.deps.length > 0) && Ce(m._f.deps), ue(l, v, o, ae));
		}
	}, Se = (e, t) => {
		if (L(n.errors, t) && e.focus) return e.focus(), 1;
	}, Ce = async (e, i = {}) => {
		let a, o, l = Nn(e);
		if (t.resolver) {
			let t = y, n = await fe(I(e) ? e : l);
			if (a = H(n), o = e ? !l.some((e) => L(n, e)) : a, t !== y) return o;
		} else e ? (o = (await Promise.all(l.map(async (e) => {
			let t = L(r, e);
			return await me({
				fields: t && t._f ? { [e]: t } : t,
				eventType: Gt.TRIGGER
			});
		}))).every(Boolean), (o || n.isValid) && S()) : o = a = await me({
			fields: r,
			name: e,
			eventType: Gt.TRIGGER
		});
		if (i.delayError && t.delayError && B(e)) {
			let r = L(n.errors, e);
			r ? (U(n.errors, e), c[e] = b(e, () => ae(e, r)), c[e](t.delayError)) : x(e);
		}
		if (i.shouldTouch) for (let t of e ? l : s.mount) !s.array.has(t) && z(n.touchedFields, t, !0);
		return _.state.next({
			...!B(e) || g("isValid") && a !== n.isValid ? {} : { name: e },
			...t.resolver || !e ? { isValid: a } : {},
			...i.shouldTouch && g("touchedFields") ? { touchedFields: n.touchedFields } : {},
			errors: n.errors
		}), i.shouldFocus && !o && yn(r, Se, e ? l : s.mount), o;
	}, we = (e, t) => {
		let r = { ...o.mount ? a : i };
		return t && (r = lr(t.dirtyFields ? n.dirtyFields : n.touchedFields, r)), I(e) ? r : B(e) ? L(r, e) : e.map((e) => L(r, e));
	}, Te = (e) => I(e) ? { ...n.errors } : B(e) ? L(n.errors, e) : e.map((e) => L(n.errors, e)), D = (e, t) => {
		let r = t || n, i = L(r.errors, e);
		return {
			invalid: !!i,
			isDirty: !!L(r.dirtyFields, e),
			error: i,
			isValidating: !!L(r.validatingFields, e),
			isTouched: !!L(r.touchedFields, e)
		};
	}, O = (e) => {
		let t = e ? Nn(e) : void 0;
		t ? t.forEach((e) => {
			te(e), U(n.errors, e), _.state.next({
				name: e,
				errors: n.errors
			});
		}) : (Object.keys(c).forEach(x), n.errors = {}, _.state.next({ errors: n.errors }));
	}, Ee = (e, t, i) => {
		te(e);
		let a = (L(r, e, { _f: {} })._f || {}).ref, { ref: o, message: s, type: c, types: l, ...u } = L(n.errors, e) || {};
		z(n.errors, e, {
			...u,
			...t,
			ref: a
		}), _.state.next({
			name: e,
			errors: n.errors,
			isValid: !1
		}), i && i.shouldFocus && a && a.focus && a.focus();
	}, De = (e, t) => {
		if (R(e)) {
			u++;
			let { unsubscribe: n } = _.state.subscribe({ next: (n) => "values" in n && e(n.values || _e(void 0, t), n) }), r = !1;
			return { unsubscribe: () => {
				r || (r = !0, u--, n());
			} };
		}
		return _e(e, t, !0);
	}, Oe = (e) => {
		let t = !!e.formState?.values;
		t && u++;
		let { unsubscribe: r } = _.state.subscribe({ next: (t) => {
			if (Pr(e.name, t.name, e.exact) && Nr(t, e.formState || m, Be, e.reRenderRoot)) {
				let r = { ...a };
				e.callback({
					values: r,
					...n,
					...t,
					defaultValues: i
				});
			}
		} });
		if (!t) return r;
		let o = !1;
		return () => {
			o || (o = !0, u--, r());
		};
	}, ke = (e) => (o.mount = !0, h = {
		...h,
		...e.formState
	}, Oe({
		...e,
		formState: {
			...p,
			...e.formState
		}
	})), Ae = (e, o = {}) => {
		for (let c of e ? Nn(e) : s.mount) s.mount.delete(c), s.array.delete(c), s.disabled.delete(c), o.keepValue || (U(r, c), U(a, c)), o.keepError || (te(c), U(n.errors, c)), !o.keepDirty && U(n.dirtyFields, c), !o.keepTouched && U(n.touchedFields, c), !o.keepIsValidating && U(n.validatingFields, c), !t.shouldUnregister && !o.keepDefaultValue && U(i, c);
		u && _.state.next({ values: P(a) }), _.state.next({
			...n,
			...o.keepDirty ? {} : { isDirty: ge() },
			...o.keepIsValidating ? {} : { isValidating: !H(n.validatingFields) }
		}), !o.keepIsValid && S();
	}, je = ({ disabled: e, name: t }) => {
		if ($t(e) && o.mount || e || s.disabled.has(t)) {
			let n = s.disabled.has(t) !== !!e;
			e ? s.disabled.add(t) : s.disabled.delete(t), n && o.mount && !o.action && S();
		}
	}, Me = (e, n = {}) => {
		let a = L(r, e), c = $t(n.disabled) || $t(t.disabled), l = !s.registerName.has(e) && a && a._f && !a._f.mount;
		if (z(r, e, {
			...a || {},
			_f: {
				...a && a._f ? a._f : { ref: { name: e } },
				name: e,
				mount: !0,
				...n
			}
		}), s.mount.add(e), a && a._f) {
			let t = L(r, e);
			for (let e of qt) e in n || delete t._f[e];
		}
		return a && !l ? je({
			disabled: $t(n.disabled) ? n.disabled : t.disabled,
			name: e
		}) : le(e, !0, n.value), {
			...c ? { disabled: n.disabled || t.disabled } : {},
			...t.progressive ? {
				required: !!n.required,
				min: Or(n.min),
				max: Or(n.max),
				minLength: Or(n.minLength),
				maxLength: Or(n.maxLength),
				pattern: Or(n.pattern)
			} : {},
			name: e,
			onChange: xe,
			onBlur: xe,
			ref: (c) => {
				if (c) {
					s.registerName.add(e), Me(e, n), s.registerName.delete(e), a = L(r, e);
					let t = I(c.value) && c.querySelectorAll && c.querySelectorAll("input,select,textarea")[0] || c, o = pr(t), l = a._f.refs || [];
					if (o ? l.find((e) => e === t) : t === a._f.ref) return;
					let u = { ...a._f };
					o ? (u.refs = [
						...l.filter(mr),
						t,
						...Array.isArray(L(i, e)) ? [{}] : []
					], u.ref = {
						type: t.type,
						name: e
					}) : (u.ref = t, delete u.refs), z(r, e, { _f: u }), le(e, !1, void 0, t);
				} else a = L(r, e, {}), a._f && (a._f.mount = !1), (t.shouldUnregister || n.shouldUnregister) && !(Ut(s.array, e) && o.action) && s.unMount.add(e);
			}
		};
	}, Ne = () => t.shouldFocusError && !t.shouldUseNativeValidation && yn(r, Se, s.mount), Pe = (e) => {
		$t(e) && (_.state.next({ disabled: e }), yn(r, (t, n) => {
			let i = L(r, n);
			i && (t.disabled = i._f.disabled || e, Array.isArray(i._f.refs) && i._f.refs.forEach((t) => {
				t.disabled = i._f.disabled || e;
			}));
		}, 0));
	}, Fe = (e, i) => async (o) => {
		let l, u;
		o && (o.preventDefault && o.preventDefault(), o.persist && o.persist());
		let d = P(a);
		if (_.state.next({ isSubmitting: !0 }), t.resolver) {
			let e = y, { errors: t, values: r } = await de();
			if (e !== y) return;
			ne(), Object.keys(c).forEach(x), n.errors = t, d = P(r);
		} else {
			let e = y;
			if (await me({
				fields: r,
				eventType: Gt.SUBMIT
			}), e !== y) return;
			U(n.errors, Yt);
		}
		if (s.disabled.size) for (let e of s.disabled) U(d, e);
		if (H(n.errors)) {
			_.state.next({ errors: {} });
			try {
				l = await e(d, o);
			} catch (e) {
				u = e;
			}
		} else i && await i({ ...n.errors }, o), Ne(), setTimeout(Ne);
		if (_.state.next({
			isSubmitted: !0,
			isSubmitting: !1,
			isSubmitSuccessful: H(n.errors) && !u,
			submitCount: n.submitCount + 1,
			errors: n.errors
		}), u) throw u;
		return l;
	}, Ie = (e, t = {}) => {
		L(r, e) && (U(n.validatingFields, e), I(t.defaultValue) ? E(e, P(L(i, e))) : (E(e, t.defaultValue), z(i, e, P(t.defaultValue))), t.keepTouched || U(n.touchedFields, e), t.keepDirty || (U(n.dirtyFields, e), n.isDirty = t.defaultValue ? ge(e, P(L(i, e))) : ge()), t.keepError || (te(e), U(n.errors, e), S()), _.state.next({
			...n,
			isValidating: !H(n.validatingFields)
		}));
	}, Le = (e, l = {}) => {
		y++;
		let u = e ? P(e) : i, d = P(u), f = H(e), p = d, h = r;
		if (Object.keys(c).forEach(x), l.keepDefaultValues || (i = u), !l.keepValues) {
			if (l.keepDirtyValues) {
				let e = /* @__PURE__ */ new Set([...s.mount, ...gr(Cr(i, a, void 0, h), n.dirtyFields)]);
				for (let t of e) {
					let e = L(n.dirtyFields, t), r = L(a, t), i = L(p, t);
					e && !I(r) ? z(p, t, r) : !e && !I(i) && E(t, i);
				}
			} else {
				if (Wt && I(e)) for (let e of s.mount) {
					let t = L(r, e);
					if (t && t._f) {
						let e = Array.isArray(t._f.refs) ? t._f.refs[0] : t._f.ref;
						if (xn(e)) {
							let t = e.closest("form");
							if (t) {
								t.reset();
								break;
							}
						}
					}
				}
				if (l.keepFieldsRef) for (let e of s.mount) E(e, L(p, e));
				else r = {};
			}
			if (t.shouldUnregister) {
				if (a = l.keepDefaultValues ? P(i) : {}, l.keepFieldsRef) for (let e of s.mount) z(a, e, L(p, e));
			} else a = P(p);
			_.array.next({ values: { ...p } }), _.state.next({
				name: void 0,
				type: void 0,
				values: { ...p }
			});
		}
		s = {
			mount: l.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
			unMount: /* @__PURE__ */ new Set(),
			array: /* @__PURE__ */ new Set(),
			registerName: /* @__PURE__ */ new Set(),
			disabled: /* @__PURE__ */ new Set(),
			watch: /* @__PURE__ */ new Set(),
			watchAll: !1,
			focus: ""
		}, o.mount = !m.isValid || !!l.keepIsValid || !!l.keepDirtyValues || !t.shouldUnregister && !H(p), o.watch = !!t.shouldUnregister, o.keepIsValid = !!l.keepIsValid, o.action = !1, o.actionArrayLengths.clear(), l.keepErrors || (n.errors = {}), _.state.next({
			submitCount: l.keepSubmitCount ? n.submitCount : 0,
			isDirty: f ? !1 : l.keepDirty ? n.isDirty : l.keepValues ? ge() : !(!l.keepDefaultValues || cn(e, i)),
			isSubmitted: l.keepIsSubmitted ? n.isSubmitted : !1,
			dirtyFields: f ? {} : l.keepDirtyValues ? l.keepDefaultValues && a ? Cr(i, a, void 0, h) : n.dirtyFields : l.keepDefaultValues && e ? Cr(i, e, void 0, h) : l.keepDirty ? n.dirtyFields : l.keepValues ? Cr(i, a, void 0, h) : {},
			touchedFields: l.keepTouched ? n.touchedFields : {},
			...!l.keepIsValidating && (n.isValidating || !H(n.validatingFields)) ? {
				validatingFields: {},
				isValidating: !1
			} : null,
			errors: l.keepErrors ? n.errors : {},
			isSubmitSuccessful: l.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
			isSubmitting: !1,
			defaultValues: i
		});
	}, Re = (e, n) => Le(R(e) ? e(a) : e, {
		...t.resetOptions,
		...n
	}), ze = (e, t = {}) => {
		let n = L(r, e), i = n && n._f;
		if (i) {
			let e = i.refs ? i.refs[0] : i.ref;
			e.focus && setTimeout(() => {
				e.focus(), t.shouldSelect && R(e.select) && e.select();
			});
		}
	}, Be = (e) => {
		let { name: t, type: r, values: i, ...a } = e;
		n = {
			...n,
			...a
		};
	};
	_.state.subscribe({ next: Be });
	let Ve = {
		control: {
			register: Me,
			unregister: Ae,
			getFieldState: D,
			handleSubmit: Fe,
			setError: Ee,
			_subscribe: Oe,
			_runSchema: de,
			_updateIsValidating: ne,
			_focusError: Ne,
			_getWatch: _e,
			_getDirty: ge,
			_setValid: S,
			_setFieldArray: ie,
			_setDisabledField: je,
			_setErrors: oe,
			_getFieldArray: ve,
			_reset: Le,
			_resetDefaultValues: () => R(t.defaultValues) && t.defaultValues().then((e) => {
				Re(e, t.resetOptions), _.state.next({ isLoading: !1 });
			}),
			_removeUnmounted: he,
			_disableForm: Pe,
			_subjects: _,
			_proxyFormState: m,
			get _fields() {
				return r;
			},
			get _formValues() {
				return a;
			},
			get _state() {
				return o;
			},
			set _state(e) {
				o = e;
			},
			get _defaultValues() {
				return i;
			},
			get _names() {
				return s;
			},
			set _names(e) {
				s = e;
			},
			get _formState() {
				return n;
			},
			get _options() {
				return t;
			},
			set _options(e) {
				t = {
					...t,
					...e
				}, d = _n(t.mode), f = _n(t.reValidateMode), ee = t.criteriaMode === Kt.all;
			}
		},
		subscribe: ke,
		trigger: Ce,
		register: Me,
		handleSubmit: Fe,
		watch: De,
		setValue: E,
		setValues: be,
		getValues: we,
		getErrors: Te,
		reset: Re,
		resetField: Ie,
		resetDefaultValues: (e, t = {}) => {
			if (i = P(e), !t.keepDirty) {
				let e = Cr(i, a, void 0, r);
				n.dirtyFields = e, n.isDirty = !H(e);
			}
			t.keepIsValid || S(), _.state.next({
				...n,
				defaultValues: i
			});
		},
		clearErrors: O,
		unregister: Ae,
		setError: Ee,
		setFocus: ze,
		getFieldState: D
	};
	return {
		...Ve,
		formControl: Ve
	};
}
function Vr(e = {}) {
	let t = T.useRef(void 0), n = T.useRef(void 0), r = T.useRef(e.formControl), i = T.useRef(!!e.validate), [a, o] = T.useState(() => ({
		...P(zr),
		isLoading: R(e.defaultValues),
		errors: e.errors || {},
		disabled: e.disabled || !1,
		defaultValues: R(e.defaultValues) ? void 0 : e.defaultValues
	}));
	if (!t.current || e.formControl && r.current !== e.formControl) {
		if (r.current = e.formControl, e.formControl) t.current = {
			...e.formControl,
			formState: a
		}, e.defaultValues && !R(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions);
		else {
			let { formControl: n, ...r } = Br(e);
			t.current = {
				...r,
				formState: a
			};
		}
	}
	let s = t.current.control;
	s._options = {
		...e,
		validate: e.validate
	};
	let c = () => ({
		...s._formState,
		defaultValues: s._defaultValues
	}), { resyncIfNeeded: l, snapshot: u } = ln(c);
	return rn(() => {
		l(!0, c, o);
		let e = s._subscribe({
			formState: s._proxyFormState,
			callback: () => o({
				...s._formState,
				defaultValues: s._defaultValues
			}),
			reRenderRoot: !0
		});
		return o((e) => ({
			...e,
			isReady: !0
		})), s._formState.isReady = !0, () => {
			e(), u(!0, c);
		};
	}, [
		s,
		l,
		u
	]), T.useEffect(() => s._disableForm(e.disabled), [s, e.disabled]), T.useEffect(() => {
		e.mode && (s._options.mode = e.mode), e.reValidateMode && (s._options.reValidateMode = e.reValidateMode);
	}, [
		s,
		e.mode,
		e.reValidateMode
	]), T.useEffect(() => {
		e.errors && (s._setErrors(e.errors), s._focusError());
	}, [s, e.errors]), T.useEffect(() => {
		var n;
		i.current && !e.validate && ((n = t.current) == null || n.clearErrors(Jt)), i.current = !!e.validate;
	}, [e.validate]), T.useEffect(() => {
		e.shouldUnregister && s._subjects.state.next({ values: s._getWatch() });
	}, [s, e.shouldUnregister]), T.useEffect(() => {
		if (s._proxyFormState.isDirty) {
			let e = s._getDirty();
			e !== a.isDirty && s._subjects.state.next({ isDirty: e });
		}
	}, [s, a.isDirty]), T.useEffect(() => {
		e.values && !cn(e.values, n.current) ? (s._reset(e.values, {
			keepFieldsRef: !0,
			...s._options.resetOptions
		}), s._options.resetOptions?.keepIsValid || s._setValid(), n.current = e.values, o((e) => ({ ...e }))) : s._resetDefaultValues();
	}, [s, e.values]), T.useEffect(() => {
		s._state.mount || (s._setValid(), s._state.mount = !0), s._state.watch && (s._state.watch = !1, s._subjects.state.next({ ...s._formState })), s._removeUnmounted();
	}), t.current.formState = T.useMemo(() => nn(a, s), [s, a]), t.current;
}
var Hr = (e) => e.render(fn({
	name: e.names,
	...e
})), Ur = (e, t) => {
	if (e != null) return e.message;
	if (t != null) return t;
}, Wr = ({ name: e, control: t, defaultErrorMessage: n, ...r }) => /* @__PURE__ */ D(V, {
	name: e,
	control: t,
	render: ({ field: e, fieldState: { error: t } }) => /* @__PURE__ */ D(He, {
		...e,
		...r,
		error: t != null || n != null && n.length > 0,
		helperText: Ur(t, n)
	})
}), Gr = ({ name: t, control: n, options: r, getOptionLabel: i, ...a }) => /* @__PURE__ */ D(V, {
	name: t,
	control: n,
	render: ({ field: { name: t, onChange: n, onBlur: o, ref: s, value: c }, fieldState: { error: l } }) => /* @__PURE__ */ D(e, {
		options: r,
		getOptionLabel: i,
		onChange: (e, t) => {
			n(t);
		},
		onBlur: o,
		ref: s,
		value: c,
		renderInput: (e) => /* @__PURE__ */ D(He, {
			...e,
			name: t,
			error: !!l,
			helperText: l?.message,
			...a
		})
	})
}), Kr = ({ tooltipText: e }) => e == null || e === "" ? null : /* @__PURE__ */ D(le, {
	title: e,
	children: /* @__PURE__ */ D("span", { children: /* @__PURE__ */ D(A, {
		iconName: "help",
		size: "small",
		color: "black"
	}) })
}), qr = ({ children: e, required: t, label: n, boxProps: r, labelProps: a, componentProps: o, disableBorder: s = !1, disableGutters: c = !1 }) => /* @__PURE__ */ O(m, {
	sx: {
		pb: 2,
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		alignItems: "stretch",
		width: "100%",
		...r?.sx
	},
	children: [/* @__PURE__ */ O(m, {
		sx: {
			py: 2,
			px: c ? 0 : 2,
			display: "flex",
			flexDirection: "row",
			justifyContent: "flex-start",
			alignItems: "center",
			width: "100%",
			borderTop: s ? "none" : "1px solid rgba(0, 0, 0, 0.12)",
			...a?.sx
		},
		children: [a?.component === !0 ? n : /* @__PURE__ */ D(C, {
			variant: "body1",
			sx: { fontWeight: "bold" },
			children: n
		}), t === !0 && /* @__PURE__ */ D(i, {
			variant: "outlined",
			color: "error",
			size: "small",
			label: "必須",
			sx: { mx: 1 }
		})]
	}), /* @__PURE__ */ D(m, {
		sx: {
			pt: 0,
			px: c ? 0 : 2,
			wordBreak: "break-all",
			...o?.sx
		},
		children: e
	})]
}), Jr = ({ children: e, required: n, firstRow: r, label: a, boxProps: o, labelProps: s, componentProps: c, formDirection: l = "row", tooltipText: u, disableBorder: d = !1 }) => /* @__PURE__ */ O(t, {
	sx: {
		display: "flex",
		flexDirection: "row",
		borderBottom: d ? "none" : "solid 1px rgba(0, 0, 0, 0.12)",
		borderTop: !d && r === !0 ? "solid 1px rgba(0, 0, 0, 0.12)" : "none",
		marginTop: r === !0 ? 2 : 0,
		width: "100%",
		...o?.sx
	},
	children: [/* @__PURE__ */ D(t, {
		sx: {
			px: 2,
			py: 2,
			flexShrink: 0,
			display: "flex",
			flexDirection: "row",
			justifyContent: "flex-start",
			alignContent: "flex-start",
			alignItems: "flex-start",
			boxSizing: "content-box",
			background: "rgba(244, 244, 244, 1)",
			width: "200px",
			...s?.sx
		},
		children: /* @__PURE__ */ O(S, {
			direction: "row",
			sx: {
				display: "flex",
				alignItems: "center"
			},
			children: [
				s?.component === !0 ? a : /* @__PURE__ */ D(C, {
					sx: {
						fontWeight: s?.bold === !0 ? "bold" : "inherit",
						fontSize: "14px"
					},
					children: a
				}),
				n === !0 && /* @__PURE__ */ D(i, {
					variant: "outlined",
					color: "error",
					size: "small",
					label: "必須",
					sx: {
						mx: 1,
						fontSize: "12px"
					}
				}),
				/* @__PURE__ */ D(Kr, { tooltipText: u })
			]
		})
	}), /* @__PURE__ */ D(t, {
		sx: {
			px: 2,
			py: 2,
			flexDirection: l,
			gap: "8px",
			width: "100%",
			wordBreak: "break-all",
			...c?.disableFlex === !0 ? {} : {
				display: "flex",
				alignItems: "flex-start",
				justifyContent: "flex-start"
			},
			...c?.sx
		},
		children: e
	})]
}), W = E((e) => {
	let t = ve();
	return _e(t.breakpoints.down("md")) ? qr(e) : Jr(e);
}), Yr = ({ destination: e }) => /* @__PURE__ */ O(Te, { children: [
	/* @__PURE__ */ D(W, {
		label: "支払方法",
		firstRow: !0,
		children: Fe(e.paymentMethod)
	}),
	/* @__PURE__ */ D(W, {
		label: "請求書送付方法",
		children: Pe(e.invoiceDelivery)
	}),
	/* @__PURE__ */ O(W, {
		label: "請求書送付先メールアドレス",
		formDirection: "column",
		children: [ze(e.invoiceMailAddress), e.additionalMailAddresses.length > 0 && /* @__PURE__ */ D(C, {
			variant: "body2",
			sx: { color: "text.secondary" },
			children: `追加送付先: ${e.additionalMailAddresses.join(", ")}`
		})]
	}),
	/* @__PURE__ */ D(W, {
		label: "担当者",
		children: ze(e.contactName)
	})
] }), G;
(function(e) {
	e.assertEqual = (e) => {};
	function t(e) {}
	e.assertIs = t;
	function n(e) {
		throw Error();
	}
	e.assertNever = n, e.arrayToEnum = (e) => {
		let t = {};
		for (let n of e) t[n] = n;
		return t;
	}, e.getValidEnumValues = (t) => {
		let n = e.objectKeys(t).filter((e) => typeof t[t[e]] != "number"), r = {};
		for (let e of n) r[e] = t[e];
		return e.objectValues(r);
	}, e.objectValues = (t) => e.objectKeys(t).map(function(e) {
		return t[e];
	}), e.objectKeys = typeof Object.keys == "function" ? (e) => Object.keys(e) : (e) => {
		let t = [];
		for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && t.push(n);
		return t;
	}, e.find = (e, t) => {
		for (let n of e) if (t(n)) return n;
	}, e.isInteger = typeof Number.isInteger == "function" ? (e) => Number.isInteger(e) : (e) => typeof e == "number" && Number.isFinite(e) && Math.floor(e) === e;
	function r(e, t = " | ") {
		return e.map((e) => typeof e == "string" ? `'${e}'` : e).join(t);
	}
	e.joinValues = r, e.jsonStringifyReplacer = (e, t) => typeof t == "bigint" ? t.toString() : t;
})(G ||= {});
var Xr;
(function(e) {
	e.mergeShapes = (e, t) => ({
		...e,
		...t
	});
})(Xr ||= {});
var K = G.arrayToEnum([
	"string",
	"nan",
	"number",
	"integer",
	"float",
	"boolean",
	"date",
	"bigint",
	"symbol",
	"function",
	"undefined",
	"null",
	"array",
	"object",
	"unknown",
	"promise",
	"void",
	"never",
	"map",
	"set"
]), Zr = (e) => {
	switch (typeof e) {
		case "undefined": return K.undefined;
		case "string": return K.string;
		case "number": return Number.isNaN(e) ? K.nan : K.number;
		case "boolean": return K.boolean;
		case "function": return K.function;
		case "bigint": return K.bigint;
		case "symbol": return K.symbol;
		case "object": return Array.isArray(e) ? K.array : e === null ? K.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? K.promise : typeof Map < "u" && e instanceof Map ? K.map : typeof Set < "u" && e instanceof Set ? K.set : typeof Date < "u" && e instanceof Date ? K.date : K.object;
		default: return K.unknown;
	}
}, q = G.arrayToEnum([
	"invalid_type",
	"invalid_literal",
	"custom",
	"invalid_union",
	"invalid_union_discriminator",
	"invalid_enum_value",
	"unrecognized_keys",
	"invalid_arguments",
	"invalid_return_type",
	"invalid_date",
	"invalid_string",
	"too_small",
	"too_big",
	"invalid_intersection_types",
	"not_multiple_of",
	"not_finite"
]), Qr = class e extends Error {
	get errors() {
		return this.issues;
	}
	constructor(e) {
		super(), this.issues = [], this.addIssue = (e) => {
			this.issues = [...this.issues, e];
		}, this.addIssues = (e = []) => {
			this.issues = [...this.issues, ...e];
		};
		let t = new.target.prototype;
		Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
	}
	format(e) {
		let t = e || function(e) {
			return e.message;
		}, n = { _errors: [] }, r = (e) => {
			for (let i of e.issues) if (i.code === "invalid_union") i.unionErrors.map(r);
			else if (i.code === "invalid_return_type") r(i.returnTypeError);
			else if (i.code === "invalid_arguments") r(i.argumentsError);
			else if (i.path.length === 0) n._errors.push(t(i));
			else {
				let e = n, r = 0;
				for (; r < i.path.length;) {
					let n = i.path[r];
					r === i.path.length - 1 ? (e[n] = e[n] || { _errors: [] }, e[n]._errors.push(t(i))) : e[n] = e[n] || { _errors: [] }, e = e[n], r++;
				}
			}
		};
		return r(this), n;
	}
	static assert(t) {
		if (!(t instanceof e)) throw Error(`Not a ZodError: ${t}`);
	}
	toString() {
		return this.message;
	}
	get message() {
		return JSON.stringify(this.issues, G.jsonStringifyReplacer, 2);
	}
	get isEmpty() {
		return this.issues.length === 0;
	}
	flatten(e = (e) => e.message) {
		let t = {}, n = [];
		for (let r of this.issues) if (r.path.length > 0) {
			let n = r.path[0];
			t[n] = t[n] || [], t[n].push(e(r));
		} else n.push(e(r));
		return {
			formErrors: n,
			fieldErrors: t
		};
	}
	get formErrors() {
		return this.flatten();
	}
};
Qr.create = (e) => new Qr(e);
//#endregion
//#region ../../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/locales/en.js
var $r = (e, t) => {
	let n;
	switch (e.code) {
		case q.invalid_type:
			n = e.received === K.undefined ? "Required" : `Expected ${e.expected}, received ${e.received}`;
			break;
		case q.invalid_literal:
			n = `Invalid literal value, expected ${JSON.stringify(e.expected, G.jsonStringifyReplacer)}`;
			break;
		case q.unrecognized_keys:
			n = `Unrecognized key(s) in object: ${G.joinValues(e.keys, ", ")}`;
			break;
		case q.invalid_union:
			n = "Invalid input";
			break;
		case q.invalid_union_discriminator:
			n = `Invalid discriminator value. Expected ${G.joinValues(e.options)}`;
			break;
		case q.invalid_enum_value:
			n = `Invalid enum value. Expected ${G.joinValues(e.options)}, received '${e.received}'`;
			break;
		case q.invalid_arguments:
			n = "Invalid function arguments";
			break;
		case q.invalid_return_type:
			n = "Invalid function return type";
			break;
		case q.invalid_date:
			n = "Invalid date";
			break;
		case q.invalid_string:
			typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : G.assertNever(e.validation) : n = e.validation === "regex" ? "Invalid" : `Invalid ${e.validation}`;
			break;
		case q.too_small:
			n = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" || e.type === "bigint" ? `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : "Invalid input";
			break;
		case q.too_big:
			n = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : "Invalid input";
			break;
		case q.custom:
			n = "Invalid input";
			break;
		case q.invalid_intersection_types:
			n = "Intersection results could not be merged";
			break;
		case q.not_multiple_of:
			n = `Number must be a multiple of ${e.multipleOf}`;
			break;
		case q.not_finite:
			n = "Number must be finite";
			break;
		default: n = t.defaultError, G.assertNever(e);
	}
	return { message: n };
}, ei = $r;
function ti(e) {
	ei = e;
}
function ni() {
	return ei;
}
//#endregion
//#region ../../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/helpers/parseUtil.js
var ri = (e) => {
	let { data: t, path: n, errorMaps: r, issueData: i } = e, a = [...n, ...i.path || []], o = {
		...i,
		path: a
	};
	if (i.message !== void 0) return {
		...i,
		path: a,
		message: i.message
	};
	let s = "", c = r.filter((e) => !!e).slice().reverse();
	for (let e of c) s = e(o, {
		data: t,
		defaultError: s
	}).message;
	return {
		...i,
		path: a,
		message: s
	};
};
function J(e, t) {
	let n = ni(), r = ri({
		issueData: t,
		data: e.data,
		path: e.path,
		errorMaps: [
			e.common.contextualErrorMap,
			e.schemaErrorMap,
			n,
			n === $r ? void 0 : $r
		].filter((e) => !!e)
	});
	e.common.issues.push(r);
}
var ii = class e {
	constructor() {
		this.value = "valid";
	}
	dirty() {
		this.value === "valid" && (this.value = "dirty");
	}
	abort() {
		this.value !== "aborted" && (this.value = "aborted");
	}
	static mergeArray(e, t) {
		let n = [];
		for (let r of t) {
			if (r.status === "aborted") return Y;
			r.status === "dirty" && e.dirty(), n.push(r.value);
		}
		return {
			status: e.value,
			value: n
		};
	}
	static async mergeObjectAsync(t, n) {
		let r = [];
		for (let e of n) {
			let t = await e.key, n = await e.value;
			r.push({
				key: t,
				value: n
			});
		}
		return e.mergeObjectSync(t, r);
	}
	static mergeObjectSync(e, t) {
		let n = {};
		for (let r of t) {
			let { key: t, value: i } = r;
			if (t.status === "aborted" || i.status === "aborted") return Y;
			t.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), t.value !== "__proto__" && (i.value !== void 0 || r.alwaysSet) && (n[t.value] = i.value);
		}
		return {
			status: e.value,
			value: n
		};
	}
}, Y = Object.freeze({ status: "aborted" }), ai = (e) => ({
	status: "dirty",
	value: e
}), oi = (e) => ({
	status: "valid",
	value: e
}), si = (e) => e.status === "aborted", ci = (e) => e.status === "dirty", li = (e) => e.status === "valid", ui = (e) => typeof Promise < "u" && e instanceof Promise, X;
(function(e) {
	e.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, e.toString = (e) => typeof e == "string" ? e : e?.message;
})(X ||= {});
//#endregion
//#region ../../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/types.js
var di = class {
	constructor(e, t, n, r) {
		this._cachedPath = [], this.parent = e, this.data = t, this._path = n, this._key = r;
	}
	get path() {
		return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
	}
}, fi = (e, t) => {
	if (li(t)) return {
		success: !0,
		data: t.value
	};
	if (!e.common.issues.length) throw Error("Validation failed but no issues detected.");
	return {
		success: !1,
		get error() {
			if (this._error) return this._error;
			let t = new Qr(e.common.issues);
			return this._error = t, this._error;
		}
	};
};
function Z(e) {
	if (!e) return {};
	let { errorMap: t, invalid_type_error: n, required_error: r, description: i } = e;
	if (t && (n || r)) throw Error("Can't use \"invalid_type_error\" or \"required_error\" in conjunction with custom error map.");
	return t ? {
		errorMap: t,
		description: i
	} : {
		errorMap: (t, i) => {
			let { message: a } = e;
			return t.code === "invalid_enum_value" ? { message: a ?? i.defaultError } : i.data === void 0 ? { message: a ?? r ?? i.defaultError } : t.code === "invalid_type" ? { message: a ?? n ?? i.defaultError } : { message: i.defaultError };
		},
		description: i
	};
}
var Q = class {
	get description() {
		return this._def.description;
	}
	_getType(e) {
		return Zr(e.data);
	}
	_getOrReturnCtx(e, t) {
		return t || {
			common: e.parent.common,
			data: e.data,
			parsedType: Zr(e.data),
			schemaErrorMap: this._def.errorMap,
			path: e.path,
			parent: e.parent
		};
	}
	_processInputParams(e) {
		return {
			status: new ii(),
			ctx: {
				common: e.parent.common,
				data: e.data,
				parsedType: Zr(e.data),
				schemaErrorMap: this._def.errorMap,
				path: e.path,
				parent: e.parent
			}
		};
	}
	_parseSync(e) {
		let t = this._parse(e);
		if (ui(t)) throw Error("Synchronous parse encountered promise.");
		return t;
	}
	_parseAsync(e) {
		let t = this._parse(e);
		return Promise.resolve(t);
	}
	parse(e, t) {
		let n = this.safeParse(e, t);
		if (n.success) return n.data;
		throw n.error;
	}
	safeParse(e, t) {
		let n = {
			common: {
				issues: [],
				async: t?.async ?? !1,
				contextualErrorMap: t?.errorMap
			},
			path: t?.path || [],
			schemaErrorMap: this._def.errorMap,
			parent: null,
			data: e,
			parsedType: Zr(e)
		};
		return fi(n, this._parseSync({
			data: e,
			path: n.path,
			parent: n
		}));
	}
	"~validate"(e) {
		let t = {
			common: {
				issues: [],
				async: !!this["~standard"].async
			},
			path: [],
			schemaErrorMap: this._def.errorMap,
			parent: null,
			data: e,
			parsedType: Zr(e)
		};
		if (!this["~standard"].async) try {
			let n = this._parseSync({
				data: e,
				path: [],
				parent: t
			});
			return li(n) ? { value: n.value } : { issues: t.common.issues };
		} catch (e) {
			e?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), t.common = {
				issues: [],
				async: !0
			};
		}
		return this._parseAsync({
			data: e,
			path: [],
			parent: t
		}).then((e) => li(e) ? { value: e.value } : { issues: t.common.issues });
	}
	async parseAsync(e, t) {
		let n = await this.safeParseAsync(e, t);
		if (n.success) return n.data;
		throw n.error;
	}
	async safeParseAsync(e, t) {
		let n = {
			common: {
				issues: [],
				contextualErrorMap: t?.errorMap,
				async: !0
			},
			path: t?.path || [],
			schemaErrorMap: this._def.errorMap,
			parent: null,
			data: e,
			parsedType: Zr(e)
		}, r = this._parse({
			data: e,
			path: n.path,
			parent: n
		});
		return fi(n, await (ui(r) ? r : Promise.resolve(r)));
	}
	refine(e, t) {
		let n = (e) => typeof t == "string" || t === void 0 ? { message: t } : typeof t == "function" ? t(e) : t;
		return this._refinement((t, r) => {
			let i = e(t), a = () => r.addIssue({
				code: q.custom,
				...n(t)
			});
			return typeof Promise < "u" && i instanceof Promise ? i.then((e) => e ? !0 : (a(), !1)) : i ? !0 : (a(), !1);
		});
	}
	refinement(e, t) {
		return this._refinement((n, r) => e(n) ? !0 : (r.addIssue(typeof t == "function" ? t(n, r) : t), !1));
	}
	_refinement(e) {
		return new ha({
			schema: this,
			typeName: $.ZodEffects,
			effect: {
				type: "refinement",
				refinement: e
			}
		});
	}
	superRefine(e) {
		return this._refinement(e);
	}
	constructor(e) {
		this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
			version: 1,
			vendor: "zod",
			validate: (e) => this["~validate"](e)
		};
	}
	optional() {
		return ga.create(this, this._def);
	}
	nullable() {
		return _a.create(this, this._def);
	}
	nullish() {
		return this.nullable().optional();
	}
	array() {
		return Xi.create(this);
	}
	promise() {
		return ma.create(this, this._def);
	}
	or(e) {
		return $i.create([this, e], this._def);
	}
	and(e) {
		return ra.create(this, e, this._def);
	}
	transform(e) {
		return new ha({
			...Z(this._def),
			schema: this,
			typeName: $.ZodEffects,
			effect: {
				type: "transform",
				transform: e
			}
		});
	}
	default(e) {
		let t = typeof e == "function" ? e : () => e;
		return new va({
			...Z(this._def),
			innerType: this,
			defaultValue: t,
			typeName: $.ZodDefault
		});
	}
	brand() {
		return new xa({
			typeName: $.ZodBranded,
			type: this,
			...Z(this._def)
		});
	}
	catch(e) {
		let t = typeof e == "function" ? e : () => e;
		return new ya({
			...Z(this._def),
			innerType: this,
			catchValue: t,
			typeName: $.ZodCatch
		});
	}
	describe(e) {
		let t = this.constructor;
		return new t({
			...this._def,
			description: e
		});
	}
	pipe(e) {
		return Sa.create(this, e);
	}
	readonly() {
		return Ca.create(this);
	}
	isOptional() {
		return this.safeParse(void 0).success;
	}
	isNullable() {
		return this.safeParse(null).success;
	}
}, pi = /^c[^\s-]{8,}$/i, mi = /^[0-9a-z]+$/, hi = /^[0-9A-HJKMNP-TV-Z]{26}$/i, gi = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, _i = /^[a-z0-9_-]{21}$/i, vi = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, yi = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, bi = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, xi = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", Si, Ci = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, wi = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Ti = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Ei = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Di = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Oi = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, ki = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Ai = RegExp(`^${ki}$`);
function ji(e) {
	let t = "[0-5]\\d";
	e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision ?? (t = `${t}(\\.\\d+)?`);
	let n = e.precision ? "+" : "?";
	return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${n}`;
}
function Mi(e) {
	return RegExp(`^${ji(e)}$`);
}
function Ni(e) {
	let t = `${ki}T${ji(e)}`, n = [];
	return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, RegExp(`^${t}$`);
}
function Pi(e, t) {
	return !((t !== "v4" && t || !Ci.test(e)) && (t !== "v6" && t || !Ti.test(e)));
}
function Fi(e, t) {
	if (!vi.test(e)) return !1;
	try {
		let [n] = e.split(".");
		if (!n) return !1;
		let r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), i = JSON.parse(atob(r));
		return !(typeof i != "object" || !i || "typ" in i && i?.typ !== "JWT" || !i.alg || t && i.alg !== t);
	} catch {
		return !1;
	}
}
function Ii(e, t) {
	return !((t !== "v4" && t || !wi.test(e)) && (t !== "v6" && t || !Ei.test(e)));
}
var Li = class e extends Q {
	_parse(e) {
		if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== K.string) {
			let t = this._getOrReturnCtx(e);
			return J(t, {
				code: q.invalid_type,
				expected: K.string,
				received: t.parsedType
			}), Y;
		}
		let t = new ii(), n;
		for (let r of this._def.checks) if (r.kind === "min") e.data.length < r.value && (n = this._getOrReturnCtx(e, n), J(n, {
			code: q.too_small,
			minimum: r.value,
			type: "string",
			inclusive: !0,
			exact: !1,
			message: r.message
		}), t.dirty());
		else if (r.kind === "max") e.data.length > r.value && (n = this._getOrReturnCtx(e, n), J(n, {
			code: q.too_big,
			maximum: r.value,
			type: "string",
			inclusive: !0,
			exact: !1,
			message: r.message
		}), t.dirty());
		else if (r.kind === "length") {
			let i = e.data.length > r.value, a = e.data.length < r.value;
			(i || a) && (n = this._getOrReturnCtx(e, n), i ? J(n, {
				code: q.too_big,
				maximum: r.value,
				type: "string",
				inclusive: !0,
				exact: !0,
				message: r.message
			}) : a && J(n, {
				code: q.too_small,
				minimum: r.value,
				type: "string",
				inclusive: !0,
				exact: !0,
				message: r.message
			}), t.dirty());
		} else if (r.kind === "email") bi.test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "email",
			code: q.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "emoji") Si ||= new RegExp(xi, "u"), Si.test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "emoji",
			code: q.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "uuid") gi.test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "uuid",
			code: q.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "nanoid") _i.test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "nanoid",
			code: q.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "cuid") pi.test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "cuid",
			code: q.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "cuid2") mi.test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "cuid2",
			code: q.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "ulid") hi.test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "ulid",
			code: q.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "url") try {
			new URL(e.data);
		} catch {
			n = this._getOrReturnCtx(e, n), J(n, {
				validation: "url",
				code: q.invalid_string,
				message: r.message
			}), t.dirty();
		}
		else r.kind === "regex" ? (r.regex.lastIndex = 0, r.regex.test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "regex",
			code: q.invalid_string,
			message: r.message
		}), t.dirty())) : r.kind === "trim" ? e.data = e.data.trim() : r.kind === "includes" ? e.data.includes(r.value, r.position) || (n = this._getOrReturnCtx(e, n), J(n, {
			code: q.invalid_string,
			validation: {
				includes: r.value,
				position: r.position
			},
			message: r.message
		}), t.dirty()) : r.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : r.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : r.kind === "startsWith" ? e.data.startsWith(r.value) || (n = this._getOrReturnCtx(e, n), J(n, {
			code: q.invalid_string,
			validation: { startsWith: r.value },
			message: r.message
		}), t.dirty()) : r.kind === "endsWith" ? e.data.endsWith(r.value) || (n = this._getOrReturnCtx(e, n), J(n, {
			code: q.invalid_string,
			validation: { endsWith: r.value },
			message: r.message
		}), t.dirty()) : r.kind === "datetime" ? Ni(r).test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			code: q.invalid_string,
			validation: "datetime",
			message: r.message
		}), t.dirty()) : r.kind === "date" ? Ai.test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			code: q.invalid_string,
			validation: "date",
			message: r.message
		}), t.dirty()) : r.kind === "time" ? Mi(r).test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			code: q.invalid_string,
			validation: "time",
			message: r.message
		}), t.dirty()) : r.kind === "duration" ? yi.test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "duration",
			code: q.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "ip" ? Pi(e.data, r.version) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "ip",
			code: q.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "jwt" ? Fi(e.data, r.alg) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "jwt",
			code: q.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "cidr" ? Ii(e.data, r.version) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "cidr",
			code: q.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "base64" ? Di.test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "base64",
			code: q.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "base64url" ? Oi.test(e.data) || (n = this._getOrReturnCtx(e, n), J(n, {
			validation: "base64url",
			code: q.invalid_string,
			message: r.message
		}), t.dirty()) : G.assertNever(r);
		return {
			status: t.value,
			value: e.data
		};
	}
	_regex(e, t, n) {
		return this.refinement((t) => e.test(t), {
			validation: t,
			code: q.invalid_string,
			...X.errToObj(n)
		});
	}
	_addCheck(t) {
		return new e({
			...this._def,
			checks: [...this._def.checks, t]
		});
	}
	email(e) {
		return this._addCheck({
			kind: "email",
			...X.errToObj(e)
		});
	}
	url(e) {
		return this._addCheck({
			kind: "url",
			...X.errToObj(e)
		});
	}
	emoji(e) {
		return this._addCheck({
			kind: "emoji",
			...X.errToObj(e)
		});
	}
	uuid(e) {
		return this._addCheck({
			kind: "uuid",
			...X.errToObj(e)
		});
	}
	nanoid(e) {
		return this._addCheck({
			kind: "nanoid",
			...X.errToObj(e)
		});
	}
	cuid(e) {
		return this._addCheck({
			kind: "cuid",
			...X.errToObj(e)
		});
	}
	cuid2(e) {
		return this._addCheck({
			kind: "cuid2",
			...X.errToObj(e)
		});
	}
	ulid(e) {
		return this._addCheck({
			kind: "ulid",
			...X.errToObj(e)
		});
	}
	base64(e) {
		return this._addCheck({
			kind: "base64",
			...X.errToObj(e)
		});
	}
	base64url(e) {
		return this._addCheck({
			kind: "base64url",
			...X.errToObj(e)
		});
	}
	jwt(e) {
		return this._addCheck({
			kind: "jwt",
			...X.errToObj(e)
		});
	}
	ip(e) {
		return this._addCheck({
			kind: "ip",
			...X.errToObj(e)
		});
	}
	cidr(e) {
		return this._addCheck({
			kind: "cidr",
			...X.errToObj(e)
		});
	}
	datetime(e) {
		return typeof e == "string" ? this._addCheck({
			kind: "datetime",
			precision: null,
			offset: !1,
			local: !1,
			message: e
		}) : this._addCheck({
			kind: "datetime",
			precision: e?.precision === void 0 ? null : e?.precision,
			offset: e?.offset ?? !1,
			local: e?.local ?? !1,
			...X.errToObj(e?.message)
		});
	}
	date(e) {
		return this._addCheck({
			kind: "date",
			message: e
		});
	}
	time(e) {
		return typeof e == "string" ? this._addCheck({
			kind: "time",
			precision: null,
			message: e
		}) : this._addCheck({
			kind: "time",
			precision: e?.precision === void 0 ? null : e?.precision,
			...X.errToObj(e?.message)
		});
	}
	duration(e) {
		return this._addCheck({
			kind: "duration",
			...X.errToObj(e)
		});
	}
	regex(e, t) {
		return this._addCheck({
			kind: "regex",
			regex: e,
			...X.errToObj(t)
		});
	}
	includes(e, t) {
		return this._addCheck({
			kind: "includes",
			value: e,
			position: t?.position,
			...X.errToObj(t?.message)
		});
	}
	startsWith(e, t) {
		return this._addCheck({
			kind: "startsWith",
			value: e,
			...X.errToObj(t)
		});
	}
	endsWith(e, t) {
		return this._addCheck({
			kind: "endsWith",
			value: e,
			...X.errToObj(t)
		});
	}
	min(e, t) {
		return this._addCheck({
			kind: "min",
			value: e,
			...X.errToObj(t)
		});
	}
	max(e, t) {
		return this._addCheck({
			kind: "max",
			value: e,
			...X.errToObj(t)
		});
	}
	length(e, t) {
		return this._addCheck({
			kind: "length",
			value: e,
			...X.errToObj(t)
		});
	}
	nonempty(e) {
		return this.min(1, X.errToObj(e));
	}
	trim() {
		return new e({
			...this._def,
			checks: [...this._def.checks, { kind: "trim" }]
		});
	}
	toLowerCase() {
		return new e({
			...this._def,
			checks: [...this._def.checks, { kind: "toLowerCase" }]
		});
	}
	toUpperCase() {
		return new e({
			...this._def,
			checks: [...this._def.checks, { kind: "toUpperCase" }]
		});
	}
	get isDatetime() {
		return !!this._def.checks.find((e) => e.kind === "datetime");
	}
	get isDate() {
		return !!this._def.checks.find((e) => e.kind === "date");
	}
	get isTime() {
		return !!this._def.checks.find((e) => e.kind === "time");
	}
	get isDuration() {
		return !!this._def.checks.find((e) => e.kind === "duration");
	}
	get isEmail() {
		return !!this._def.checks.find((e) => e.kind === "email");
	}
	get isURL() {
		return !!this._def.checks.find((e) => e.kind === "url");
	}
	get isEmoji() {
		return !!this._def.checks.find((e) => e.kind === "emoji");
	}
	get isUUID() {
		return !!this._def.checks.find((e) => e.kind === "uuid");
	}
	get isNANOID() {
		return !!this._def.checks.find((e) => e.kind === "nanoid");
	}
	get isCUID() {
		return !!this._def.checks.find((e) => e.kind === "cuid");
	}
	get isCUID2() {
		return !!this._def.checks.find((e) => e.kind === "cuid2");
	}
	get isULID() {
		return !!this._def.checks.find((e) => e.kind === "ulid");
	}
	get isIP() {
		return !!this._def.checks.find((e) => e.kind === "ip");
	}
	get isCIDR() {
		return !!this._def.checks.find((e) => e.kind === "cidr");
	}
	get isBase64() {
		return !!this._def.checks.find((e) => e.kind === "base64");
	}
	get isBase64url() {
		return !!this._def.checks.find((e) => e.kind === "base64url");
	}
	get minLength() {
		let e = null;
		for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
		return e;
	}
	get maxLength() {
		let e = null;
		for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
		return e;
	}
};
Li.create = (e) => new Li({
	checks: [],
	typeName: $.ZodString,
	coerce: e?.coerce ?? !1,
	...Z(e)
});
function Ri(e, t) {
	let n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, i = n > r ? n : r;
	return Number.parseInt(e.toFixed(i).replace(".", "")) % Number.parseInt(t.toFixed(i).replace(".", "")) / 10 ** i;
}
var zi = class e extends Q {
	constructor() {
		super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
	}
	_parse(e) {
		if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== K.number) {
			let t = this._getOrReturnCtx(e);
			return J(t, {
				code: q.invalid_type,
				expected: K.number,
				received: t.parsedType
			}), Y;
		}
		let t, n = new ii();
		for (let r of this._def.checks) r.kind === "int" ? G.isInteger(e.data) || (t = this._getOrReturnCtx(e, t), J(t, {
			code: q.invalid_type,
			expected: "integer",
			received: "float",
			message: r.message
		}), n.dirty()) : r.kind === "min" ? (r.inclusive ? e.data < r.value : e.data <= r.value) && (t = this._getOrReturnCtx(e, t), J(t, {
			code: q.too_small,
			minimum: r.value,
			type: "number",
			inclusive: r.inclusive,
			exact: !1,
			message: r.message
		}), n.dirty()) : r.kind === "max" ? (r.inclusive ? e.data > r.value : e.data >= r.value) && (t = this._getOrReturnCtx(e, t), J(t, {
			code: q.too_big,
			maximum: r.value,
			type: "number",
			inclusive: r.inclusive,
			exact: !1,
			message: r.message
		}), n.dirty()) : r.kind === "multipleOf" ? Ri(e.data, r.value) !== 0 && (t = this._getOrReturnCtx(e, t), J(t, {
			code: q.not_multiple_of,
			multipleOf: r.value,
			message: r.message
		}), n.dirty()) : r.kind === "finite" ? Number.isFinite(e.data) || (t = this._getOrReturnCtx(e, t), J(t, {
			code: q.not_finite,
			message: r.message
		}), n.dirty()) : G.assertNever(r);
		return {
			status: n.value,
			value: e.data
		};
	}
	gte(e, t) {
		return this.setLimit("min", e, !0, X.toString(t));
	}
	gt(e, t) {
		return this.setLimit("min", e, !1, X.toString(t));
	}
	lte(e, t) {
		return this.setLimit("max", e, !0, X.toString(t));
	}
	lt(e, t) {
		return this.setLimit("max", e, !1, X.toString(t));
	}
	setLimit(t, n, r, i) {
		return new e({
			...this._def,
			checks: [...this._def.checks, {
				kind: t,
				value: n,
				inclusive: r,
				message: X.toString(i)
			}]
		});
	}
	_addCheck(t) {
		return new e({
			...this._def,
			checks: [...this._def.checks, t]
		});
	}
	int(e) {
		return this._addCheck({
			kind: "int",
			message: X.toString(e)
		});
	}
	positive(e) {
		return this._addCheck({
			kind: "min",
			value: 0,
			inclusive: !1,
			message: X.toString(e)
		});
	}
	negative(e) {
		return this._addCheck({
			kind: "max",
			value: 0,
			inclusive: !1,
			message: X.toString(e)
		});
	}
	nonpositive(e) {
		return this._addCheck({
			kind: "max",
			value: 0,
			inclusive: !0,
			message: X.toString(e)
		});
	}
	nonnegative(e) {
		return this._addCheck({
			kind: "min",
			value: 0,
			inclusive: !0,
			message: X.toString(e)
		});
	}
	multipleOf(e, t) {
		return this._addCheck({
			kind: "multipleOf",
			value: e,
			message: X.toString(t)
		});
	}
	finite(e) {
		return this._addCheck({
			kind: "finite",
			message: X.toString(e)
		});
	}
	safe(e) {
		return this._addCheck({
			kind: "min",
			inclusive: !0,
			value: -(2 ** 53 - 1),
			message: X.toString(e)
		})._addCheck({
			kind: "max",
			inclusive: !0,
			value: 2 ** 53 - 1,
			message: X.toString(e)
		});
	}
	get minValue() {
		let e = null;
		for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
		return e;
	}
	get maxValue() {
		let e = null;
		for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
		return e;
	}
	get isInt() {
		return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && G.isInteger(e.value));
	}
	get isFinite() {
		let e = null, t = null;
		for (let n of this._def.checks) if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf") return !0;
		else n.kind === "min" ? (t === null || n.value > t) && (t = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
		return Number.isFinite(t) && Number.isFinite(e);
	}
};
zi.create = (e) => new zi({
	checks: [],
	typeName: $.ZodNumber,
	coerce: e?.coerce || !1,
	...Z(e)
});
var Bi = class e extends Q {
	constructor() {
		super(...arguments), this.min = this.gte, this.max = this.lte;
	}
	_parse(e) {
		if (this._def.coerce) try {
			e.data = BigInt(e.data);
		} catch {
			return this._getInvalidInput(e);
		}
		if (this._getType(e) !== K.bigint) return this._getInvalidInput(e);
		let t, n = new ii();
		for (let r of this._def.checks) r.kind === "min" ? (r.inclusive ? e.data < r.value : e.data <= r.value) && (t = this._getOrReturnCtx(e, t), J(t, {
			code: q.too_small,
			type: "bigint",
			minimum: r.value,
			inclusive: r.inclusive,
			message: r.message
		}), n.dirty()) : r.kind === "max" ? (r.inclusive ? e.data > r.value : e.data >= r.value) && (t = this._getOrReturnCtx(e, t), J(t, {
			code: q.too_big,
			type: "bigint",
			maximum: r.value,
			inclusive: r.inclusive,
			message: r.message
		}), n.dirty()) : r.kind === "multipleOf" ? e.data % r.value !== BigInt(0) && (t = this._getOrReturnCtx(e, t), J(t, {
			code: q.not_multiple_of,
			multipleOf: r.value,
			message: r.message
		}), n.dirty()) : G.assertNever(r);
		return {
			status: n.value,
			value: e.data
		};
	}
	_getInvalidInput(e) {
		let t = this._getOrReturnCtx(e);
		return J(t, {
			code: q.invalid_type,
			expected: K.bigint,
			received: t.parsedType
		}), Y;
	}
	gte(e, t) {
		return this.setLimit("min", e, !0, X.toString(t));
	}
	gt(e, t) {
		return this.setLimit("min", e, !1, X.toString(t));
	}
	lte(e, t) {
		return this.setLimit("max", e, !0, X.toString(t));
	}
	lt(e, t) {
		return this.setLimit("max", e, !1, X.toString(t));
	}
	setLimit(t, n, r, i) {
		return new e({
			...this._def,
			checks: [...this._def.checks, {
				kind: t,
				value: n,
				inclusive: r,
				message: X.toString(i)
			}]
		});
	}
	_addCheck(t) {
		return new e({
			...this._def,
			checks: [...this._def.checks, t]
		});
	}
	positive(e) {
		return this._addCheck({
			kind: "min",
			value: BigInt(0),
			inclusive: !1,
			message: X.toString(e)
		});
	}
	negative(e) {
		return this._addCheck({
			kind: "max",
			value: BigInt(0),
			inclusive: !1,
			message: X.toString(e)
		});
	}
	nonpositive(e) {
		return this._addCheck({
			kind: "max",
			value: BigInt(0),
			inclusive: !0,
			message: X.toString(e)
		});
	}
	nonnegative(e) {
		return this._addCheck({
			kind: "min",
			value: BigInt(0),
			inclusive: !0,
			message: X.toString(e)
		});
	}
	multipleOf(e, t) {
		return this._addCheck({
			kind: "multipleOf",
			value: e,
			message: X.toString(t)
		});
	}
	get minValue() {
		let e = null;
		for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
		return e;
	}
	get maxValue() {
		let e = null;
		for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
		return e;
	}
};
Bi.create = (e) => new Bi({
	checks: [],
	typeName: $.ZodBigInt,
	coerce: e?.coerce ?? !1,
	...Z(e)
});
var Vi = class extends Q {
	_parse(e) {
		if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== K.boolean) {
			let t = this._getOrReturnCtx(e);
			return J(t, {
				code: q.invalid_type,
				expected: K.boolean,
				received: t.parsedType
			}), Y;
		}
		return oi(e.data);
	}
};
Vi.create = (e) => new Vi({
	typeName: $.ZodBoolean,
	coerce: e?.coerce || !1,
	...Z(e)
});
var Hi = class e extends Q {
	_parse(e) {
		if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== K.date) {
			let t = this._getOrReturnCtx(e);
			return J(t, {
				code: q.invalid_type,
				expected: K.date,
				received: t.parsedType
			}), Y;
		}
		if (Number.isNaN(e.data.getTime())) return J(this._getOrReturnCtx(e), { code: q.invalid_date }), Y;
		let t = new ii(), n;
		for (let r of this._def.checks) r.kind === "min" ? e.data.getTime() < r.value && (n = this._getOrReturnCtx(e, n), J(n, {
			code: q.too_small,
			message: r.message,
			inclusive: !0,
			exact: !1,
			minimum: r.value,
			type: "date"
		}), t.dirty()) : r.kind === "max" ? e.data.getTime() > r.value && (n = this._getOrReturnCtx(e, n), J(n, {
			code: q.too_big,
			message: r.message,
			inclusive: !0,
			exact: !1,
			maximum: r.value,
			type: "date"
		}), t.dirty()) : G.assertNever(r);
		return {
			status: t.value,
			value: new Date(e.data.getTime())
		};
	}
	_addCheck(t) {
		return new e({
			...this._def,
			checks: [...this._def.checks, t]
		});
	}
	min(e, t) {
		return this._addCheck({
			kind: "min",
			value: e.getTime(),
			message: X.toString(t)
		});
	}
	max(e, t) {
		return this._addCheck({
			kind: "max",
			value: e.getTime(),
			message: X.toString(t)
		});
	}
	get minDate() {
		let e = null;
		for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
		return e == null ? null : new Date(e);
	}
	get maxDate() {
		let e = null;
		for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
		return e == null ? null : new Date(e);
	}
};
Hi.create = (e) => new Hi({
	checks: [],
	coerce: e?.coerce || !1,
	typeName: $.ZodDate,
	...Z(e)
});
var Ui = class extends Q {
	_parse(e) {
		if (this._getType(e) !== K.symbol) {
			let t = this._getOrReturnCtx(e);
			return J(t, {
				code: q.invalid_type,
				expected: K.symbol,
				received: t.parsedType
			}), Y;
		}
		return oi(e.data);
	}
};
Ui.create = (e) => new Ui({
	typeName: $.ZodSymbol,
	...Z(e)
});
var Wi = class extends Q {
	_parse(e) {
		if (this._getType(e) !== K.undefined) {
			let t = this._getOrReturnCtx(e);
			return J(t, {
				code: q.invalid_type,
				expected: K.undefined,
				received: t.parsedType
			}), Y;
		}
		return oi(e.data);
	}
};
Wi.create = (e) => new Wi({
	typeName: $.ZodUndefined,
	...Z(e)
});
var Gi = class extends Q {
	_parse(e) {
		if (this._getType(e) !== K.null) {
			let t = this._getOrReturnCtx(e);
			return J(t, {
				code: q.invalid_type,
				expected: K.null,
				received: t.parsedType
			}), Y;
		}
		return oi(e.data);
	}
};
Gi.create = (e) => new Gi({
	typeName: $.ZodNull,
	...Z(e)
});
var Ki = class extends Q {
	constructor() {
		super(...arguments), this._any = !0;
	}
	_parse(e) {
		return oi(e.data);
	}
};
Ki.create = (e) => new Ki({
	typeName: $.ZodAny,
	...Z(e)
});
var qi = class extends Q {
	constructor() {
		super(...arguments), this._unknown = !0;
	}
	_parse(e) {
		return oi(e.data);
	}
};
qi.create = (e) => new qi({
	typeName: $.ZodUnknown,
	...Z(e)
});
var Ji = class extends Q {
	_parse(e) {
		let t = this._getOrReturnCtx(e);
		return J(t, {
			code: q.invalid_type,
			expected: K.never,
			received: t.parsedType
		}), Y;
	}
};
Ji.create = (e) => new Ji({
	typeName: $.ZodNever,
	...Z(e)
});
var Yi = class extends Q {
	_parse(e) {
		if (this._getType(e) !== K.undefined) {
			let t = this._getOrReturnCtx(e);
			return J(t, {
				code: q.invalid_type,
				expected: K.void,
				received: t.parsedType
			}), Y;
		}
		return oi(e.data);
	}
};
Yi.create = (e) => new Yi({
	typeName: $.ZodVoid,
	...Z(e)
});
var Xi = class e extends Q {
	_parse(e) {
		let { ctx: t, status: n } = this._processInputParams(e), r = this._def;
		if (t.parsedType !== K.array) return J(t, {
			code: q.invalid_type,
			expected: K.array,
			received: t.parsedType
		}), Y;
		if (r.exactLength !== null) {
			let e = t.data.length > r.exactLength.value, i = t.data.length < r.exactLength.value;
			(e || i) && (J(t, {
				code: e ? q.too_big : q.too_small,
				minimum: i ? r.exactLength.value : void 0,
				maximum: e ? r.exactLength.value : void 0,
				type: "array",
				inclusive: !0,
				exact: !0,
				message: r.exactLength.message
			}), n.dirty());
		}
		if (r.minLength !== null && t.data.length < r.minLength.value && (J(t, {
			code: q.too_small,
			minimum: r.minLength.value,
			type: "array",
			inclusive: !0,
			exact: !1,
			message: r.minLength.message
		}), n.dirty()), r.maxLength !== null && t.data.length > r.maxLength.value && (J(t, {
			code: q.too_big,
			maximum: r.maxLength.value,
			type: "array",
			inclusive: !0,
			exact: !1,
			message: r.maxLength.message
		}), n.dirty()), t.common.async) return Promise.all([...t.data].map((e, n) => r.type._parseAsync(new di(t, e, t.path, n)))).then((e) => ii.mergeArray(n, e));
		let i = [...t.data].map((e, n) => r.type._parseSync(new di(t, e, t.path, n)));
		return ii.mergeArray(n, i);
	}
	get element() {
		return this._def.type;
	}
	min(t, n) {
		return new e({
			...this._def,
			minLength: {
				value: t,
				message: X.toString(n)
			}
		});
	}
	max(t, n) {
		return new e({
			...this._def,
			maxLength: {
				value: t,
				message: X.toString(n)
			}
		});
	}
	length(t, n) {
		return new e({
			...this._def,
			exactLength: {
				value: t,
				message: X.toString(n)
			}
		});
	}
	nonempty(e) {
		return this.min(1, e);
	}
};
Xi.create = (e, t) => new Xi({
	type: e,
	minLength: null,
	maxLength: null,
	exactLength: null,
	typeName: $.ZodArray,
	...Z(t)
});
function Zi(e) {
	if (e instanceof Qi) {
		let t = {};
		for (let n in e.shape) {
			let r = e.shape[n];
			t[n] = ga.create(Zi(r));
		}
		return new Qi({
			...e._def,
			shape: () => t
		});
	}
	return e instanceof Xi ? new Xi({
		...e._def,
		type: Zi(e.element)
	}) : e instanceof ga ? ga.create(Zi(e.unwrap())) : e instanceof _a ? _a.create(Zi(e.unwrap())) : e instanceof ia ? ia.create(e.items.map((e) => Zi(e))) : e;
}
var Qi = class e extends Q {
	constructor() {
		super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
	}
	_getCached() {
		if (this._cached !== null) return this._cached;
		let e = this._def.shape(), t = G.objectKeys(e);
		return this._cached = {
			shape: e,
			keys: t
		}, this._cached;
	}
	_parse(e) {
		if (this._getType(e) !== K.object) {
			let t = this._getOrReturnCtx(e);
			return J(t, {
				code: q.invalid_type,
				expected: K.object,
				received: t.parsedType
			}), Y;
		}
		let { status: t, ctx: n } = this._processInputParams(e), { shape: r, keys: i } = this._getCached(), a = [];
		if (!(this._def.catchall instanceof Ji && this._def.unknownKeys === "strip")) for (let e in n.data) i.includes(e) || a.push(e);
		let o = [];
		for (let e of i) {
			let t = r[e], i = n.data[e];
			o.push({
				key: {
					status: "valid",
					value: e
				},
				value: t._parse(new di(n, i, n.path, e)),
				alwaysSet: e in n.data
			});
		}
		if (this._def.catchall instanceof Ji) {
			let e = this._def.unknownKeys;
			if (e === "passthrough") for (let e of a) o.push({
				key: {
					status: "valid",
					value: e
				},
				value: {
					status: "valid",
					value: n.data[e]
				}
			});
			else if (e === "strict") a.length > 0 && (J(n, {
				code: q.unrecognized_keys,
				keys: a
			}), t.dirty());
			else if (e !== "strip") throw Error("Internal ZodObject error: invalid unknownKeys value.");
		} else {
			let e = this._def.catchall;
			for (let t of a) {
				let r = n.data[t];
				o.push({
					key: {
						status: "valid",
						value: t
					},
					value: e._parse(new di(n, r, n.path, t)),
					alwaysSet: t in n.data
				});
			}
		}
		return n.common.async ? Promise.resolve().then(async () => {
			let e = [];
			for (let t of o) {
				let n = await t.key, r = await t.value;
				e.push({
					key: n,
					value: r,
					alwaysSet: t.alwaysSet
				});
			}
			return e;
		}).then((e) => ii.mergeObjectSync(t, e)) : ii.mergeObjectSync(t, o);
	}
	get shape() {
		return this._def.shape();
	}
	strict(t) {
		return X.errToObj, new e({
			...this._def,
			unknownKeys: "strict",
			...t === void 0 ? {} : { errorMap: (e, n) => {
				let r = this._def.errorMap?.(e, n).message ?? n.defaultError;
				return e.code === "unrecognized_keys" ? { message: X.errToObj(t).message ?? r } : { message: r };
			} }
		});
	}
	strip() {
		return new e({
			...this._def,
			unknownKeys: "strip"
		});
	}
	passthrough() {
		return new e({
			...this._def,
			unknownKeys: "passthrough"
		});
	}
	extend(t) {
		return new e({
			...this._def,
			shape: () => ({
				...this._def.shape(),
				...t
			})
		});
	}
	merge(t) {
		return new e({
			unknownKeys: t._def.unknownKeys,
			catchall: t._def.catchall,
			shape: () => ({
				...this._def.shape(),
				...t._def.shape()
			}),
			typeName: $.ZodObject
		});
	}
	setKey(e, t) {
		return this.augment({ [e]: t });
	}
	catchall(t) {
		return new e({
			...this._def,
			catchall: t
		});
	}
	pick(t) {
		let n = {};
		for (let e of G.objectKeys(t)) t[e] && this.shape[e] && (n[e] = this.shape[e]);
		return new e({
			...this._def,
			shape: () => n
		});
	}
	omit(t) {
		let n = {};
		for (let e of G.objectKeys(this.shape)) t[e] || (n[e] = this.shape[e]);
		return new e({
			...this._def,
			shape: () => n
		});
	}
	deepPartial() {
		return Zi(this);
	}
	partial(t) {
		let n = {};
		for (let e of G.objectKeys(this.shape)) {
			let r = this.shape[e];
			n[e] = t && !t[e] ? r : r.optional();
		}
		return new e({
			...this._def,
			shape: () => n
		});
	}
	required(t) {
		let n = {};
		for (let e of G.objectKeys(this.shape)) if (t && !t[e]) n[e] = this.shape[e];
		else {
			let t = this.shape[e];
			for (; t instanceof ga;) t = t._def.innerType;
			n[e] = t;
		}
		return new e({
			...this._def,
			shape: () => n
		});
	}
	keyof() {
		return da(G.objectKeys(this.shape));
	}
};
Qi.create = (e, t) => new Qi({
	shape: () => e,
	unknownKeys: "strip",
	catchall: Ji.create(),
	typeName: $.ZodObject,
	...Z(t)
}), Qi.strictCreate = (e, t) => new Qi({
	shape: () => e,
	unknownKeys: "strict",
	catchall: Ji.create(),
	typeName: $.ZodObject,
	...Z(t)
}), Qi.lazycreate = (e, t) => new Qi({
	shape: e,
	unknownKeys: "strip",
	catchall: Ji.create(),
	typeName: $.ZodObject,
	...Z(t)
});
var $i = class extends Q {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e), n = this._def.options;
		function r(e) {
			for (let t of e) if (t.result.status === "valid") return t.result;
			for (let n of e) if (n.result.status === "dirty") return t.common.issues.push(...n.ctx.common.issues), n.result;
			let n = e.map((e) => new Qr(e.ctx.common.issues));
			return J(t, {
				code: q.invalid_union,
				unionErrors: n
			}), Y;
		}
		if (t.common.async) return Promise.all(n.map(async (e) => {
			let n = {
				...t,
				common: {
					...t.common,
					issues: []
				},
				parent: null
			};
			return {
				result: await e._parseAsync({
					data: t.data,
					path: t.path,
					parent: n
				}),
				ctx: n
			};
		})).then(r);
		{
			let e, r = [];
			for (let i of n) {
				let n = {
					...t,
					common: {
						...t.common,
						issues: []
					},
					parent: null
				}, a = i._parseSync({
					data: t.data,
					path: t.path,
					parent: n
				});
				if (a.status === "valid") return a;
				a.status === "dirty" && !e && (e = {
					result: a,
					ctx: n
				}), n.common.issues.length && r.push(n.common.issues);
			}
			if (e) return t.common.issues.push(...e.ctx.common.issues), e.result;
			let i = r.map((e) => new Qr(e));
			return J(t, {
				code: q.invalid_union,
				unionErrors: i
			}), Y;
		}
	}
	get options() {
		return this._def.options;
	}
};
$i.create = (e, t) => new $i({
	options: e,
	typeName: $.ZodUnion,
	...Z(t)
});
var ea = (e) => e instanceof la ? ea(e.schema) : e instanceof ha ? ea(e.innerType()) : e instanceof ua ? [e.value] : e instanceof fa ? e.options : e instanceof pa ? G.objectValues(e.enum) : e instanceof va ? ea(e._def.innerType) : e instanceof Wi ? [void 0] : e instanceof Gi ? [null] : e instanceof ga ? [void 0, ...ea(e.unwrap())] : e instanceof _a ? [null, ...ea(e.unwrap())] : e instanceof xa || e instanceof Ca ? ea(e.unwrap()) : e instanceof ya ? ea(e._def.innerType) : [], ta = class e extends Q {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e);
		if (t.parsedType !== K.object) return J(t, {
			code: q.invalid_type,
			expected: K.object,
			received: t.parsedType
		}), Y;
		let n = this.discriminator, r = t.data[n], i = this.optionsMap.get(r);
		return i ? t.common.async ? i._parseAsync({
			data: t.data,
			path: t.path,
			parent: t
		}) : i._parseSync({
			data: t.data,
			path: t.path,
			parent: t
		}) : (J(t, {
			code: q.invalid_union_discriminator,
			options: Array.from(this.optionsMap.keys()),
			path: [n]
		}), Y);
	}
	get discriminator() {
		return this._def.discriminator;
	}
	get options() {
		return this._def.options;
	}
	get optionsMap() {
		return this._def.optionsMap;
	}
	static create(t, n, r) {
		let i = /* @__PURE__ */ new Map();
		for (let e of n) {
			let n = ea(e.shape[t]);
			if (!n.length) throw Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
			for (let r of n) {
				if (i.has(r)) throw Error(`Discriminator property ${String(t)} has duplicate value ${String(r)}`);
				i.set(r, e);
			}
		}
		return new e({
			typeName: $.ZodDiscriminatedUnion,
			discriminator: t,
			options: n,
			optionsMap: i,
			...Z(r)
		});
	}
};
function na(e, t) {
	let n = Zr(e), r = Zr(t);
	if (e === t) return {
		valid: !0,
		data: e
	};
	if (n === K.object && r === K.object) {
		let n = G.objectKeys(t), r = G.objectKeys(e).filter((e) => n.indexOf(e) !== -1), i = {
			...e,
			...t
		};
		for (let n of r) {
			let r = na(e[n], t[n]);
			if (!r.valid) return { valid: !1 };
			i[n] = r.data;
		}
		return {
			valid: !0,
			data: i
		};
	}
	if (n === K.array && r === K.array) {
		if (e.length !== t.length) return { valid: !1 };
		let n = [];
		for (let r = 0; r < e.length; r++) {
			let i = e[r], a = t[r], o = na(i, a);
			if (!o.valid) return { valid: !1 };
			n.push(o.data);
		}
		return {
			valid: !0,
			data: n
		};
	}
	return n === K.date && r === K.date && +e == +t ? {
		valid: !0,
		data: e
	} : { valid: !1 };
}
var ra = class extends Q {
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e), r = (e, r) => {
			if (si(e) || si(r)) return Y;
			let i = na(e.value, r.value);
			return i.valid ? ((ci(e) || ci(r)) && t.dirty(), {
				status: t.value,
				value: i.data
			}) : (J(n, { code: q.invalid_intersection_types }), Y);
		};
		return n.common.async ? Promise.all([this._def.left._parseAsync({
			data: n.data,
			path: n.path,
			parent: n
		}), this._def.right._parseAsync({
			data: n.data,
			path: n.path,
			parent: n
		})]).then(([e, t]) => r(e, t)) : r(this._def.left._parseSync({
			data: n.data,
			path: n.path,
			parent: n
		}), this._def.right._parseSync({
			data: n.data,
			path: n.path,
			parent: n
		}));
	}
};
ra.create = (e, t, n) => new ra({
	left: e,
	right: t,
	typeName: $.ZodIntersection,
	...Z(n)
});
var ia = class e extends Q {
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.parsedType !== K.array) return J(n, {
			code: q.invalid_type,
			expected: K.array,
			received: n.parsedType
		}), Y;
		if (n.data.length < this._def.items.length) return J(n, {
			code: q.too_small,
			minimum: this._def.items.length,
			inclusive: !0,
			exact: !1,
			type: "array"
		}), Y;
		!this._def.rest && n.data.length > this._def.items.length && (J(n, {
			code: q.too_big,
			maximum: this._def.items.length,
			inclusive: !0,
			exact: !1,
			type: "array"
		}), t.dirty());
		let r = [...n.data].map((e, t) => {
			let r = this._def.items[t] || this._def.rest;
			return r ? r._parse(new di(n, e, n.path, t)) : null;
		}).filter((e) => !!e);
		return n.common.async ? Promise.all(r).then((e) => ii.mergeArray(t, e)) : ii.mergeArray(t, r);
	}
	get items() {
		return this._def.items;
	}
	rest(t) {
		return new e({
			...this._def,
			rest: t
		});
	}
};
ia.create = (e, t) => {
	if (!Array.isArray(e)) throw Error("You must pass an array of schemas to z.tuple([ ... ])");
	return new ia({
		items: e,
		typeName: $.ZodTuple,
		rest: null,
		...Z(t)
	});
};
var aa = class e extends Q {
	get keySchema() {
		return this._def.keyType;
	}
	get valueSchema() {
		return this._def.valueType;
	}
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.parsedType !== K.object) return J(n, {
			code: q.invalid_type,
			expected: K.object,
			received: n.parsedType
		}), Y;
		let r = [], i = this._def.keyType, a = this._def.valueType;
		for (let e in n.data) r.push({
			key: i._parse(new di(n, e, n.path, e)),
			value: a._parse(new di(n, n.data[e], n.path, e)),
			alwaysSet: e in n.data
		});
		return n.common.async ? ii.mergeObjectAsync(t, r) : ii.mergeObjectSync(t, r);
	}
	get element() {
		return this._def.valueType;
	}
	static create(t, n, r) {
		return n instanceof Q ? new e({
			keyType: t,
			valueType: n,
			typeName: $.ZodRecord,
			...Z(r)
		}) : new e({
			keyType: Li.create(),
			valueType: t,
			typeName: $.ZodRecord,
			...Z(n)
		});
	}
}, oa = class extends Q {
	get keySchema() {
		return this._def.keyType;
	}
	get valueSchema() {
		return this._def.valueType;
	}
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.parsedType !== K.map) return J(n, {
			code: q.invalid_type,
			expected: K.map,
			received: n.parsedType
		}), Y;
		let r = this._def.keyType, i = this._def.valueType, a = [...n.data.entries()].map(([e, t], a) => ({
			key: r._parse(new di(n, e, n.path, [a, "key"])),
			value: i._parse(new di(n, t, n.path, [a, "value"]))
		}));
		if (n.common.async) {
			let e = /* @__PURE__ */ new Map();
			return Promise.resolve().then(async () => {
				for (let n of a) {
					let r = await n.key, i = await n.value;
					if (r.status === "aborted" || i.status === "aborted") return Y;
					(r.status === "dirty" || i.status === "dirty") && t.dirty(), e.set(r.value, i.value);
				}
				return {
					status: t.value,
					value: e
				};
			});
		}
		{
			let e = /* @__PURE__ */ new Map();
			for (let n of a) {
				let r = n.key, i = n.value;
				if (r.status === "aborted" || i.status === "aborted") return Y;
				(r.status === "dirty" || i.status === "dirty") && t.dirty(), e.set(r.value, i.value);
			}
			return {
				status: t.value,
				value: e
			};
		}
	}
};
oa.create = (e, t, n) => new oa({
	valueType: t,
	keyType: e,
	typeName: $.ZodMap,
	...Z(n)
});
var sa = class e extends Q {
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.parsedType !== K.set) return J(n, {
			code: q.invalid_type,
			expected: K.set,
			received: n.parsedType
		}), Y;
		let r = this._def;
		r.minSize !== null && n.data.size < r.minSize.value && (J(n, {
			code: q.too_small,
			minimum: r.minSize.value,
			type: "set",
			inclusive: !0,
			exact: !1,
			message: r.minSize.message
		}), t.dirty()), r.maxSize !== null && n.data.size > r.maxSize.value && (J(n, {
			code: q.too_big,
			maximum: r.maxSize.value,
			type: "set",
			inclusive: !0,
			exact: !1,
			message: r.maxSize.message
		}), t.dirty());
		let i = this._def.valueType;
		function a(e) {
			let n = /* @__PURE__ */ new Set();
			for (let r of e) {
				if (r.status === "aborted") return Y;
				r.status === "dirty" && t.dirty(), n.add(r.value);
			}
			return {
				status: t.value,
				value: n
			};
		}
		let o = [...n.data.values()].map((e, t) => i._parse(new di(n, e, n.path, t)));
		return n.common.async ? Promise.all(o).then((e) => a(e)) : a(o);
	}
	min(t, n) {
		return new e({
			...this._def,
			minSize: {
				value: t,
				message: X.toString(n)
			}
		});
	}
	max(t, n) {
		return new e({
			...this._def,
			maxSize: {
				value: t,
				message: X.toString(n)
			}
		});
	}
	size(e, t) {
		return this.min(e, t).max(e, t);
	}
	nonempty(e) {
		return this.min(1, e);
	}
};
sa.create = (e, t) => new sa({
	valueType: e,
	minSize: null,
	maxSize: null,
	typeName: $.ZodSet,
	...Z(t)
});
var ca = class e extends Q {
	constructor() {
		super(...arguments), this.validate = this.implement;
	}
	_parse(e) {
		let { ctx: t } = this._processInputParams(e);
		if (t.parsedType !== K.function) return J(t, {
			code: q.invalid_type,
			expected: K.function,
			received: t.parsedType
		}), Y;
		function n(e, n) {
			return ri({
				data: e,
				path: t.path,
				errorMaps: [
					t.common.contextualErrorMap,
					t.schemaErrorMap,
					ni(),
					$r
				].filter((e) => !!e),
				issueData: {
					code: q.invalid_arguments,
					argumentsError: n
				}
			});
		}
		function r(e, n) {
			return ri({
				data: e,
				path: t.path,
				errorMaps: [
					t.common.contextualErrorMap,
					t.schemaErrorMap,
					ni(),
					$r
				].filter((e) => !!e),
				issueData: {
					code: q.invalid_return_type,
					returnTypeError: n
				}
			});
		}
		let i = { errorMap: t.common.contextualErrorMap }, a = t.data;
		if (this._def.returns instanceof ma) {
			let e = this;
			return oi(async function(...t) {
				let o = new Qr([]), s = await e._def.args.parseAsync(t, i).catch((e) => {
					throw o.addIssue(n(t, e)), o;
				}), c = await Reflect.apply(a, this, s);
				return await e._def.returns._def.type.parseAsync(c, i).catch((e) => {
					throw o.addIssue(r(c, e)), o;
				});
			});
		}
		{
			let e = this;
			return oi(function(...t) {
				let o = e._def.args.safeParse(t, i);
				if (!o.success) throw new Qr([n(t, o.error)]);
				let s = Reflect.apply(a, this, o.data), c = e._def.returns.safeParse(s, i);
				if (!c.success) throw new Qr([r(s, c.error)]);
				return c.data;
			});
		}
	}
	parameters() {
		return this._def.args;
	}
	returnType() {
		return this._def.returns;
	}
	args(...t) {
		return new e({
			...this._def,
			args: ia.create(t).rest(qi.create())
		});
	}
	returns(t) {
		return new e({
			...this._def,
			returns: t
		});
	}
	implement(e) {
		return this.parse(e);
	}
	strictImplement(e) {
		return this.parse(e);
	}
	static create(t, n, r) {
		return new e({
			args: t || ia.create([]).rest(qi.create()),
			returns: n || qi.create(),
			typeName: $.ZodFunction,
			...Z(r)
		});
	}
}, la = class extends Q {
	get schema() {
		return this._def.getter();
	}
	_parse(e) {
		let { ctx: t } = this._processInputParams(e);
		return this._def.getter()._parse({
			data: t.data,
			path: t.path,
			parent: t
		});
	}
};
la.create = (e, t) => new la({
	getter: e,
	typeName: $.ZodLazy,
	...Z(t)
});
var ua = class extends Q {
	_parse(e) {
		if (e.data !== this._def.value) {
			let t = this._getOrReturnCtx(e);
			return J(t, {
				received: t.data,
				code: q.invalid_literal,
				expected: this._def.value
			}), Y;
		}
		return {
			status: "valid",
			value: e.data
		};
	}
	get value() {
		return this._def.value;
	}
};
ua.create = (e, t) => new ua({
	value: e,
	typeName: $.ZodLiteral,
	...Z(t)
});
function da(e, t) {
	return new fa({
		values: e,
		typeName: $.ZodEnum,
		...Z(t)
	});
}
var fa = class e extends Q {
	_parse(e) {
		if (typeof e.data != "string") {
			let t = this._getOrReturnCtx(e), n = this._def.values;
			return J(t, {
				expected: G.joinValues(n),
				received: t.parsedType,
				code: q.invalid_type
			}), Y;
		}
		if (this._cache ||= new Set(this._def.values), !this._cache.has(e.data)) {
			let t = this._getOrReturnCtx(e), n = this._def.values;
			return J(t, {
				received: t.data,
				code: q.invalid_enum_value,
				options: n
			}), Y;
		}
		return oi(e.data);
	}
	get options() {
		return this._def.values;
	}
	get enum() {
		let e = {};
		for (let t of this._def.values) e[t] = t;
		return e;
	}
	get Values() {
		let e = {};
		for (let t of this._def.values) e[t] = t;
		return e;
	}
	get Enum() {
		let e = {};
		for (let t of this._def.values) e[t] = t;
		return e;
	}
	extract(t, n = this._def) {
		return e.create(t, {
			...this._def,
			...n
		});
	}
	exclude(t, n = this._def) {
		return e.create(this.options.filter((e) => !t.includes(e)), {
			...this._def,
			...n
		});
	}
};
fa.create = da;
var pa = class extends Q {
	_parse(e) {
		let t = G.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
		if (n.parsedType !== K.string && n.parsedType !== K.number) {
			let e = G.objectValues(t);
			return J(n, {
				expected: G.joinValues(e),
				received: n.parsedType,
				code: q.invalid_type
			}), Y;
		}
		if (this._cache ||= new Set(G.getValidEnumValues(this._def.values)), !this._cache.has(e.data)) {
			let e = G.objectValues(t);
			return J(n, {
				received: n.data,
				code: q.invalid_enum_value,
				options: e
			}), Y;
		}
		return oi(e.data);
	}
	get enum() {
		return this._def.values;
	}
};
pa.create = (e, t) => new pa({
	values: e,
	typeName: $.ZodNativeEnum,
	...Z(t)
});
var ma = class extends Q {
	unwrap() {
		return this._def.type;
	}
	_parse(e) {
		let { ctx: t } = this._processInputParams(e);
		return t.parsedType !== K.promise && t.common.async === !1 ? (J(t, {
			code: q.invalid_type,
			expected: K.promise,
			received: t.parsedType
		}), Y) : oi((t.parsedType === K.promise ? t.data : Promise.resolve(t.data)).then((e) => this._def.type.parseAsync(e, {
			path: t.path,
			errorMap: t.common.contextualErrorMap
		})));
	}
};
ma.create = (e, t) => new ma({
	type: e,
	typeName: $.ZodPromise,
	...Z(t)
});
var ha = class extends Q {
	innerType() {
		return this._def.schema;
	}
	sourceType() {
		return this._def.schema._def.typeName === $.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
	}
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e), r = this._def.effect || null, i = {
			addIssue: (e) => {
				J(n, e), e.fatal ? t.abort() : t.dirty();
			},
			get path() {
				return n.path;
			}
		};
		if (i.addIssue = i.addIssue.bind(i), r.type === "preprocess") {
			let e = r.transform(n.data, i);
			if (n.common.async) return Promise.resolve(e).then(async (e) => {
				if (t.value === "aborted") return Y;
				let r = await this._def.schema._parseAsync({
					data: e,
					path: n.path,
					parent: n
				});
				return r.status === "aborted" ? Y : r.status === "dirty" || t.value === "dirty" ? ai(r.value) : r;
			});
			{
				if (t.value === "aborted") return Y;
				let r = this._def.schema._parseSync({
					data: e,
					path: n.path,
					parent: n
				});
				return r.status === "aborted" ? Y : r.status === "dirty" || t.value === "dirty" ? ai(r.value) : r;
			}
		}
		if (r.type === "refinement") {
			let e = (e) => {
				let t = r.refinement(e, i);
				if (n.common.async) return Promise.resolve(t);
				if (t instanceof Promise) throw Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
				return e;
			};
			if (n.common.async === !1) {
				let r = this._def.schema._parseSync({
					data: n.data,
					path: n.path,
					parent: n
				});
				return r.status === "aborted" ? Y : (r.status === "dirty" && t.dirty(), e(r.value), {
					status: t.value,
					value: r.value
				});
			}
			return this._def.schema._parseAsync({
				data: n.data,
				path: n.path,
				parent: n
			}).then((n) => n.status === "aborted" ? Y : (n.status === "dirty" && t.dirty(), e(n.value).then(() => ({
				status: t.value,
				value: n.value
			}))));
		}
		if (r.type === "transform") {
			if (n.common.async === !1) {
				let e = this._def.schema._parseSync({
					data: n.data,
					path: n.path,
					parent: n
				});
				if (!li(e)) return Y;
				let a = r.transform(e.value, i);
				if (a instanceof Promise) throw Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
				return {
					status: t.value,
					value: a
				};
			}
			return this._def.schema._parseAsync({
				data: n.data,
				path: n.path,
				parent: n
			}).then((e) => li(e) ? Promise.resolve(r.transform(e.value, i)).then((e) => ({
				status: t.value,
				value: e
			})) : Y);
		}
		G.assertNever(r);
	}
};
ha.create = (e, t, n) => new ha({
	schema: e,
	typeName: $.ZodEffects,
	effect: t,
	...Z(n)
}), ha.createWithPreprocess = (e, t, n) => new ha({
	schema: t,
	effect: {
		type: "preprocess",
		transform: e
	},
	typeName: $.ZodEffects,
	...Z(n)
});
var ga = class extends Q {
	_parse(e) {
		return this._getType(e) === K.undefined ? oi(void 0) : this._def.innerType._parse(e);
	}
	unwrap() {
		return this._def.innerType;
	}
};
ga.create = (e, t) => new ga({
	innerType: e,
	typeName: $.ZodOptional,
	...Z(t)
});
var _a = class extends Q {
	_parse(e) {
		return this._getType(e) === K.null ? oi(null) : this._def.innerType._parse(e);
	}
	unwrap() {
		return this._def.innerType;
	}
};
_a.create = (e, t) => new _a({
	innerType: e,
	typeName: $.ZodNullable,
	...Z(t)
});
var va = class extends Q {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e), n = t.data;
		return t.parsedType === K.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
			data: n,
			path: t.path,
			parent: t
		});
	}
	removeDefault() {
		return this._def.innerType;
	}
};
va.create = (e, t) => new va({
	innerType: e,
	typeName: $.ZodDefault,
	defaultValue: typeof t.default == "function" ? t.default : () => t.default,
	...Z(t)
});
var ya = class extends Q {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e), n = {
			...t,
			common: {
				...t.common,
				issues: []
			}
		}, r = this._def.innerType._parse({
			data: n.data,
			path: n.path,
			parent: { ...n }
		});
		return ui(r) ? r.then((e) => ({
			status: "valid",
			value: e.status === "valid" ? e.value : this._def.catchValue({
				get error() {
					return new Qr(n.common.issues);
				},
				input: n.data
			})
		})) : {
			status: "valid",
			value: r.status === "valid" ? r.value : this._def.catchValue({
				get error() {
					return new Qr(n.common.issues);
				},
				input: n.data
			})
		};
	}
	removeCatch() {
		return this._def.innerType;
	}
};
ya.create = (e, t) => new ya({
	innerType: e,
	typeName: $.ZodCatch,
	catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
	...Z(t)
});
var ba = class extends Q {
	_parse(e) {
		if (this._getType(e) !== K.nan) {
			let t = this._getOrReturnCtx(e);
			return J(t, {
				code: q.invalid_type,
				expected: K.nan,
				received: t.parsedType
			}), Y;
		}
		return {
			status: "valid",
			value: e.data
		};
	}
};
ba.create = (e) => new ba({
	typeName: $.ZodNaN,
	...Z(e)
});
var xa = class extends Q {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e), n = t.data;
		return this._def.type._parse({
			data: n,
			path: t.path,
			parent: t
		});
	}
	unwrap() {
		return this._def.type;
	}
}, Sa = class e extends Q {
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.common.async) return (async () => {
			let e = await this._def.in._parseAsync({
				data: n.data,
				path: n.path,
				parent: n
			});
			return e.status === "aborted" ? Y : e.status === "dirty" ? (t.dirty(), ai(e.value)) : this._def.out._parseAsync({
				data: e.value,
				path: n.path,
				parent: n
			});
		})();
		{
			let e = this._def.in._parseSync({
				data: n.data,
				path: n.path,
				parent: n
			});
			return e.status === "aborted" ? Y : e.status === "dirty" ? (t.dirty(), {
				status: "dirty",
				value: e.value
			}) : this._def.out._parseSync({
				data: e.value,
				path: n.path,
				parent: n
			});
		}
	}
	static create(t, n) {
		return new e({
			in: t,
			out: n,
			typeName: $.ZodPipeline
		});
	}
}, Ca = class extends Q {
	_parse(e) {
		let t = this._def.innerType._parse(e), n = (e) => (li(e) && (e.value = Object.freeze(e.value)), e);
		return ui(t) ? t.then((e) => n(e)) : n(t);
	}
	unwrap() {
		return this._def.innerType;
	}
};
Ca.create = (e, t) => new Ca({
	innerType: e,
	typeName: $.ZodReadonly,
	...Z(t)
}), Qi.lazycreate;
var $;
(function(e) {
	e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})($ ||= {}), Li.create, zi.create, ba.create, Bi.create, Vi.create, Hi.create, Ui.create, Wi.create, Gi.create, Ki.create, qi.create, Ji.create, Yi.create, Xi.create;
var wa = Qi.create;
Qi.strictCreate, $i.create, ta.create, ra.create, ia.create, aa.create, oa.create, sa.create, ca.create, la.create, ua.create, fa.create, pa.create, ma.create, ha.create, ga.create, _a.create, ha.createWithPreprocess, Sa.create;
//#endregion
//#region lib/components/Styles/textSx.ts
var Ta = {
	xs: { fontSize: (e) => e.typography.pxToRem(10) },
	sm: { fontSize: (e) => e.typography.pxToRem(12) },
	md: { fontSize: (e) => e.typography.pxToRem(14) },
	mdlg: { fontSize: (e) => e.typography.pxToRem(16) },
	lg: { fontSize: (e) => e.typography.pxToRem(18) },
	xl: { fontSize: (e) => e.typography.pxToRem(20) },
	bold: { fontWeight: "bold" },
	nonDecoration: { textDecoration: "none" },
	underlineOnHover: { "&:hover": { textDecoration: "underline" } },
	underline: { textDecoration: "underline" },
	primaryText: { color: "primary.main" },
	secondaryText: { color: "text.secondary" },
	whiteText: { color: "background.paper" },
	blackText: { color: "text.primary" }
}, Ea = ye(({ bgcolor: e, ...t }, n) => /* @__PURE__ */ D(se, {
	...t,
	ref: n,
	slotProps: {
		...t.slotProps,
		inputLabel: {
			...t.slotProps?.inputLabel,
			sx: {
				...Ta.md,
				lineHeight: "1em",
				top: "-2px",
				[`&:not(.${pe.shrink})`]: { transform: "translate(14px, 9px) scale(1)" }
			}
		},
		input: {
			...t.slotProps?.input,
			sx: {
				...t.slotProps?.input?.sx,
				...Ta.md,
				...t.disabled === !0 ? { bgcolor: "#F5F5F5" } : {
					boxShadow: "0px 2px 1px inset rgb(0,0,0,0.1)",
					bgcolor: e
				},
				paddingTop: 0,
				paddingBottom: 0,
				[`& .${fe.input}`]: {
					paddingTop: "4px",
					paddingBottom: "4px"
				}
			}
		}
	}
})), Da = ye(({ bgcolor: t, error: n, helperText: r, label: i, disabled: a, placeholder: o, required: s, hasError: c = !1, size: l = "small", ...u }, d) => /* @__PURE__ */ D(e, {
	...u,
	ref: d,
	size: l,
	sx: {
		[`& .${pe.root}`]: {
			top: "-2px",
			...Ta.md
		},
		[`& .${ue.inputRoot}.${me.root}`]: {
			paddingTop: 0,
			paddingBottom: 0,
			[`& .${ue.input}`]: {
				paddingTop: "4px",
				paddingBottom: "4px"
			}
		},
		...u.sx
	},
	disabled: a,
	renderInput: (e) => /* @__PURE__ */ D(Ea, {
		...e,
		label: i,
		variant: "outlined",
		error: c || !!n,
		placeholder: o,
		helperText: r ?? n?.message,
		required: s,
		bgcolor: t
	})
})), Oa = ({ name: e, options: t, disabled: n }) => {
	let { control: r } = tr(), i = fn({
		control: r,
		name: e.defaultOrganizationUid
	}), a = fn({
		control: r,
		name: e.organizationUids
	}), o = Se(() => t.filter((e) => a.includes(e.organizationUid)), [a, t]), s = !a.includes(i) && a.length > 0;
	return /* @__PURE__ */ D(V, {
		name: e.defaultOrganizationUid,
		control: r,
		render: ({ field: e }) => /* @__PURE__ */ D(Da, {
			options: o,
			value: t.find((t) => t.organizationUid === e.value) ?? null,
			onChange: (n, r) => {
				t.find((e) => e.organizationUid === r?.organizationUid) && e.onChange(r?.organizationUid);
			},
			disabled: a == null || a.length === 0 || n,
			placeholder: "デフォルト組織",
			sx: {
				maxWidth: "480px",
				mt: 2
			},
			hasError: s,
			helperText: s ? "所属組織内からデフォルトの組織を選択する必要があります" : void 0
		})
	});
}, ka = ({ options: e, disabled: t }) => /* @__PURE__ */ D(Oa, {
	options: e,
	disabled: t,
	name: {
		organizationUids: "organizationUids",
		defaultOrganizationUid: "defaultOrganizationUid"
	}
}), Aa = ye(({ itemList: e, ...t }, n) => /* @__PURE__ */ D(te, {
	...t,
	ref: n,
	inputProps: {
		...t.inputProps,
		sx: {
			...t.inputProps?.sx,
			...Ta.md,
			...t.disabled === !0 ? { bgcolor: "#F5F5F5" } : { boxShadow: "0px 2px 1px inset rgb(0,0,0,0.1)" },
			paddingTop: "4px",
			paddingBottom: "4px"
		}
	},
	children: e.map((e) => /* @__PURE__ */ D(y, {
		value: e.value,
		children: e.text
	}, e.value))
})), ja = ({ name: e, generator: n, limitDenwaLists: r, disabled: i, required: a = !1, disableGutters: o = !1 }) => {
	let { control: s, getFieldState: c, trigger: l } = tr(), u = un({
		control: s,
		name: n.fieldNames.field
	}), { error: d } = c(n.fieldNames.field, u), f = d?.message ?? d?.root?.message, m = Kn({
		control: s,
		name: e
	});
	return /* @__PURE__ */ O(W, {
		label: "電話番号",
		required: a,
		componentProps: { sx: {
			display: "flex",
			flexDirection: "column",
			gap: "8px"
		} },
		disableGutters: o,
		children: [
			m.fields.map(({ id: e }, r) => /* @__PURE__ */ O(t, {
				sx: {
					display: "flex",
					flexDirection: "row",
					gap: "8px",
					alignItems: "baseline",
					width: "100%",
					maxWidth: "480px"
				},
				children: [
					/* @__PURE__ */ D(V, {
						name: n.fieldNames.denwaNumber(r),
						control: s,
						render: ({ field: e, fieldState: { error: t } }) => /* @__PURE__ */ D(Ea, {
							...e,
							error: !!t,
							size: "small",
							helperText: t?.message,
							fullWidth: !0,
							disabled: i,
							onChange: (t) => {
								e.onChange(t.target.value), l(n.fieldNames.field);
							}
						})
					}),
					/* @__PURE__ */ D(V, {
						name: n.fieldNames.denwaNumberShubetsu(r),
						control: s,
						render: ({ field: e }) => /* @__PURE__ */ D(Aa, {
							...e,
							size: "small",
							fullWidth: !0,
							sx: { maxWidth: {
								xs: "6rem",
								md: "9rem"
							} },
							disabled: i,
							itemList: Me.map((e) => ({
								text: e,
								value: e
							})),
							onChange: (t) => {
								e.onChange(t.target?.value), l(n.fieldNames.field);
							}
						})
					}),
					/* @__PURE__ */ D(t, {
						sx: { visibility: i || a && r === 0 && m.fields.length === 1 ? "hidden" : "visible" },
						children: /* @__PURE__ */ D(bt, {
							type: "button",
							onClick: () => m.remove(r),
							icon: "close",
							variant: "iconOnly"
						})
					})
				]
			}, e)),
			f != null && /* @__PURE__ */ D(p, {
				error: !0,
				children: f
			}),
			/* @__PURE__ */ D(t, {
				sx: {
					display: "flex",
					flexDirection: "row"
				},
				children: /* @__PURE__ */ O(j, {
					type: "button",
					onClick: () => m.append(...n.defaultValue()),
					disabled: i || m.fields.length >= r,
					variant: "text",
					prependIcon: "add",
					children: [/* @__PURE__ */ D(C, {
						variant: "button",
						sx: { fontWeight: "bold" },
						children: "行を追加"
					}), /* @__PURE__ */ D(C, {
						variant: "button",
						children: "（最大３件）"
					})]
				})
			})
		]
	});
}, Ma = ({ limitDenwaLists: e, disabled: t, required: n }) => /* @__PURE__ */ D(ja, {
	required: n,
	limitDenwaLists: e,
	disabled: t,
	name: "denwaList",
	generator: {
		fieldNames: {
			field: "denwaList",
			denwaNumber: (e) => `denwaList.${e}.denwaNumber`,
			denwaNumberShubetsu: (e) => `denwaList.${e}.denwaNumberShubetsu`
		},
		defaultValue: () => [{
			denwaNumberShubetsu: "電話",
			denwaNumber: ""
		}]
	}
}), Na = ({ required: e = !0, ...t }) => /* @__PURE__ */ D(ja, {
	...t,
	required: e,
	name: "domain.denwaList",
	generator: {
		fieldNames: {
			field: "domain.denwaList",
			denwaNumber: (e) => `domain.denwaList.${e}.denwaNumber`,
			denwaNumberShubetsu: (e) => `domain.denwaList.${e}.denwaNumberShubetsu`
		},
		defaultValue: () => [{
			denwaNumberShubetsu: "電話",
			denwaNumber: ""
		}]
	}
}), Pa = ({ required: e = !0, ...t }) => /* @__PURE__ */ D(ja, {
	...t,
	required: e,
	name: "organization.denwaList",
	generator: {
		fieldNames: {
			field: "organization.denwaList",
			denwaNumber: (e) => `organization.denwaList.${e}.denwaNumber`,
			denwaNumberShubetsu: (e) => `organization.denwaList.${e}.denwaNumberShubetsu`
		},
		defaultValue: () => [{
			denwaNumberShubetsu: "電話",
			denwaNumber: ""
		}]
	}
}), Fa = ({ isLoadingJushoTextOptions: e, jushoTextOptionsErrorType: t, isDirectInput: n, hasEbone: r }) => e ? /* @__PURE__ */ D(_, { sx: {
	width: "100%",
	maxWidth: "400px"
} }) : n ? r ? /* @__PURE__ */ D(C, {
	variant: "caption",
	color: "error",
	sx: { px: 1 },
	children: "郵便番号入力後の候補から住所を再設定してください"
}) : null : t == null ? null : t === "notFound" ? /* @__PURE__ */ D(C, {
	variant: "caption",
	color: "error",
	sx: { px: 1 },
	children: "該当する郵便番号を特定できません"
}) : /* @__PURE__ */ D(C, {
	variant: "caption",
	color: "error",
	sx: { px: 1 },
	children: "住所の確認に失敗しました。再度お試しください"
}), Ia = ({ generator: e, jushoTextOptions: n, isLoadingJushoTextOptions: i, jushoTextOptionsErrorType: a, disabled: o, hasEbone: s }) => {
	let { control: c, watch: l, setValue: u } = tr(), d = l(e.fieldNames.isDirectInput), p = l(e.fieldNames.jushoText);
	return d && (n.find((e) => e === p) ?? "") !== "" && u(e.fieldNames.isDirectInput, !1), /* @__PURE__ */ O(S, {
		spacing: 1.5,
		sx: { width: "100%" },
		children: [
			n.length === 0 && !d && /* @__PURE__ */ D(C, {
				variant: "caption",
				sx: { color: "text.secondary" },
				children: "郵便番号を入力すると候補から住所を選択できます"
			}),
			/* @__PURE__ */ D(V, {
				name: e.fieldNames.yubinNumber,
				control: c,
				render: ({ field: e, fieldState: { error: t } }) => /* @__PURE__ */ D(Ea, {
					...e,
					onChange: (t) => e.onChange(t.target.value.replace("-", "")),
					slotProps: { input: { startAdornment: /* @__PURE__ */ D(h, {
						position: "start",
						children: "〒"
					}) } },
					placeholder: "郵便番号",
					sx: {
						width: "100%",
						maxWidth: { md: "200px" }
					},
					fullWidth: !0,
					required: !0,
					error: !!t,
					helperText: t?.message,
					disabled: o
				})
			}),
			/* @__PURE__ */ O(t, { children: [
				/* @__PURE__ */ D(V, {
					name: e.fieldNames.jushoText,
					control: c,
					render: ({ field: t, fieldState: { error: r } }) => /* @__PURE__ */ D(Da, {
						...t,
						freeSolo: d,
						loading: i,
						options: n,
						disabled: n.length === 0 && !d || o,
						noOptionsText: "",
						isOptionEqualToValue: (e, t) => e === t,
						onInputChange: (e, n) => {
							d && t.onChange(n);
						},
						onChange: (n, r) => {
							d ? r !== null && u(e.fieldNames.isDirectInput, !1) : t.onChange(r);
						},
						placeholder: "住所",
						error: r,
						fullWidth: !0
					})
				}),
				/* @__PURE__ */ D(Fa, {
					isLoadingJushoTextOptions: i,
					jushoTextOptionsErrorType: a,
					isDirectInput: d,
					hasEbone: s
				}),
				(d || a != null) && !s && !i && /* @__PURE__ */ D(t, { children: /* @__PURE__ */ D(V, {
					name: e.fieldNames.isDirectInput,
					control: c,
					render: ({ field: e }) => /* @__PURE__ */ D(f, {
						...e,
						label: "住所を直接入力する",
						slotProps: { typography: { color: "text.secondary" } },
						control: /* @__PURE__ */ D(r, {
							size: "small",
							checked: e.value
						})
					})
				}) })
			] }),
			/* @__PURE__ */ O(S, {
				direction: "row",
				spacing: 1,
				children: [/* @__PURE__ */ D(V, {
					name: e.fieldNames.nokoriJusho,
					control: c,
					render: ({ field: e, fieldState: { error: t } }) => /* @__PURE__ */ D(Ea, {
						...e,
						error: !!t,
						helperText: t?.message,
						placeholder: "番地以降",
						sx: { width: "100%" },
						fullWidth: !0,
						disabled: o
					})
				}), /* @__PURE__ */ D(V, {
					name: e.fieldNames.gaikuGoto,
					control: c,
					render: ({ field: e, fieldState: { error: t } }) => /* @__PURE__ */ D(Ea, {
						...e,
						error: !!t,
						helperText: t?.message,
						placeholder: "街区・号棟",
						sx: { width: "100%" },
						fullWidth: !0,
						disabled: o
					})
				})]
			})
		]
	});
}, La = ({ name: e, options: t, disabled: n }) => {
	let { control: r } = tr();
	return /* @__PURE__ */ D(V, {
		name: e,
		control: r,
		render: ({ field: e }) => /* @__PURE__ */ D(Da, {
			multiple: !0,
			limitTags: 2,
			options: t,
			getOptionLabel: (e) => e.label,
			isOptionEqualToValue: (e, t) => e.organizationUid === t.organizationUid,
			value: t.filter((t) => e.value?.includes(t.organizationUid) === !0),
			onChange: (t, n) => e.onChange(n?.map((e) => e.organizationUid)),
			sx: { maxWidth: "480px" },
			disabled: n
		})
	});
}, Ra = ({ options: e, disabled: t }) => /* @__PURE__ */ D(La, {
	options: e,
	disabled: t,
	name: "organizationUids"
}), za = ({ name: e, options: n, disabled: r }) => {
	let { control: i } = tr(), a = ve(), o = _e(a.breakpoints.down("md"));
	return /* @__PURE__ */ D(W, {
		label: "権限クラス",
		children: /* @__PURE__ */ D(t, {
			sx: {
				mb: o ? 3 : 0,
				width: "100%"
			},
			children: /* @__PURE__ */ D(V, {
				control: i,
				name: e,
				render: ({ field: e }) => /* @__PURE__ */ D(Da, {
					options: n,
					getOptionLabel: (e) => e.label,
					isOptionEqualToValue: (e, t) => e.roleUid === t.roleUid,
					value: n.find((t) => e.value === t.roleUid) ?? null,
					onChange: (t, r) => {
						n.find((e) => e.roleUid === r?.roleUid) && e.onChange(r?.roleUid);
					},
					sx: {
						minWidth: "170px",
						maxWidth: "480px"
					},
					disabled: r
				})
			})
		})
	});
}, Ba = ({ options: e, disabled: t }) => /* @__PURE__ */ D(za, {
	options: e,
	disabled: t,
	name: "roleUid"
});
//#endregion
//#region lib/components/Dialogs/EmailChangeDialog/index.tsx
ti(je);
var Va = wa({
	providerUserUid: Ae.shape.providerUserUid,
	email: Oe
}), Ha = ({ open: e, control: n, email: r, onCancel: i, onSubmit: a, isSubmitting: o, disabled: u }) => /* @__PURE__ */ D(t, { children: /* @__PURE__ */ D(s, {
	open: e,
	fullWidth: !0,
	children: /* @__PURE__ */ O("form", {
		onSubmit: a,
		children: [
			/* @__PURE__ */ D(At, {
				onClose: i,
				disableCloseButton: o,
				children: "メールアドレス変更"
			}),
			/* @__PURE__ */ D(l, { children: /* @__PURE__ */ O(S, {
				spacing: 3,
				sx: {
					pt: 2,
					pb: 1
				},
				children: [/* @__PURE__ */ O(S, {
					spacing: .5,
					children: [
						/* @__PURE__ */ D(C, { children: "以下へ新しいメールアドレスを入力してください。" }),
						/* @__PURE__ */ D(C, { children: "メールアドレス変更のご案内を送信します。" }),
						r != null && r.length > 0 && /* @__PURE__ */ O(C, {
							variant: "caption",
							sx: {
								color: "text.secondary",
								pt: .5
							},
							children: ["現在のメールアドレス：", r]
						})
					]
				}), /* @__PURE__ */ D(V, {
					name: "email",
					control: n,
					render: ({ field: e, fieldState: { error: t } }) => /* @__PURE__ */ D(Ea, {
						...e,
						placeholder: "新しいメールアドレス",
						fullWidth: !0,
						error: t !== void 0,
						helperText: t?.message
					})
				})]
			}) }),
			/* @__PURE__ */ O(c, { children: [/* @__PURE__ */ D(j, {
				type: "button",
				variant: "text",
				onClick: i,
				disabled: o,
				children: "キャンセル"
			}), /* @__PURE__ */ D(j, {
				variant: "contained",
				type: "submit",
				isLoading: o,
				disabled: u,
				children: "送信する"
			})] })
		]
	})
}) }), Ua = E(({ open: e, email: t, error: n, ticketUrl: r, isLoading: i, onClick: a, onCancel: o, disabled: d }) => /* @__PURE__ */ O(s, {
	open: e,
	fullWidth: !0,
	children: [
		/* @__PURE__ */ D(At, {
			onClose: o,
			disableCloseButton: i,
			children: "パスワードの変更"
		}),
		/* @__PURE__ */ D(l, { children: /* @__PURE__ */ O(S, {
			spacing: 1,
			sx: { pt: 2 },
			children: [
				/* @__PURE__ */ O(u, { children: [
					"以下アカウントのパスワードを変更します。",
					/* @__PURE__ */ D("br", {}),
					"次の画面で新しいパスワードを入力してください。"
				] }),
				/* @__PURE__ */ D(u, { children: /* @__PURE__ */ D("li", { children: t }) }),
				/* @__PURE__ */ D(u, { children: "実行すると専用ページに遷移します。" }),
				n && /* @__PURE__ */ D(u, { children: "予期せぬエラーが発生しました。お手数ですがはじめからやり直してください。" }),
				r != null && r.length > 0 && /* @__PURE__ */ O(u, { children: [
					"ページが変わらない場合は ",
					/* @__PURE__ */ D(v, {
						href: r,
						children: "こちら"
					}),
					" ",
					"をクリックしてください。"
				] })
			]
		}) }),
		/* @__PURE__ */ O(c, { children: [/* @__PURE__ */ D(j, {
			type: "button",
			variant: "text",
			onClick: o,
			children: "キャンセル"
		}), !n && /* @__PURE__ */ D(j, {
			type: "button",
			variant: "contained",
			isLoading: i,
			disabled: d,
			onClick: () => void a(),
			children: "変更する"
		})] })
	]
})), Wa = E(({ open: e, disabled: t, isLoading: n, error: r, ticketUrl: i, onClick: a, onCancel: o }) => /* @__PURE__ */ O(s, {
	open: e,
	fullWidth: !0,
	children: [
		/* @__PURE__ */ D(At, {
			onClose: o,
			disableCloseButton: n,
			children: "デバイスの設定"
		}),
		/* @__PURE__ */ D(l, { children: /* @__PURE__ */ O(S, {
			spacing: 1,
			sx: { pt: 2 },
			children: [
				/* @__PURE__ */ D(st, {
					color: "info",
					children: /* @__PURE__ */ D(st.Title, { children: "次回ログインからワンタイムパスワードによる認証が必要になります。" })
				}),
				/* @__PURE__ */ O(u, {
					sx: { pt: 1 },
					children: [
						"認証アプリをご準備のうえ、設定を開始してください。",
						/* @__PURE__ */ D("br", {}),
						"実行すると専用ページに遷移します。"
					]
				}),
				r && /* @__PURE__ */ D(u, { children: "予期せぬエラーが発生しました。お手数ですがはじめからやり直してください。" }),
				i != null && i.length > 0 && /* @__PURE__ */ O(u, { children: [
					"ページが変わらない場合は",
					" ",
					/* @__PURE__ */ D(v, {
						href: i,
						target: "_blank",
						rel: "noopener noreferrer",
						children: "こちら"
					}),
					" ",
					"をクリックしてください。"
				] })
			]
		}) }),
		/* @__PURE__ */ O(c, { children: [/* @__PURE__ */ D(j, {
			type: "button",
			variant: "text",
			onClick: o,
			children: "キャンセル"
		}), !r && /* @__PURE__ */ D(j, {
			type: "button",
			variant: "contained",
			isLoading: n,
			disabled: t,
			onClick: () => void a(),
			children: "設定を始める"
		})] })
	]
})), Ga = ({ children: e, label: n, labelSx: r, componentSx: a, required: o }) => jt() ? /* @__PURE__ */ O(t, {
	sx: {
		display: "flex",
		flexDirection: "column",
		rowGap: 1.75
	},
	children: [/* @__PURE__ */ O(t, {
		sx: {
			display: "flex",
			alignItems: "center"
		},
		children: [/* @__PURE__ */ D(C, {
			sx: {
				...Ta.bold,
				...Ta.md,
				...r
			},
			children: n
		}), o === !0 && /* @__PURE__ */ D(i, {
			variant: "outlined",
			color: "error",
			size: "small",
			label: "必須",
			sx: { mx: 1 }
		})]
	}), /* @__PURE__ */ D(t, {
		sx: {
			display: "flex",
			flexDirection: "column",
			rowGap: 1.5,
			wordBreak: "break-all",
			...a
		},
		children: e
	})]
}) : /* @__PURE__ */ O(Te, { children: [/* @__PURE__ */ O(t, {
	sx: {
		px: 2,
		py: 2,
		display: "flex",
		flexDirection: "row",
		justifyContent: "flex-start",
		boxSizing: "content-box",
		alignItems: "center",
		bgcolor: (e) => e.palette.background.grey,
		borderBottom: (e) => `solid 1px ${e.palette.divider}`,
		...r
	},
	children: [/* @__PURE__ */ D(C, {
		sx: { ...Ta.md },
		children: n
	}), o === !0 && /* @__PURE__ */ D(i, {
		variant: "outlined",
		color: "error",
		size: "small",
		label: "必須",
		sx: { mx: 1 }
	})]
}), /* @__PURE__ */ D(t, {
	sx: {
		p: 2,
		gap: "8px",
		borderBottom: (e) => `solid 1px ${e.palette.divider}`,
		wordBreak: "break-all",
		...a
	},
	children: e
})] }), Ka = ({ children: e }) => jt() ? /* @__PURE__ */ D(t, {
	sx: {
		display: "flex",
		flexDirection: "column",
		rowGap: 2,
		"& > *:not(:first-of-type)": {
			borderTop: (e) => `solid 1px ${e.palette.divider}`,
			pt: 2
		}
	},
	children: e
}) : /* @__PURE__ */ D(t, {
	sx: {
		display: "grid",
		gridTemplateColumns: ["minmax(25%, auto)", "1fr"].join(" "),
		borderTop: (e) => `solid 1px ${e.palette.divider}`
	},
	children: e
}), qa = ({ children: e }) => /* @__PURE__ */ O(o, {
	sx: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "flex-start",
		bgcolor: (e) => e.palette.background.grey,
		minHeight: "100vh",
		pb: 2
	},
	children: [/* @__PURE__ */ D(t, {
		sx: {
			mb: 2,
			width: "100%",
			maxWidth: 280
		},
		children: /* @__PURE__ */ D("img", {
			alt: "logo",
			style: { width: "100%" },
			src: "/img/esa_logo.svg"
		})
	}), /* @__PURE__ */ D("div", { children: e })]
}), Ja = ge(Be)(({ theme: e }) => ({
	backgroundColor: "#FFF",
	color: "#000",
	transition: e.transitions.create(["margin", "width"], {
		easing: e.transitions.easing.sharp,
		duration: e.transitions.duration.leavingScreen
	}),
	[e.breakpoints.up("xs")]: { zIndex: e.zIndex.drawer - 1 },
	[e.breakpoints.up("md")]: { zIndex: e.zIndex.drawer + 1 }
})), Ya = {
	fontSize: 16,
	fontWeight: "bold"
}, Xa = ({ title: e, titleAdornment: r, collapsible: i = !0, defaultOpen: o = !1, children: s }) => {
	let [c, l] = we(o), u = xe(), d = i && e != null, f = /* @__PURE__ */ D(C, {
		component: "span",
		sx: Ya,
		children: e
	});
	return /* @__PURE__ */ O(t, {
		sx: {
			border: "1px solid rgba(0, 0, 0, 0.12)",
			borderRadius: 1,
			px: 2,
			pb: 2,
			mt: 2,
			mx: {
				xs: 2,
				md: 0
			}
		},
		children: [e != null && (d ? /* @__PURE__ */ O(n, {
			onClick: () => l((e) => !e),
			"aria-expanded": c,
			"aria-controls": u,
			sx: {
				display: "flex",
				justifyContent: "space-between",
				width: "100%",
				pt: 1.5,
				textAlign: "left"
			},
			children: [r == null ? f : /* @__PURE__ */ O(t, {
				component: "span",
				sx: {
					display: "flex",
					alignItems: "center",
					gap: 1
				},
				children: [f, r]
			}), /* @__PURE__ */ D(A, {
				iconName: c ? "expandLess" : "expandMore",
				color: "black"
			})]
		}) : /* @__PURE__ */ D(C, {
			sx: {
				...Ya,
				pt: 1.5
			},
			children: e
		})), d ? /* @__PURE__ */ D(a, {
			in: c,
			timeout: "auto",
			id: u,
			children: s
		}) : s]
	});
}, Za = {
	main: {
		mobile: {
			typography: {
				mx: 0,
				fontSize: 20,
				fontWeight: "bold"
			},
			box: {
				py: 2,
				mx: 2,
				mt: 0,
				backgroundColor: "#F5F5F5"
			}
		},
		desktop: {
			typography: {
				pb: 2,
				fontSize: 20,
				fontWeight: "bold"
			},
			box: {
				px: 3,
				py: 3,
				mt: 0,
				backgroundColor: "#F5F5F5"
			}
		}
	},
	sub: {
		mobile: {
			typography: {
				mx: 2,
				fontSize: 16,
				fontWeight: "bold"
			},
			box: {
				py: 2,
				mx: 0,
				mt: 3,
				backgroundColor: "white",
				border: "1px solid rgba(0, 0, 0, 0.12)"
			}
		},
		desktop: {
			typography: {
				pb: 2,
				fontSize: 16,
				fontWeight: "bold"
			},
			box: {
				px: 3,
				py: 3,
				mt: 3,
				backgroundColor: "white",
				border: "1px solid rgba(0, 0, 0, 0.12)"
			}
		}
	},
	inner: {
		mobile: {
			typography: {
				mx: 0,
				fontSize: 16,
				fontWeight: "bold"
			},
			box: {
				py: 0,
				mx: 0,
				mt: 3
			}
		},
		desktop: {
			typography: {
				pb: 0,
				fontSize: 16,
				fontWeight: "bold"
			},
			box: {
				px: 0,
				py: 1,
				mt: 2
			}
		}
	}
}, Qa = (e) => Array.isArray(e), $a = (e) => Qa(e) ? e : [e], eo = ({ children: e, title: n, variant: r = "main", expandIcon: i, openMenu: a, onClickEvent: o, actionComponent: s, firstSection: c, sx: l, titleGutters: u, ...d }) => /* @__PURE__ */ O(t, {
	...d,
	sx: [
		Za[r].mobile.box,
		c === !0 ? { mt: 0 } : null,
		...$a(l)
	],
	children: [/* @__PURE__ */ O(t, {
		sx: {
			display: "flex",
			flexDirection: "row",
			alignItems: "center"
		},
		children: [
			!!n && /* @__PURE__ */ D(C, {
				sx: [
					Za[r].mobile.typography,
					...u === !0 ? [{ mx: 2 }] : [],
					{
						pb: 2,
						flexGrow: 2
					}
				],
				children: n
			}),
			i === !0 && (a === !0 ? /* @__PURE__ */ D(t, {
				onClick: o,
				sx: {
					marginRight: "16px",
					alignSelf: "center"
				},
				children: /* @__PURE__ */ D(A, { iconName: "expandLess" })
			}) : /* @__PURE__ */ D(t, {
				onClick: o,
				sx: {
					marginRight: "16px",
					alignSelf: "center"
				},
				children: /* @__PURE__ */ D(A, { iconName: "expandMore" })
			})),
			s != null && s
		]
	}), e]
}), to = ({ children: e, title: n, expandIcon: r, openMenu: i, onClickEvent: a, variant: o = "main", actionComponent: s, firstSection: c, sx: l, titleGutters: u, ...d }) => /* @__PURE__ */ O(t, {
	...d,
	sx: [
		Za[o].desktop.box,
		c === !0 ? { mt: 0 } : null,
		...$a(l)
	],
	children: [/* @__PURE__ */ O(t, {
		sx: {
			display: "flex",
			flexDirection: "row",
			alignItems: "center"
		},
		children: [
			!!n && /* @__PURE__ */ D(C, {
				sx: [Za[o].desktop.typography, { flexGrow: 2 }],
				children: n
			}),
			r === !0 && (i === !0 ? /* @__PURE__ */ D(t, {
				onClick: a,
				sx: { alignSelf: "flex-end" },
				children: /* @__PURE__ */ D(A, { iconName: "expandLess" })
			}) : /* @__PURE__ */ D(t, {
				onClick: a,
				sx: { alignSelf: "flex-end" },
				children: /* @__PURE__ */ D(A, { iconName: "expandMore" })
			})),
			s != null && s
		]
	}), e]
}), no = (e) => {
	let t = ve();
	return _e(t.breakpoints.down("md")) ? eo(e) : to(e);
}, ro = (e) => `calc(var(--vh, 1vh) * ${e});`, io = ro(100), ao = ({ children: e }) => /* @__PURE__ */ O(t, {
	sx: {
		display: "flex",
		flexDirection: "column",
		height: io
	},
	children: [/* @__PURE__ */ D(Ja, {
		position: "static",
		children: /* @__PURE__ */ D(ce, {
			sx: { padding: "0px 16px" },
			children: /* @__PURE__ */ D("img", {
				alt: "app-bar-logo",
				src: "/img/esa_logo.svg",
				height: "56px"
			})
		})
	}), /* @__PURE__ */ D(t, {
		sx: {
			flexGrow: 1,
			display: "flex",
			overflow: "hidden"
		},
		children: e
	})]
}), oo = ({ children: e }) => /* @__PURE__ */ O(o, {
	sx: {
		height: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	children: [/* @__PURE__ */ D(t, {
		component: "img",
		src: "/img/loading_icon.gif",
		alt: "loading",
		sx: { mixBlendMode: "multiply" }
	}), e]
}), so = ge(t)(({ theme: e }) => ({
	[e.breakpoints.up("xs")]: { padding: e.spacing(3) },
	[e.breakpoints.up("md")]: {
		padding: e.spacing(5),
		minWidth: "800px"
	},
	background: e.palette.background.paper,
	boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.04), 0px 0px 24px rgba(0, 0, 0, 0.04)",
	display: "flex",
	flexDirection: "column",
	borderRadius: "8px"
})), co = ({ label: e = "", stepLabels: n, step: r, hiddenLogo: i = !1 }) => {
	let a = ve(), o = _e(a.breakpoints.down("md"));
	return /* @__PURE__ */ O(t, {
		sx: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "center"
		},
		children: [
			i ? /* @__PURE__ */ D(t, {}) : /* @__PURE__ */ D(t, {
				sx: {
					mb: 2,
					width: "100%",
					maxWidth: 280
				},
				children: /* @__PURE__ */ D("img", {
					alt: "logo",
					style: { width: "100%" },
					src: "/img/esa_logo.svg"
				})
			}),
			e.length !== 0 && /* @__PURE__ */ D(C, {
				variant: "h5",
				sx: { mb: 5 },
				children: e
			}),
			/* @__PURE__ */ D(t, {
				sx: { mb: o ? 3 : 5 },
				children: /* @__PURE__ */ D(ie, {
					activeStep: r,
					alternativeLabel: !0,
					sx: { width: o ? 320 : 560 },
					children: n.map((e) => /* @__PURE__ */ D(ne, { children: /* @__PURE__ */ D(re, {
						sx: {
							whiteSpace: "nowrap",
							[`& .${he.root}.${he.active}`]: { color: a.palette.info.main },
							[`& .${he.root}.${he.completed}`]: { color: a.palette.info.main }
						},
						children: o ? "" : e
					}) }, e))
				})
			})
		]
	});
}, lo = Object.prototype.hasOwnProperty;
function uo(e, t, n) {
	for (n of e.keys()) if (fo(n, t)) return n;
}
function fo(e, t) {
	var n, r, i;
	if (e === t) return !0;
	if (e && t && (n = e.constructor) === t.constructor) {
		if (n === Date) return e.getTime() === t.getTime();
		if (n === RegExp) return e.toString() === t.toString();
		if (n === Array) {
			if ((r = e.length) === t.length) for (; r-- && fo(e[r], t[r]););
			return r === -1;
		}
		if (n === Set) {
			if (e.size !== t.size) return !1;
			for (r of e) if (i = r, i && typeof i == "object" && (i = uo(t, i), !i) || !t.has(i)) return !1;
			return !0;
		}
		if (n === Map) {
			if (e.size !== t.size) return !1;
			for (r of e) if (i = r[0], i && typeof i == "object" && (i = uo(t, i), !i) || !fo(r[1], t.get(i))) return !1;
			return !0;
		}
		if (n === ArrayBuffer) e = new Uint8Array(e), t = new Uint8Array(t);
		else if (n === DataView) {
			if ((r = e.byteLength) === t.byteLength) for (; r-- && e.getInt8(r) === t.getInt8(r););
			return r === -1;
		}
		if (ArrayBuffer.isView(e)) {
			if ((r = e.byteLength) === t.byteLength) for (; r-- && e[r] === t[r];);
			return r === -1;
		}
		if (!n || typeof e == "object") {
			for (n in r = 0, e) if (lo.call(e, n) && ++r && !lo.call(t, n) || !(n in t) || !fo(e[n], t[n])) return !1;
			return Object.keys(t).length === r;
		}
	}
	return e !== e && t !== t;
}
//#endregion
//#region lib/components/Tables/TablePagination.tsx
var po = ({ from: e, to: t, count: n }) => `${e}-${t} 件目 / ${n}件`, mo = (e) => [
	10,
	25,
	50,
	100,
	{
		label: "全て",
		value: e
	}
], ho = E(({ count: e, page: t, setPage: n, perPage: r, setPerPage: i, labelRowsPerPage: a = "1ページあたりの行数：", rowsPerPageOptions: o = mo, labelDisplayedRows: s = po, sxprops: c }) => {
	let l = ve(), u = _e(l.breakpoints.down("md")) ? {
		".MuiTablePagination-toolbar": { flexWrap: "wrap" },
		...c
	} : { ...c };
	return /* @__PURE__ */ D(oe, {
		sx: u,
		rowsPerPageOptions: Array.isArray(o) ? o : o(e),
		count: e,
		rowsPerPage: r,
		page: t,
		labelDisplayedRows: s,
		labelRowsPerPage: a,
		onPageChange: (e, t) => {
			n(t);
		},
		onRowsPerPageChange: (e) => {
			i(Number(e.target.value));
		},
		component: "div"
	});
}, fo), go = ({ handleOnChange: e, placeholder: n = "検索", value: r, children: i }) => /* @__PURE__ */ O(t, {
	sx: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		mt: 2
	},
	children: [/* @__PURE__ */ D(ee, {
		elevation: 0,
		variant: "outlined",
		sx: {
			display: "flex",
			height: "45px",
			borderRadius: "6px",
			width: "100%"
		},
		children: /* @__PURE__ */ D(g, {
			placeholder: n,
			value: r,
			onChange: e,
			startAdornment: /* @__PURE__ */ D(h, {
				position: "start",
				children: /* @__PURE__ */ D(A, { iconName: "search" })
			}),
			inputProps: {},
			sx: {
				padding: 2,
				width: "100%"
			}
		})
	}), !!i && /* @__PURE__ */ D(t, {
		sx: {
			m: 1,
			display: "flex",
			alignItems: "center"
		},
		children: i
	})]
}), _o = ({ control: e, email: n, organizations: r, roles: i, onClickEmailChange: a = () => {}, onClickPasswordChange: o = () => {}, visibleEmailChange: s = !1, visiblePasswordChange: c = !1, disabled: l = !1, disabledRole: u = !1, disabledOrganization: d = !1, disabledEmailChange: f = !1, disabledPasswordChange: p = !1 }) => {
	let m = r.map((e) => ({
		label: e.name,
		organizationUid: e.organizationUid
	})), h = i.map((e) => ({
		label: e.name,
		roleUid: e.roleUid
	}));
	return /* @__PURE__ */ O(Te, { children: [
		/* @__PURE__ */ D(W, {
			label: "氏名",
			required: !0,
			firstRow: !0,
			children: /* @__PURE__ */ D(V, {
				control: e,
				name: "name",
				render: ({ field: e, fieldState: { error: t } }) => /* @__PURE__ */ D(Ea, {
					...e,
					variant: "outlined",
					error: !!t,
					helperText: t?.message,
					size: "small",
					sx: { maxWidth: "480px" },
					fullWidth: !0,
					disabled: l
				})
			})
		}),
		/* @__PURE__ */ D(W, {
			label: "公開名",
			children: /* @__PURE__ */ D(V, {
				control: e,
				name: "publicName",
				render: ({ field: e, fieldState: { error: t } }) => /* @__PURE__ */ D(Ea, {
					...e,
					variant: "outlined",
					error: !!t,
					helperText: t?.message,
					size: "small",
					sx: { maxWidth: "480px" },
					fullWidth: !0,
					disabled: l
				})
			})
		}),
		/* @__PURE__ */ O(W, {
			label: "メールアドレス (ID)",
			formDirection: "column",
			children: [/* @__PURE__ */ D(Ea, {
				variant: "outlined",
				disabled: !0,
				size: "small",
				sx: { maxWidth: "480px" },
				fullWidth: !0,
				value: n
			}), s && /* @__PURE__ */ D(t, { children: /* @__PURE__ */ D(Ot, {
				onClick: a,
				disabled: l || f,
				children: /* @__PURE__ */ D(C, {
					variant: "button",
					children: "メールアドレスを変更"
				})
			}) })]
		}),
		c && /* @__PURE__ */ D(W, {
			label: "パスワード",
			children: /* @__PURE__ */ D(t, { children: /* @__PURE__ */ D(j, {
				type: "button",
				variant: "text",
				onClick: o,
				disabled: l || p,
				children: "パスワードを変更"
			}) })
		}),
		/* @__PURE__ */ D(Ma, {
			limitDenwaLists: 3,
			disabled: l
		}),
		/* @__PURE__ */ D(W, {
			label: "所属組織",
			required: !0,
			children: /* @__PURE__ */ O(t, {
				sx: { width: "100%" },
				children: [
					/* @__PURE__ */ D(Ra, {
						options: m,
						disabled: l || d
					}),
					/* @__PURE__ */ D(ka, {
						options: m,
						disabled: l || d
					}),
					/* @__PURE__ */ D(C, {
						variant: "body2",
						sx: { color: "text.secondary" },
						children: "デフォルトにしたい組織を設定してください"
					})
				]
			})
		}),
		/* @__PURE__ */ D(Ba, {
			options: h,
			disabled: l || u
		})
	] });
}, vo = ({ control: e, email: n, organizations: r, roles: i, onSubmit: a, onCancel: o, disabledSubmit: u, isSubmitting: d, open: f }) => /* @__PURE__ */ D(t, { children: /* @__PURE__ */ D(s, {
	fullWidth: !0,
	maxWidth: "md",
	open: f,
	children: /* @__PURE__ */ O("form", {
		onSubmit: (e) => void a(e),
		children: [
			/* @__PURE__ */ D(At, {
				onClose: o,
				disableCloseButton: d,
				children: "メンバー編集"
			}),
			/* @__PURE__ */ D(l, {
				sx: {
					display: "flex",
					flexDirection: "column",
					alignItems: "flex-start",
					padding: "16px 24px"
				},
				children: /* @__PURE__ */ D(_o, {
					control: e,
					email: n,
					organizations: r,
					roles: i
				})
			}),
			/* @__PURE__ */ O(c, { children: [/* @__PURE__ */ D(j, {
				type: "button",
				onClick: o,
				variant: "text",
				children: "キャンセル"
			}), /* @__PURE__ */ D(j, {
				type: "submit",
				disabled: u,
				variant: "contained",
				children: "登録"
			})] })
		]
	})
}) }), yo = ({ supportSiteLink: e, isCollaborator: t }) => t === !0 ? /* @__PURE__ */ D(C, { children: "管理会社からいい生活Square メッセージを受信したときに、メールでお知らせします。" }) : /* @__PURE__ */ O(Te, { children: [/* @__PURE__ */ D(C, { children: "いい生活Squareの取引先からのメッセージ受信時に、メールを送信します。" }), /* @__PURE__ */ O(C, { children: [
	"メッセージに関するご不明点は",
	/* @__PURE__ */ D(Et, {
		href: e,
		sx: { color: "white" },
		children: "サポートサイト"
	}),
	"をご確認ください。"
] })] }), bo = ({ messengerLink: e, isCollaborator: t }) => t === !0 ? null : /* @__PURE__ */ O(C, {
	variant: "body2",
	sx: { color: "text.secondary" },
	children: [
		"メッセージに関する設定は",
		/* @__PURE__ */ D(Et, {
			href: e,
			children: "Square設定"
		}),
		"をご確認ください。"
	]
}), xo = ({ disabled: e, control: n, supportSiteLink: r, messengerLink: i, isCollaborator: a }) => /* @__PURE__ */ D(Te, { children: /* @__PURE__ */ O(m, { children: [
	/* @__PURE__ */ D(t, {
		sx: {
			borderTop: 1,
			borderColor: "rgba(0, 0, 0, 0.12)"
		},
		children: /* @__PURE__ */ D(t, {
			sx: {
				mx: 2,
				mt: 2
			},
			children: /* @__PURE__ */ D(C, {
				variant: "body2",
				sx: {
					color: "rgba(0, 0, 0, 0.6)",
					mb: 2
				},
				children: "※「受信しない」設定でも、ご利用のアカウント、法的通知、プライバシーに関する問題についてメールを送信する場合があります。"
			})
		})
	}),
	/* @__PURE__ */ D(t, {
		sx: {
			borderTop: 1,
			borderColor: "rgba(0, 0, 0, 0.12)"
		},
		children: /* @__PURE__ */ O(t, {
			sx: {
				mx: 2,
				mt: 2
			},
			children: [
				/* @__PURE__ */ D(C, {
					variant: "body1",
					sx: {
						fontWeight: "bold",
						mb: 1
					},
					children: "登録情報の変更に関する内容"
				}),
				/* @__PURE__ */ D(Tt, {
					label: "いい生活アカウント",
					style: { marginBottom: 8 }
				}),
				/* @__PURE__ */ D(V, {
					name: "emailNotify.enabled",
					control: n,
					render: ({ field: t }) => /* @__PURE__ */ O(x, {
						row: !0,
						...t,
						onChange: (e) => {
							let n = e.target.value === "true";
							t.onChange(n);
						},
						sx: {
							gap: 1,
							mb: 1
						},
						children: [/* @__PURE__ */ D(f, {
							value: "true",
							control: /* @__PURE__ */ D(b, {}),
							label: "受信する",
							disabled: e,
							slotProps: { typography: { variant: "body2" } }
						}), /* @__PURE__ */ D(f, {
							value: "false",
							control: /* @__PURE__ */ D(b, {}),
							label: "受信しない",
							disabled: e,
							slotProps: { typography: { variant: "body2" } }
						})]
					})
				})
			]
		})
	}),
	/* @__PURE__ */ D(t, {
		sx: {
			borderTop: 1,
			borderColor: "rgba(0, 0, 0, 0.12)"
		},
		children: /* @__PURE__ */ O(t, {
			sx: {
				mx: 2,
				mt: 2
			},
			children: [
				/* @__PURE__ */ O(C, {
					variant: "body1",
					sx: {
						fontWeight: "bold",
						mb: 1
					},
					children: ["メッセージ受信通知", /* @__PURE__ */ D(le, {
						title: /* @__PURE__ */ D(yo, {
							supportSiteLink: r,
							isCollaborator: a
						}),
						children: /* @__PURE__ */ D("span", { children: /* @__PURE__ */ D(A, {
							iconName: "help",
							size: "small",
							color: "black"
						}) })
					})]
				}),
				/* @__PURE__ */ D(Tt, {
					label: "Square",
					style: { marginBottom: 8 }
				}),
				/* @__PURE__ */ D(V, {
					name: "emailNotify.enabledMessenger",
					control: n,
					render: ({ field: t }) => /* @__PURE__ */ O(x, {
						row: !0,
						...t,
						onChange: (e) => {
							let n = e.target.value === "true";
							t.onChange(n);
						},
						sx: { gap: 1 },
						children: [/* @__PURE__ */ D(f, {
							value: "true",
							control: /* @__PURE__ */ D(b, {}),
							label: "受信する",
							disabled: e,
							slotProps: { typography: { variant: "body2" } }
						}), /* @__PURE__ */ D(f, {
							value: "false",
							control: /* @__PURE__ */ D(b, {}),
							label: "受信しない",
							disabled: e,
							slotProps: { typography: { variant: "body2" } }
						})]
					})
				}),
				/* @__PURE__ */ D(bo, {
					messengerLink: i,
					isCollaborator: a
				})
			]
		})
	})
] }) }), So = ({ disabled: e, control: n, supportSiteLink: r, messengerLink: i, isCollaborator: a }) => /* @__PURE__ */ O(Te, { children: [
	/* @__PURE__ */ D(C, {
		variant: "body2",
		sx: { color: "rgba(0, 0, 0, 0.6)" },
		children: "※「受信しない」設定でも、ご利用のアカウント、法的通知、プライバシーに関する問題についてメールを送信する場合があります。"
	}),
	/* @__PURE__ */ D(W, {
		label: /* @__PURE__ */ O(t, { children: [/* @__PURE__ */ D(C, {
			variant: "body1",
			sx: { mb: 1 },
			children: "登録情報の変更に関する内容"
		}), /* @__PURE__ */ D(Tt, { label: "いい生活アカウント" })] }),
		labelProps: { component: !0 },
		componentProps: { sx: {
			display: "flex",
			alignItems: "center"
		} },
		firstRow: !0,
		children: /* @__PURE__ */ D(V, {
			name: "emailNotify.enabled",
			control: n,
			render: ({ field: t }) => /* @__PURE__ */ O(x, {
				row: !0,
				...t,
				onChange: (e) => {
					let n = e.target.value === "true";
					t.onChange(n);
				},
				sx: { gap: 1 },
				children: [/* @__PURE__ */ D(f, {
					value: "true",
					control: /* @__PURE__ */ D(b, {}),
					label: "受信する",
					disabled: e,
					slotProps: { typography: { variant: "body2" } }
				}), /* @__PURE__ */ D(f, {
					value: "false",
					control: /* @__PURE__ */ D(b, {}),
					label: "受信しない",
					disabled: e,
					slotProps: { typography: { variant: "body2" } }
				})]
			})
		})
	}),
	/* @__PURE__ */ D(W, {
		label: /* @__PURE__ */ D(t, {
			sx: { display: "flex" },
			children: /* @__PURE__ */ O(t, {
				sx: {
					display: "flex",
					flexDirection: "column"
				},
				children: [/* @__PURE__ */ O(t, {
					sx: {
						display: "flex",
						flexDirection: "row"
					},
					children: [/* @__PURE__ */ D(C, {
						variant: "body1",
						sx: { mb: 1 },
						children: "メッセージ受信通知"
					}), /* @__PURE__ */ D(le, {
						title: /* @__PURE__ */ D(yo, {
							supportSiteLink: r,
							isCollaborator: a
						}),
						children: /* @__PURE__ */ D("span", { children: /* @__PURE__ */ D(A, {
							iconName: "help",
							size: "small",
							color: "black"
						}) })
					})]
				}), /* @__PURE__ */ D(Tt, { label: "Square" })]
			})
		}),
		labelProps: { component: !0 },
		children: /* @__PURE__ */ O(t, {
			sx: {
				display: "flex",
				flexDirection: "column"
			},
			children: [/* @__PURE__ */ D(V, {
				name: "emailNotify.enabledMessenger",
				control: n,
				render: ({ field: t }) => /* @__PURE__ */ O(x, {
					row: !0,
					...t,
					onChange: (e) => {
						let n = e.target.value === "true";
						t.onChange(n);
					},
					sx: { gap: 1 },
					children: [/* @__PURE__ */ D(f, {
						value: "true",
						control: /* @__PURE__ */ D(b, {}),
						label: "受信する",
						disabled: e,
						slotProps: { typography: { variant: "body2" } }
					}), /* @__PURE__ */ D(f, {
						value: "false",
						control: /* @__PURE__ */ D(b, {}),
						label: "受信しない",
						disabled: e,
						slotProps: { typography: { variant: "body2" } }
					})]
				})
			}), /* @__PURE__ */ D(bo, {
				messengerLink: i,
				isCollaborator: a
			})]
		})
	})
] }), Co = E((e) => {
	let t = ve(), n = _e(t.breakpoints.down("md")) ? xo(e) : So(e);
	return e.isDialog === !0 ? /* @__PURE__ */ O(Te, { children: [/* @__PURE__ */ D(C, {
		sx: {
			mt: 3,
			mb: 1,
			...Ta.bold,
			...Ta.mdlg
		},
		children: "メール通知"
	}), n] }) : /* @__PURE__ */ D(no, {
		variant: "sub",
		title: "メール通知",
		children: n
	});
}), wo = ({ type: e = "submit", loading: n, disabled: r }) => /* @__PURE__ */ D(t, {
	sx: {
		display: "flex",
		justifyContent: "flex-end",
		backgroundColor: "white",
		position: "fixed",
		bottom: 0,
		zIndex: 1e3,
		height: "54px",
		width: "100vw",
		textAlign: "center",
		boxShadow: "rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px"
	},
	children: /* @__PURE__ */ D(t, {
		sx: {
			mx: 1,
			my: 1
		},
		children: /* @__PURE__ */ D(j, {
			type: e,
			variant: "contained",
			isLoading: n,
			disabled: r,
			children: "変更を保存"
		})
	})
}), To = ({ type: e = "submit", loading: n, disabled: r }) => /* @__PURE__ */ D(t, {
	sx: {
		display: "flex",
		justifyContent: "flex-end",
		backgroundColor: "white",
		position: "fixed",
		bottom: 0,
		zIndex: 1e3,
		height: "54px",
		width: "100%",
		right: "0",
		textAlign: "center",
		boxShadow: "rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px"
	},
	children: /* @__PURE__ */ D(t, {
		sx: {
			mx: 1,
			my: 1
		},
		children: /* @__PURE__ */ D(j, {
			type: e,
			variant: "contained",
			isLoading: n,
			disabled: r,
			children: "変更を保存"
		})
	})
}), Eo = E((e) => {
	let t = ve();
	return _e(t.breakpoints.down("md")) ? wo(e) : To(e);
}), Do = ({ ipAddressList: e, clientIp: n }) => {
	if (n == null) return null;
	let r = [];
	return Ie(e, n) && r.push({
		severity: "warning",
		message: `ご利用中のIPアドレス（${n}）はIPアドレス制限の対象になります`
	}), e.forEach((e) => {
		Le(e) && r.push({
			severity: "error",
			message: `ローカルIPが設定されています（${e}）`
		});
	}), r.length === 0 ? null : /* @__PURE__ */ D(t, {
		sx: {
			pt: 1,
			maxWidth: "480px"
		},
		children: r.map(({ severity: e, message: n }) => /* @__PURE__ */ D(t, {
			sx: { pb: 1 },
			children: /* @__PURE__ */ D(st, {
				color: e,
				children: /* @__PURE__ */ D("div", { children: n })
			})
		}, n))
	});
}, Oo = E(({ disabled: e, clientIp: n, control: r, isDialog: i }) => {
	let a = fn({
		control: r,
		name: "ipAddressList"
	}), o = /* @__PURE__ */ D(W, {
		label: "許可するIPアドレス",
		firstRow: !0,
		children: /* @__PURE__ */ O(t, {
			sx: { width: "100%" },
			children: [
				/* @__PURE__ */ D(V, {
					name: "ipAddressList",
					control: r,
					render: (t) => /* @__PURE__ */ D(Da, {
						...t.field,
						multiple: !0,
						freeSolo: !0,
						autoSelect: !0,
						options: [],
						onChange: (e, n) => {
							t.field.onChange(n);
						},
						disabled: e,
						error: t.fieldState.error,
						helperText: ts(t.fieldState.error),
						sx: { maxWidth: "480px" },
						fullWidth: !0,
						placeholder: "許可するIPアドレス"
					})
				}),
				/* @__PURE__ */ D(Do, {
					clientIp: n,
					ipAddressList: a || []
				}),
				/* @__PURE__ */ D(C, {
					variant: "body2",
					sx: { color: "text.secondary" },
					children: "※IP アドレス制限は管理者の操作でのみ変更できます"
				})
			]
		})
	});
	return i === !0 ? /* @__PURE__ */ O(Te, { children: [/* @__PURE__ */ D(C, {
		sx: {
			mt: 3,
			...Ta.bold,
			...Ta.mdlg
		},
		children: "IPアドレス制限"
	}), o] }) : /* @__PURE__ */ D(no, {
		variant: "sub",
		title: "IPアドレス制限",
		children: o
	});
}), ko = (e) => e ? "再度この会社に所属するには、会社の管理者からの招待が必要です。" : "メンバーから脱退することで、新たに「会社所属リクエスト」や「会社の新規登録」ができます。", Ao = ({ onClickUserDelete: e, disabled: t, isCollaborator: n }) => {
	let [r, i] = we(!1);
	return /* @__PURE__ */ D(no, {
		variant: "sub",
		title: "その他のオプション",
		expandIcon: !0,
		openMenu: r,
		onClickEvent: () => i((e) => !e),
		children: /* @__PURE__ */ D(a, {
			in: r,
			timeout: "auto",
			children: /* @__PURE__ */ D(m, {
				sx: { mt: 2 },
				children: /* @__PURE__ */ D(m, {
					container: !0,
					sx: {
						mt: 2,
						mb: 2,
						display: "flex",
						flexDirection: "row"
					},
					children: /* @__PURE__ */ O(m, {
						size: 7,
						sx: { mr: 4 },
						children: [
							/* @__PURE__ */ D(C, {
								variant: "body2",
								sx: { mb: 1 },
								children: "会社メンバーからの脱退"
							}),
							/* @__PURE__ */ O(C, {
								variant: "caption",
								component: "p",
								sx: {
									color: "rgba(0, 0, 0, 0.6)",
									mb: 2
								},
								children: [
									"脱退した会社の情報や連携しているサービスの情報は閲覧・操作ができなくなります。",
									/* @__PURE__ */ D("br", {}),
									ko(n)
								]
							}),
							/* @__PURE__ */ D(j, {
								type: "button",
								variant: "contained",
								color: "error",
								onClick: e,
								disabled: t,
								children: "脱退する"
							})
						]
					})
				})
			})
		})
	});
}, jo = ({ onClickUserDelete: e, disabled: t, isCollaborator: n }) => {
	let [r, i] = we(!1);
	return /* @__PURE__ */ D(no, {
		variant: "sub",
		title: "その他のオプション",
		expandIcon: !0,
		openMenu: r,
		onClickEvent: () => i((e) => !e),
		children: /* @__PURE__ */ D(a, {
			in: r,
			timeout: "auto",
			children: /* @__PURE__ */ D(m, {
				sx: { mx: 2 },
				children: /* @__PURE__ */ D(m, {
					container: !0,
					sx: {
						mb: 2,
						display: "flex",
						flexDirection: "row"
					},
					children: /* @__PURE__ */ O(m, { children: [/* @__PURE__ */ O(C, {
						variant: "caption",
						component: "p",
						sx: {
							color: "rgba(0, 0, 0, 0.6)",
							mb: 2
						},
						children: [
							"脱退した会社の情報や連携しているサービスの情報は閲覧・操作ができなくなります。",
							/* @__PURE__ */ D("br", {}),
							ko(n)
						]
					}), /* @__PURE__ */ D(j, {
						type: "button",
						variant: "contained",
						color: "error",
						onClick: e,
						disabled: t,
						children: "脱退する"
					})] })
				})
			})
		})
	});
}, Mo = E((e) => {
	let t = ve();
	return _e(t.breakpoints.down("md")) ? jo(e) : Ao(e);
}), No = {
	GoogleAuthenticator: "https://support.google.com/accounts/answer/1066447",
	MicrosoftAuthenticator: "https://www.microsoft.com/ja-jp/security/mobile-authenticator-app"
}, Po = (e, t) => e === "registered" ? `デバイスが登録されているため多要素認証が要求されます（一時無効化は ${Ne(t)} まで）` : e === "none" ? `${Ne(t)} まで無効化中` : `${Ne(t)} まで一時無効化を設定済み`, Fo = ({ authenticatorState: e, mfaExemptedUntil: n, onClickMfaExemption: r, onClickReleaseMfaExemption: i, disabledMfaExemption: a, disabledReleaseMfaExemption: o }) => Re(n) ? /* @__PURE__ */ O(t, {
	sx: {
		display: "flex",
		flexDirection: "column",
		gap: 1
	},
	children: [/* @__PURE__ */ D(C, {
		variant: "body1",
		children: Po(e, n)
	}), /* @__PURE__ */ D(t, { children: /* @__PURE__ */ D(j, {
		type: "button",
		variant: "outlined",
		color: "error",
		disabled: o,
		onClick: i,
		children: "無効化を解除する"
	}) })]
}) : /* @__PURE__ */ D(t, { children: /* @__PURE__ */ D(j, {
	type: "button",
	variant: "outlined",
	disabled: a,
	onClick: r,
	children: "無効化する"
}) }), Io = ({ children: e }) => /* @__PURE__ */ D(C, {
	variant: "caption",
	component: "p",
	sx: {
		color: "rgba(0, 0, 0, 0.6)",
		mt: 2
	},
	children: e
}), Lo = () => /* @__PURE__ */ D(C, {
	variant: "caption",
	sx: { color: "rgba(0, 0, 0, 0.6)" },
	children: "このメンバーの多要素認証の必須状態を72時間無効化します。無効化されている間、このメンバーはパスワードだけでログインできます。端末の故障・紛失などの一時対応にご利用ください。"
}), Ro = ({ totpEnrollmentState: e, totpEnrollment: n, onClickAuthenticationMethodsDelete: r, disabledAuthenticationMethodsDelete: i, totpUnavailableNote: a }) => /* @__PURE__ */ O(W, {
	label: "ワンタイムパスワード",
	firstRow: !0,
	componentProps: { disableFlex: !0 },
	children: [e.kind === "enrolled" ? /* @__PURE__ */ O(t, {
		sx: {
			display: "flex",
			flexWrap: "wrap",
			alignItems: "center",
			gap: 2
		},
		children: [/* @__PURE__ */ O(t, {
			sx: {
				display: "flex",
				flexDirection: "row"
			},
			children: [/* @__PURE__ */ D(C, {
				variant: "body1",
				children: "デバイス登録済"
			}), /* @__PURE__ */ O(C, {
				variant: "body1",
				sx: { color: "text.secondary" },
				children: [
					"（",
					Ne(e.enrolledAt),
					"）"
				]
			})]
		}), /* @__PURE__ */ D(j, {
			type: "button",
			variant: "outlined",
			color: "error",
			disabled: i,
			onClick: r,
			children: "削除する"
		})]
	}) : /* @__PURE__ */ O(t, {
		sx: {
			display: "flex",
			flexDirection: {
				xs: "column",
				md: "row"
			},
			flexWrap: "wrap",
			alignItems: {
				xs: "flex-start",
				md: "center"
			},
			gap: 2
		},
		children: [/* @__PURE__ */ D(C, {
			variant: "body1",
			children: e.kind === "notEnrolled" ? "デバイス未登録" : "不明"
		}), n && /* @__PURE__ */ D(j, {
			type: "button",
			variant: "outlined",
			disabled: n.disabled || e.kind !== "notEnrolled",
			onClick: n.onClick,
			children: "設定する"
		})]
	}), a == null ? /* @__PURE__ */ D(t, {
		sx: { pt: 1 },
		children: /* @__PURE__ */ O(C, {
			variant: "caption",
			sx: { color: "rgba(0, 0, 0, 0.6)" },
			children: [
				"パスワードとは別に確認コードの入力を求めることで、セキュリティを強化します。",
				/* @__PURE__ */ D("br", {}),
				"設定には",
				/* @__PURE__ */ D(v, {
					target: "_blank",
					rel: "noopener noreferrer",
					href: No.GoogleAuthenticator,
					sx: { display: "inline-flex" },
					children: "Google Authenticator"
				}),
				",",
				" ",
				/* @__PURE__ */ D(v, {
					target: "_blank",
					rel: "noopener noreferrer",
					href: No.MicrosoftAuthenticator,
					sx: { display: "inline-flex" },
					children: "Microsoft Authenticator"
				}),
				"等の認証アプリが必要です。"
			]
		})
	}) : /* @__PURE__ */ D(Io, { children: a })]
}), zo = ({ firstRow: e, authenticatorState: n, mfaExemptedUntil: r, onClickMfaExemption: i, onClickReleaseMfaExemption: a, disabledMfaExemption: o, disabledReleaseMfaExemption: s }) => /* @__PURE__ */ O(W, {
	label: "一時無効化",
	firstRow: e,
	componentProps: { disableFlex: !0 },
	children: [/* @__PURE__ */ D(Fo, {
		authenticatorState: n,
		mfaExemptedUntil: r,
		onClickMfaExemption: i,
		onClickReleaseMfaExemption: a,
		disabledMfaExemption: o,
		disabledReleaseMfaExemption: s
	}), /* @__PURE__ */ D(t, {
		sx: { pt: 1 },
		children: /* @__PURE__ */ D(Lo, {})
	})]
}), Bo = (e) => {
	let { showTotpRow: t = !0, passkeyRow: n, showMfaExemption: r } = e;
	return !t && n == null && r !== !0 ? null : /* @__PURE__ */ O(Te, { children: [
		t && Ro(e),
		n != null && /* @__PURE__ */ D(W, {
			label: "パスキー",
			firstRow: !t,
			componentProps: { disableFlex: !0 },
			children: n
		}),
		r === !0 && zo({
			...e,
			firstRow: !t && n == null
		})
	] });
}, Vo = ({ supportSiteLink: e }) => /* @__PURE__ */ O(C, {
	variant: "body2",
	component: "p",
	sx: {
		color: "rgba(0, 0, 0, 0.6)",
		mb: {
			xs: 2,
			md: 0
		}
	},
	children: [
		"多要素認証に関するご不明点は",
		/* @__PURE__ */ D(Et, {
			href: e,
			children: "サポートサイト"
		}),
		"をご確認ください"
	]
}), Ho = E((e) => {
	let n = Bo(e);
	return n == null ? null : e.isDialog === !0 ? /* @__PURE__ */ O(Te, { children: [
		/* @__PURE__ */ D(C, {
			sx: {
				mt: 3,
				mb: 1,
				...Ta.bold,
				...Ta.mdlg
			},
			children: "多要素認証"
		}),
		/* @__PURE__ */ D(Vo, { supportSiteLink: e.supportSiteLink }),
		n
	] }) : /* @__PURE__ */ O(no, {
		variant: "sub",
		title: "多要素認証",
		children: [/* @__PURE__ */ D(t, {
			sx: { mx: {
				xs: 2,
				md: 0
			} },
			children: /* @__PURE__ */ D(Vo, { supportSiteLink: e.supportSiteLink })
		}), n]
	});
}), Uo = ({ isLoading: e, error: t, authenticationMethods: n }) => {
	if (e) return { kind: "loading" };
	if (t != null) return { kind: "error" };
	let r = n.authenticationMethods.filter(({ type: e }) => e === ke).length;
	return r > 0 ? {
		kind: "enrolled",
		count: r
	} : { kind: "notEnrolled" };
}, Wo = {
	loading: "不明",
	error: "不明",
	notEnrolled: "未登録"
}, Go = ({ state: e }) => e.kind === "enrolled" ? /* @__PURE__ */ O(t, {
	sx: {
		display: "flex",
		flexDirection: "row"
	},
	children: [/* @__PURE__ */ D(C, {
		variant: "body1",
		children: "登録済"
	}), /* @__PURE__ */ O(C, {
		variant: "body1",
		sx: { color: "text.secondary" },
		children: [
			"（",
			e.count,
			"件）"
		]
	})]
}) : /* @__PURE__ */ D(C, {
	variant: "body1",
	children: Wo[e.kind]
}), Ko = ({ passkey: e, isDeleting: n, canDelete: r, onClickPasskeyDelete: i }) => {
	let a = `（登録日時 ${Ne(e.enrolledAt)}）`, o = e.authenticator.kind === "identified" ? `${e.authenticator.name}${a}` : a, s = e.authenticator.kind === "identified" ? `${e.deviceLabel} ${o}` : `${e.deviceLabel}${o}`;
	return /* @__PURE__ */ O(t, {
		component: "li",
		sx: {
			display: "flex",
			alignItems: "center",
			gap: 2,
			py: 1,
			borderBottom: 1,
			borderColor: "rgba(0, 0, 0, 0.12)"
		},
		children: [/* @__PURE__ */ O(t, {
			sx: { flexGrow: 1 },
			children: [/* @__PURE__ */ D(C, {
				variant: "body1",
				children: e.deviceLabel
			}), /* @__PURE__ */ D(C, {
				variant: "body2",
				sx: { color: "text.secondary" },
				children: o
			})]
		}), /* @__PURE__ */ D(j, {
			type: "button",
			variant: "outlined",
			color: "error",
			disabled: !r,
			isLoading: n,
			onClick: () => i(e),
			"aria-label": `${s}を削除する`,
			children: "削除する"
		})]
	});
}, qo = ({ state: e, onClickPasskeyDelete: n }) => e.status === "loading" ? /* @__PURE__ */ D(oo, {}) : e.passkeys.length === 0 ? /* @__PURE__ */ D(u, {
	sx: { pt: 2.5 },
	children: "登録済みのパスキーはありません。"
}) : /* @__PURE__ */ D(t, {
	component: "ul",
	role: "list",
	"aria-label": "登録済みのパスキーの一覧",
	sx: {
		listStyle: "none",
		m: 0,
		p: 0
	},
	children: e.passkeys.map((t) => /* @__PURE__ */ D(Ko, {
		passkey: t,
		isDeleting: e.status === "deleting" && e.authMethodId === t.authMethodId,
		canDelete: e.status !== "deleting",
		onClickPasskeyDelete: n
	}, t.authMethodId))
}), Jo = E(({ open: e, state: t, onClickPasskeyDelete: n, onClose: r }) => /* @__PURE__ */ O(s, {
	open: e,
	fullWidth: !0,
	maxWidth: "sm",
	children: [
		/* @__PURE__ */ D(At, {
			onClose: r,
			disableCloseButton: t.status === "deleting",
			children: "登録済みのパスキー"
		}),
		/* @__PURE__ */ D(l, {
			"aria-live": "polite",
			"aria-busy": t.status === "loading",
			children: /* @__PURE__ */ D(qo, {
				state: t,
				onClickPasskeyDelete: n
			})
		}),
		/* @__PURE__ */ D(c, { children: /* @__PURE__ */ D(j, {
			type: "button",
			variant: "text",
			color: "primary",
			disabled: t.status === "deleting",
			onClick: r,
			children: "閉じる"
		}) })
	]
})), Yo = (e) => {
	let t = `登録日時 ${Ne(e.enrolledAt)}`;
	return e.authenticator.kind === "identified" ? `${e.authenticator.name}、${t}` : t;
}, Xo = ({ open: e, passkey: n, isSubmitting: r, handleClose: i, handleSubmit: a }) => /* @__PURE__ */ O(s, {
	open: e,
	fullWidth: !0,
	maxWidth: "sm",
	children: [
		/* @__PURE__ */ D(At, {
			onClose: i,
			disableCloseButton: r,
			children: "パスキーの削除"
		}),
		/* @__PURE__ */ O(l, { children: [/* @__PURE__ */ D(t, {
			sx: { pt: 2 },
			children: /* @__PURE__ */ D(st, {
				color: "warning",
				children: /* @__PURE__ */ O(st.Content, { children: [
					"削除したパスキーではログインできなくなります。",
					/* @__PURE__ */ D("br", {}),
					"パスワードでのログインは引き続きご利用いただけます。"
				] })
			})
		}), /* @__PURE__ */ O(u, {
			sx: { pt: 2.5 },
			children: [
				"以下のパスキーを削除します。よろしいですか？",
				/* @__PURE__ */ D("br", {}),
				n.deviceLabel,
				"（",
				Yo(n),
				"）"
			]
		})] }),
		/* @__PURE__ */ O(c, { children: [/* @__PURE__ */ D(j, {
			type: "button",
			variant: "text",
			color: "primary",
			onClick: i,
			disabled: r,
			children: "キャンセル"
		}), /* @__PURE__ */ D(j, {
			type: "button",
			variant: "outlined",
			color: "error",
			onClick: a,
			isLoading: r,
			children: "削除する"
		})] })
	]
}), Zo = ({ open: e, loading: n, onClickCancel: r, onClickReject: i, memberApplicant: { userName: a, email: o } }) => /* @__PURE__ */ O(s, {
	open: e,
	children: [
		/* @__PURE__ */ D(At, {
			onClose: r,
			disableCloseButton: n,
			children: "リクエストの拒否"
		}),
		/* @__PURE__ */ O(l, {
			sx: {
				padding: "16px 24px",
				marginTop: "16px",
				display: "flex",
				flexDirection: "column",
				rowGap: 2
			},
			children: [/* @__PURE__ */ D(t, { children: "以下メンバーの会社所属リクエストを拒否します。よろしいですか？" }), /* @__PURE__ */ O(t, { children: [
				"・ ",
				a,
				" （",
				o,
				"）"
			] })]
		}),
		/* @__PURE__ */ O(c, { children: [/* @__PURE__ */ D(j, {
			type: "button",
			variant: "text",
			onClick: r,
			disabled: n,
			children: "キャンセル"
		}), /* @__PURE__ */ D(j, {
			type: "button",
			color: "error",
			variant: "outlined",
			onClick: i,
			isLoading: n,
			children: "拒否する"
		})] })
	]
}), Qo = ({ open: t, loading: n, disabled: r, onClickCancel: i, onClickApprove: a, onChangeOrganization: o, onChangeRole: d, memberApplicant: { requestedOrganizationName: f, userName: p }, organization: m, organizations: h, role: g, roles: _ }) => /* @__PURE__ */ O(s, {
	open: t,
	children: [
		/* @__PURE__ */ D(At, {
			onClose: i,
			disableCloseButton: n,
			children: "会社所属リクエストの承認"
		}),
		/* @__PURE__ */ O(l, { children: [
			/* @__PURE__ */ O(u, { children: [
				"「",
				p,
				"」の会社所属リクエストを承認します"
			] }),
			/* @__PURE__ */ D(u, { children: "所属する組織を選択してください" }),
			/* @__PURE__ */ O(u, { children: ["申請者の希望する所属組織名: ", f] }),
			/* @__PURE__ */ D(e, {
				fullWidth: !0,
				value: m,
				options: h,
				getOptionLabel: (e) => e.name,
				isOptionEqualToValue: (e, t) => e.organizationUid === t.organizationUid,
				onChange: (e, t) => {
					t != null && o(t);
				},
				renderInput: (e) => /* @__PURE__ */ D(se, { ...e })
			}),
			/* @__PURE__ */ D(u, { children: "役割を選択してください" }),
			/* @__PURE__ */ D(e, {
				fullWidth: !0,
				value: g,
				options: _,
				getOptionLabel: (e) => e.name,
				isOptionEqualToValue: (e, t) => e.roleUid === t.roleUid,
				onChange: (e, t) => {
					t != null && d(t);
				},
				renderInput: (e) => /* @__PURE__ */ D(se, { ...e })
			}),
			/* @__PURE__ */ D(u, { children: "組織が存在しない場合は「組織」画面から追加できます" })
		] }),
		/* @__PURE__ */ O(c, { children: [/* @__PURE__ */ D(j, {
			type: "button",
			variant: "text",
			onClick: i,
			disabled: n,
			children: "キャンセル"
		}), /* @__PURE__ */ D(j, {
			type: "button",
			variant: "contained",
			onClick: a,
			disabled: r,
			isLoading: n,
			children: "承認する"
		})] })
	]
}), $o = "#52A0D6", es = de({
	palette: {
		background: {
			default: Ve[100],
			grey: "#F4F4F4"
		},
		primary: { main: "#035DAD" },
		secondary: {
			main: "#DEEBF4",
			light: "#F2F7FB"
		},
		info: { main: "#2196F3" },
		error: { main: "#F44336" },
		text: {
			primary: "rgba(0,0,0,0.87)",
			secondary: "rgba(0,0,0,0.60)",
			disabled: "rgba(0,0,0,0.38)"
		}
	},
	typography: {
		fontSize: 14,
		fontFamily: [
			"\"Hiragino Kaku Gothic ProN\"",
			"Meiryo",
			"sans-serif"
		].join(","),
		body1: { fontSize: 14 },
		body2: { fontSize: 12 }
	},
	components: {
		MuiTypography: { styleOverrides: { root: { overflowWrap: "break-word" } } },
		MuiTabs: { styleOverrides: { indicator: { backgroundColor: $o } } },
		MuiTab: { styleOverrides: { textColorInherit: { "&$selected": { color: $o } } } },
		MuiFormControlLabel: { styleOverrides: { label: { lineHeight: "1.3" } } },
		MuiButton: {
			defaultProps: { color: "primary" },
			styleOverrides: { root: {
				fontWeight: "bold",
				textTransform: "none"
			} }
		},
		MuiRadio: { defaultProps: { color: "primary" } },
		MuiCheckbox: { defaultProps: { color: "primary" } },
		MuiLink: { defaultProps: { underline: "hover" } },
		MuiDialog: { styleOverrides: { paper: { margin: "32px 24px" } } },
		MuiDialogTitle: { styleOverrides: { root: {
			display: "flex",
			borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
			borderRadius: "4px 4px 0px 0px",
			alignItems: "center",
			fontStyle: "normal",
			fontWeight: 700,
			fontSize: "16px",
			paddingTop: "12px",
			paddingBottom: "12px",
			height: "48px"
		} } },
		MuiDialogContentText: { defaultProps: { color: "text.primary" } },
		MuiDialogActions: { styleOverrides: { root: {
			padding: "8px 24px",
			WebkitBoxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12)"
		} } },
		MuiTable: { styleOverrides: { root: { border: "1px solid rgba(0, 0, 0, 0.12)" } } },
		MuiAlertTitle: { styleOverrides: { root: {
			fontWeight: 700,
			fontSize: "16px"
		} } }
	}
}), ts = (e) => {
	if (e) return Array.isArray(e) ? e.length > 0 ? e.find((e) => e != null)?.message : void 0 : e.message;
};
//#endregion
export { Io as AuthMethodUnavailableNote, Yr as BillingDestinationRows, kt as ConfirmationDialog, Gr as ControlledAutocompleteField, Wr as ControlledTextField, V as Controller, ka as DefaultOrganizationForm, oo as DefaultProgress, Ma as DenwaNumberForm, At as DialogTitleWithCloseButton, Nt as DiscardConfirmationDialog, Pt as DiscardConfirmationPrompt, Mt as DiscardEditDialog, Na as DomainDenwaNumberForm, Ha as EmailChangeDialog, Va as EmailForm, mn as ErrorMessage, Ja as EsAppBar, Da as EsAutocomplete, Aa as EsSelect, Ea as EsTextField, qa as EsaFrame, co as EsaStepper, He as EsaTextField, qn as FieldArray, ar as Form, Ka as FormGridContainer, Ga as FormGridRow, nr as FormProvider, W as FormRow, or as FormState, sr as FormStateSubscribe, Xa as FramedBlock, Ia as JushoForm, Ot as LinkButton, Qo as MemberApplicantApproveDialog, Zo as MemberApplicantRejectDialog, Wa as MfaEnrollmentDialog, Fo as MfaExemptionActions, Lo as MfaExemptionDescription, Dt as NoWrapTableCell, Et as OpenInNewLink, Pa as OrganizationDenwaNumberForm, Ra as OrganizationsForm, Go as PasskeyStateLabel, Ua as PasswordChangeDialog, Ba as RoleForm, no as Section, so as ShadowedPanel, ao as SimpleLayout, ho as TablePagination, go as TableSearchForm, vo as UserEditDialog, Co as UserEmailNotifyForm, _o as UserForm, Eo as UserFormSubmitButton, Oo as UserIpAddressForm, Ho as UserMfaEnrollmentForm, Mo as UserOtherOptionsForm, Xo as UserPasskeyDeleteDialog, Jo as UserPasskeyListDialog, Hr as Watch, wn as appendErrors, Br as createFormControl, ts as errorMessage, L as get, ro as getViewportHeight, z as set, Ta as textSx, es as theme, Uo as toPasskeyEnrollmentState, pn as useController, Kn as useFieldArray, Vr as useForm, tr as useFormContext, un as useFormState, jt as useIsMobile, fn as useWatch };

//# sourceMappingURL=esa-components.mjs.map